/* eslint-disable */
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import type { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
export type Esg_Category =
  | 'ENVIRONMENTAL'
  | 'GENERAL'
  | 'GOVERNANCE'
  | 'SOCIAL'
  | 'STANDARDS';

export type Esg_Subcategory =
  | 'BIODIVERSITY'
  | 'BRIBERY_AND_CORRUPTION'
  | 'BRSR'
  | 'CLIMATE_STABILITY'
  | 'COMPLIANCE'
  | 'CONSUMERS_AND_END_USERS'
  | 'CORPORATE_GOVERNANCE'
  | 'DATA_PRIVACY_AND_INFORMATION_SECURITY'
  | 'DIVERSITY_EQUITY_AND_INCLUSION'
  | 'E1'
  | 'E2'
  | 'E3'
  | 'E4'
  | 'E5'
  | 'ENERGY_INNOVATION'
  | 'ENGAGE'
  | 'ESRS'
  | 'ESRS2'
  | 'ETHICS_AND_INTEGRITY'
  | 'G1'
  | 'GENERAL'
  | 'GRI'
  | 'HEALTH_AND_SAFETY'
  | 'HUMAN_CAPITAL_MANAGEMENT'
  | 'HUMAN_RIGHTS_AND_MODERN_DAY_SLAVERY'
  | 'IFRS'
  | 'IFRS_S1_GENERAL_DISCLOSURES'
  | 'IFRS_S2_CLIMATE_CHANGE'
  | 'INFORMATION_SECURITY'
  | 'ISO_14001'
  | 'ISO_14001_TOPIC'
  | 'ISO_37001'
  | 'ISO_37001_TOPIC'
  | 'NATURAL_RESOURCES'
  | 'POLLUTION_CONTROL'
  | 'RISK_MANAGEMENT'
  | 'S1'
  | 'S2'
  | 'S3'
  | 'S4'
  | 'SASB'
  | 'SHARED'
  | 'SOCIAL_ACCOUNTABILITY'
  | 'SOCIETY'
  | 'SUPPLY_CHAIN_AND_PARTNER_MANAGEMENT'
  | 'SUSTAINABILITY_GOVERNANCE'
  | 'SUSTAINABLE_DEVELOPMENT'
  | 'TCFD'
  | 'TRANSPARENCY'
  | 'UNGPS'
  | 'VOLUME_1_APPAREL_ACCESSORIES_FOOTWEAR'
  | 'VOLUME_2_APPLIANCE_MANUFACTURING'
  | 'VOLUME_3_BUILDING_PRODUCTS_FURNISHINGS'
  | 'VOLUME_4_E_COMMERCE'
  | 'VOLUME_5_HOUSEHOLD_PERSONAL_PRODUCTS'
  | 'VOLUME_6_MULTILINE_SPECIALTY_RETAILERS_DISTRIBUTORS'
  | 'VOLUME_7_TOYS_SPORTING_GOODS'
  | 'VOLUME_8_COAL_OPERATIONS'
  | 'VOLUME_9_CONSTRUCTION_MATERIALS'
  | 'VOLUME_10_IRON_STEEL_PRODUCERS'
  | 'VOLUME_11_METALS_MINING'
  | 'VOLUME_12_OIL_GAS_EXPLORATION_PRODUCTION'
  | 'VOLUME_13_OIL_GAS_MIDSTREAM'
  | 'VOLUME_14_OIL_GAS_REFINING_MARKETING'
  | 'VOLUME_15_OIL_GAS_SERVICES'
  | 'VOLUME_16_AGRICULTURAL_PRODUCTS'
  | 'VOLUME_17_ALCOHOLIC_BEVERAGES'
  | 'VOLUME_18_FOOD_RETAILERS_DISTRIBUTORS'
  | 'VOLUME_19_MEAT_POULTRY_DAIRY'
  | 'VOLUME_20_NON_ALCOHOLIC_BEVERAGES'
  | 'VOLUME_21_PROCESSED_FOODS'
  | 'VOLUME_22_RESTAURANTS'
  | 'VOLUME_23_TOBACCO'
  | 'VOLUME_24_ASSET_MANAGEMENT_CUSTODY_ACTIVITIES'
  | 'VOLUME_25_COMMERCIAL_BANKS'
  | 'VOLUME_26_CONSUMER_FINANCE'
  | 'VOLUME_27_INSURANCE'
  | 'VOLUME_28_INVESTMENT_BANKING_BROKERAGE'
  | 'VOLUME_29_MORTGAGE_FINANCE'
  | 'VOLUME_30_SECURITY_COMMODITY_EXCHANGES'
  | 'VOLUME_31_BIOTECHNOLOGY_PHARMACEUTICALS'
  | 'VOLUME_32_DRUG_RETAILERS'
  | 'VOLUME_33_HEALTH_CARE_DELIVERY'
  | 'VOLUME_34_HEALTH_CARE_DISTRIBUTORS'
  | 'VOLUME_35_MANAGED_CARE'
  | 'VOLUME_36_MEDICAL_EQUIPMENT_SUPPLIES'
  | 'VOLUME_37_CASINOS_GAMING'
  | 'VOLUME_38_ELECTRIC_UTILITIES_POWER_GENERATORS'
  | 'VOLUME_39_ENGINEERING_CONSTRUCTION_SERVICES'
  | 'VOLUME_40_GAS_UTILITIES_DISTRIBUTORS'
  | 'VOLUME_41_HOME_BUILDERS'
  | 'VOLUME_42_FUEL_CELLS_INDUSTRIAL_BATTERIES'
  | 'VOLUME_43_REAL_ESTATE_SERVICES'
  | 'VOLUME_44_WASTE_MANAGEMENT'
  | 'VOLUME_45_WATER_UTILITIES_SERVICES'
  | 'VOLUME_46_BIOFUELS'
  | 'VOLUME_47_FORESTRY_MANAGEMENT'
  | 'VOLUME_48_FUEL_CELLS_INDUSTRIAL_BATTERIES'
  | 'VOLUME_49_PULP_PAPER_PRODUCTS'
  | 'VOLUME_50_SOLAR_TECHNOLOGY_PROJECT_DEVELOPERS'
  | 'VOLUME_51_WIND_TECHNOLOGY_PROJECT_DEVELOPERS'
  | 'VOLUME_52_AEROSPACE_DEFENCE'
  | 'VOLUME_53_CHEMICALS'
  | 'VOLUME_54_CONTAINERS_PACKAGING'
  | 'VOLUME_55_ELECTRICAL_ELECTRONIC_EQUIPMENT'
  | 'VOLUME_56_INDUSTRIAL_MACHINERY_GOODS'
  | 'VOLUME_57_ADVERTISING_MARKETING'
  | 'VOLUME_58_EDUCATION'
  | 'VOLUME_59_HOTELS_LODGING'
  | 'VOLUME_60_LEISURE_FACILITIES'
  | 'VOLUME_61_MEDIA_ENTERTAINMENT'
  | 'VOLUME_62_PROFESSIONAL_COMMERCIAL_SERVICES'
  | 'VOLUME_63_ELECTRONIC_MANUFACTURING_SERVICES_ORIGINAL_DESIGN_MANUFACTURING'
  | 'VOLUME_64_HARDWARE'
  | 'VOLUME_65_INTERNET_MEDIA_SERVICES'
  | 'VOLUME_66_SEMICONDUCTORS'
  | 'VOLUME_67_SOFTWARE_IT_SERVICES'
  | 'VOLUME_68_TELECOMMUNICATION_SERVICES'
  | 'VOLUME_69_AIR_FREIGHT_LOGISTICS'
  | 'VOLUME_70_AIRLINES'
  | 'VOLUME_71_AUTO_PARTS'
  | 'VOLUME_72_AUTOMOBILES'
  | 'VOLUME_73_CAR_RENTAL_LEASING'
  | 'VOLUME_74_CRUISE_LINES'
  | 'VOLUME_75_MARINE_TRANSPORTATION'
  | 'VOLUME_76_RAIL_TRANSPORTATION'
  | 'VOLUME_77_ROAD_TRANSPORTATION'
  | 'WASTE_MANAGEMENT'
  | 'WHISTLEBLOWING';

export type Esg_Year_Status =
  | 'ACTIVE'
  | 'CLOSED'
  | 'OPEN';

/** Represents the paging input. */
export type PagingInput = {
  /** Paginate after opaque cursor. */
  after?: unknown;
  /** Paginate before opaque cursor. */
  before?: unknown;
  /** Paginate first. */
  first?: number | null | undefined;
  /** Paginate last. */
  last?: number | null | undefined;
  /** Limit the number of records returned. */
  limit?: number | null | undefined;
  /** Offset to start returning records from. */
  offset?: number | null | undefined;
};

/** Input for filtering programs with available questions */
export type ProgramsListInput = {
  /** Access mode filter. By default will only resolve programmes that are enabled by user permissions. */
  accessMode?: Risk_Area_Access_Mode;
  /** Filter by category UUIDs (OR logic with riskAreaUuids) */
  categoryUuids?: Array<string> | null | undefined;
  /** Optional flag to include programmes with no frameworks */
  includeNoFramework?: boolean | null | undefined;
  /** Filter by specific risk area UUIDs (OR logic with categoryUuids) */
  riskAreaUuids?: Array<string> | null | undefined;
  /** Text search - filters by question text, header, navigation title, context */
  textSearch?: string | null | undefined;
};

/** Defines how access to risk areas is determined. */
export type Risk_Area_Access_Mode =
  /** Will only resolve Programs/Risk Areas enabled by user permissions. */
  | 'PERMISSION_ONLY'
  /** Will resolve Programs/Risk Areas enabled by user permissions and by tasks. */
  | 'TASK_AND_PERMISSION'
  /** Will only resolve Programs/Risk Areas enabled by user tasks. */
  | 'TASK_ONLY';

/** Sort Directions */
export type SortDirection =
  | 'ASC'
  | 'DESC';

/** Represents direction for target (ie. DECREASE, INCREASE, CONSTANT) */
export type Target_Direction =
  | 'CONSTANT'
  | 'DECREASE'
  | 'INCREASE';

/** Represents target point type (ie. OVERALL, YEARLY, RECURRING) */
export type Target_Point =
  | 'OVERALL'
  | 'RECURRING'
  | 'YEARLY';

/** Task assignment mode */
export type Task_Assignment_Mode =
  | 'ALL'
  | 'ASSIGNED_BY_ME'
  | 'ASSIGNED_TO_ME';

/** Task status */
export type Task_Status =
  | 'CLOSED'
  | 'IN_PROGRESS'
  | 'OPEN';

/** Task type */
export type Task_Type =
  | 'DISCLOSURE'
  | 'METRIC'
  | 'PROFILE'
  | 'SURVEY';

/** Represents pagination input for connection of Targets. */
export type TargetConnectionInput = {
  /** uuid of the metric */
  metricUuid?: string | null | undefined;
  /** filter by name or description (for search) */
  name?: string | null | undefined;
  /** Limit or page results. */
  paging?: PagingInput | null | undefined;
  /** Specify to sort results. */
  sorting?: Array<TargetSortInput> | null | undefined;
};

export type TargetSortFields =
  | 'BASE_YEAR'
  | 'DESCRIPTION'
  | 'NAME'
  | 'TARGET_YEAR';

export type TargetSortInput = {
  direction: SortDirection;
  field: TargetSortFields;
};

/** Represents pagination input for connection of tasks. */
export type TaskConnectionInput = {
  /** Narrows the result of pagination to given criteria. */
  filtering?: TaskFilterInput | null | undefined;
  /** Limit or page results. */
  paging?: PagingInput | null | undefined;
  /** Narrows the result of pagination to given search criteria. */
  searching?: TaskSearchInput | null | undefined;
  /** Specify to sort results. */
  sorting?: Array<TaskSortInput> | null | undefined;
};

/** Represents input for task pagination filter. */
export type TaskFilterInput = {
  /** Narrows the pagination result to the given assignees. */
  assignees?: Array<string> | null | undefined;
  /** Narrows the pagination result to the given assignment mode. */
  assignmentMode?: Task_Assignment_Mode | null | undefined;
  /** Narrows the pagination result to the given assignors. */
  assignors?: Array<string> | null | undefined;
  /** Optional input for 'max days offset' for due date filter in days. Rules: today + [maxDueDateOffset] >= due date. */
  maxDueDateOffset?: number | null | undefined;
  /** Optional input for 'min days offset' for due date filter in days. Rules: today + [minDueDateOffset] =< due date. Accepts negative integers. */
  minDueDateOffset?: number | null | undefined;
  /** Optional array of risk area uuids to scope results. */
  riskAreaUuids?: Array<string> | null | undefined;
  /** Narrows the pagination result to the given statuses. */
  statuses?: Array<Task_Status> | null | undefined;
  /** Narrows the pagination result to the given task types. */
  taskTypes?: Array<Task_Type> | null | undefined;
  /** UUID of reporting year. If not provided active year will be used */
  yearUuid?: string | null | undefined;
};

/** Represents input for task search. */
export type TaskSearchInput = {
  /** Narrows the pagination search result by assignee last name. */
  narrowByAssigneeLastName?: boolean | null | undefined;
  /** Narrows the pagination search result by assignee name. */
  narrowByAssigneeName?: boolean | null | undefined;
  /** Narrows the pagination search result by assignor last name. */
  narrowByAssignorLastName?: boolean | null | undefined;
  /** Narrows the pagination search result by assignor name. */
  narrowByAssignorName?: boolean | null | undefined;
  /** Narrows the pagination search result by task id. */
  narrowByTaskId?: boolean | null | undefined;
  /** Narrows the pagination search result by task title. */
  narrowByTaskTitle?: boolean | null | undefined;
  /** Narrows the pagination search result to the given keywords. */
  textQuery?: string | null | undefined;
};

export type TaskSortFields =
  | 'ASSIGNEE_NAME'
  | 'ASSIGNOR_NAME'
  | 'DATE_CREATED'
  | 'DUE_DATE'
  | 'RISK_AREA'
  | 'STAGE'
  | 'STATUS'
  | 'TASK_ID'
  | 'TITLE'
  | 'TYPE';

export type TaskSortInput = {
  direction: SortDirection;
  field: TaskSortFields;
};

export type TargetsCardQueryVariables = Exact<{
  input?: TargetConnectionInput | null | undefined;
}>;


export type TargetsCardQuery = { targetList: { totalCount: number, edges: Array<{ node: { uuid: string, baseYear: number, direction: Target_Direction, name: string, points: Target_Point, targetYear: number, metric: { uuid: string }, targetData: Array<{ currentValue: number, isBaseYear: boolean, predictedValue: number, targetValue: number, unit: string | null, year: number }> | null } }> } };

export type TaskCardBaseFragment = { uuid: string, id: string, dueDate: Date, isNew: boolean, status: Task_Status, title: string, type: Task_Type };

export type TasksCardQueryVariables = Exact<{
  completedInput?: TaskConnectionInput | null | undefined;
  inProgressInput?: TaskConnectionInput | null | undefined;
  notStartedInput?: TaskConnectionInput | null | undefined;
}>;


export type TasksCardQuery = { completedTasks: { nodes: Array<{ uuid: string, id: string, dueDate: Date, isNew: boolean, status: Task_Status, title: string, type: Task_Type }>, statistics: { closedCount: number, newCount: number, totalCount: number } | null }, inProgressTasks: { nodes: Array<{ uuid: string, id: string, dueDate: Date, isNew: boolean, status: Task_Status, title: string, type: Task_Type }>, statistics: { newCount: number, overdueCount: number, totalCount: number, upcomingCount: number } | null }, notStartedTasks: { nodes: Array<{ uuid: string, id: string, dueDate: Date, isNew: boolean, status: Task_Status, title: string, type: Task_Type }>, statistics: { newCount: number, overdueCount: number, totalCount: number, upcomingCount: number } | null } };

export type DashboardStatisticsQueryVariables = Exact<{
  hasDisclosureAccess: boolean;
  hasIncidentsAccess: boolean;
  hasSurveyAccess: boolean;
}>;


export type DashboardStatisticsQuery = { collectStatistics?: { statistics: { approvedCount: number | null, disclosuresCount: number | null, newAnswersCount: number | null, responsesCount: number | null } | null }, incidentsStatistics?: { statistics: { closedCount: number, longInactiveCount: number, openedCount: number, totalCount: number } }, surveyStatistics?: { statistics: { completedCount: number, ongoingCount: number, scheduledCount: number } | null } };

export type EsgStatisticsQueryVariables = Exact<{
  includeDisabledRiskAreas?: boolean | null | undefined;
  input: ProgramsListInput;
}>;


export type EsgStatisticsQuery = { programsList: Array<{ uuid: string, name: string, category: { uuid: string, name: Esg_Category }, riskAreas: Array<{ uuid: string, color: unknown, customLabel: string | null, name: Esg_Subcategory, path: string, statistics: { answeredQuestions: number, totalQuestions: number } | null, steps: Array<{ id: string, questions: Array<{ uuid: string }> }> }> }> };

export type SessionPayloadFragment = { refreshToken: string | null, sessionToken: string };

export type WebflowPostBaseFragment = { category: string | null, description: string | null, title: string | null, url: string | null };

export type RefreshSessionMutationVariables = Exact<{
  token: string;
}>;


export type RefreshSessionMutation = { refreshSession: { refreshToken: string | null, sessionToken: string } };

export type YearsQueryVariables = Exact<{ [key: string]: never; }>;


export type YearsQuery = { years: { nodes: Array<{ uuid: string, status: Esg_Year_Status, year: number }> } | null };

export type CarbonLensInitializeSsoMutationVariables = Exact<{ [key: string]: never; }>;


export type CarbonLensInitializeSsoMutation = { url: string };

export type WebflowQueryVariables = Exact<{ [key: string]: never; }>;


export type WebflowQuery = { webflow: { esgArticles: { nodes: Array<{ category: string | null, description: string | null, title: string | null, url: string | null }> }, feed: { nodes: Array<{ category: string | null, description: string | null, title: string | null, url: string | null }> }, latestRelease: { category: string | null, description: string | null, title: string | null, url: string | null } | null, supportArticle: { category: string | null, description: string | null, title: string | null, url: string | null } | null } };

export const TaskCardBaseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskCardBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dueDate"}},{"kind":"Field","name":{"kind":"Name","value":"isNew"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<TaskCardBaseFragment, unknown>;
export const SessionPayloadFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SessionPayload"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SessionPayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"sessionToken"}}]}}]} as unknown as DocumentNode<SessionPayloadFragment, unknown>;
export const WebflowPostBaseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WebflowPostBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WebflowPost"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode<WebflowPostBaseFragment, unknown>;
export const TargetsCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TargetsCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TargetConnectionInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"baseYear"}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"targetData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentValue"}},{"kind":"Field","name":{"kind":"Name","value":"isBaseYear"}},{"kind":"Field","name":{"kind":"Name","value":"predictedValue"}},{"kind":"Field","name":{"kind":"Name","value":"targetValue"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetYear"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<TargetsCardQuery, TargetsCardQueryVariables>;
export const TasksCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TasksCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"completedInput"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TaskConnectionInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inProgressInput"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TaskConnectionInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notStartedInput"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TaskConnectionInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"completedTasks"},"name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"completedInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskCardBase"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"closedCount"}},{"kind":"Field","name":{"kind":"Name","value":"newCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"inProgressTasks"},"name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inProgressInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskCardBase"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newCount"}},{"kind":"Field","name":{"kind":"Name","value":"overdueCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"upcomingCount"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"notStartedTasks"},"name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notStartedInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskCardBase"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newCount"}},{"kind":"Field","name":{"kind":"Name","value":"overdueCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"upcomingCount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskCardBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Task"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dueDate"}},{"kind":"Field","name":{"kind":"Name","value":"isNew"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<TasksCardQuery, TasksCardQueryVariables>;
export const DashboardStatisticsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DashboardStatistics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hasDisclosureAccess"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hasIncidentsAccess"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hasSurveyAccess"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"collectStatistics"},"name":{"kind":"Name","value":"disclosureAdminListV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filterInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"statuses"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ACTIVE"},{"kind":"EnumValue","value":"INACTIVE"}]}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasDisclosureAccess"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approvedCount"}},{"kind":"Field","name":{"kind":"Name","value":"disclosuresCount"}},{"kind":"Field","name":{"kind":"Name","value":"newAnswersCount"}},{"kind":"Field","name":{"kind":"Name","value":"responsesCount"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"incidentsStatistics"},"name":{"kind":"Name","value":"caseInvestigations"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasIncidentsAccess"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"closedCount"}},{"kind":"Field","name":{"kind":"Name","value":"longInactiveCount"}},{"kind":"Field","name":{"kind":"Name","value":"openedCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"surveyStatistics"},"name":{"kind":"Name","value":"surveyAdminListV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"statuses"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"COMPLETED"},{"kind":"EnumValue","value":"ONGOING"},{"kind":"EnumValue","value":"SCHEDULED"}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasSurveyAccess"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completedCount"}},{"kind":"Field","name":{"kind":"Name","value":"ongoingCount"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledCount"}}]}}]}}]}}]} as unknown as DocumentNode<DashboardStatisticsQuery, DashboardStatisticsQueryVariables>;
export const EsgStatisticsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EsgStatistics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeDisabledRiskAreas"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProgramsListInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programsList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"riskAreas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includeDisabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeDisabledRiskAreas"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"customLabel"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"path"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"statistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answeredQuestions"}},{"kind":"Field","name":{"kind":"Name","value":"totalQuestions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EsgStatisticsQuery, EsgStatisticsQueryVariables>;
export const RefreshSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RefreshSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JWT"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SessionPayload"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SessionPayload"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SessionPayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"sessionToken"}}]}}]} as unknown as DocumentNode<RefreshSessionMutation, RefreshSessionMutationVariables>;
export const YearsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Years"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"years"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paging"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"1"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}}]}}]} as unknown as DocumentNode<YearsQuery, YearsQueryVariables>;
export const CarbonLensInitializeSsoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CarbonLensInitializeSSO"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"url"},"name":{"kind":"Name","value":"carbonLensInitializeSSO"}}]}}]} as unknown as DocumentNode<CarbonLensInitializeSsoMutation, CarbonLensInitializeSsoMutationVariables>;
export const WebflowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Webflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"webflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"esgArticles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paging"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"6"}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"1"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WebflowPostBase"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paging"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"6"}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"1"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WebflowPostBase"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"latestRelease"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WebflowPostBase"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supportArticle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WebflowPostBase"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WebflowPostBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WebflowPost"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode<WebflowQuery, WebflowQueryVariables>;
export const OPERATIONS = {
  Query: {
    TargetsCard: 'TargetsCard',
    TasksCard: 'TasksCard',
    DashboardStatistics: 'DashboardStatistics',
    EsgStatistics: 'EsgStatistics',
    Years: 'Years',
    Webflow: 'Webflow'
  },
  Mutation: {
    RefreshSession: 'RefreshSession',
    CarbonLensInitializeSSO: 'CarbonLensInitializeSSO'
  },
  Fragment: {
    TaskCardBase: 'TaskCardBase',
    SessionPayload: 'SessionPayload',
    WebflowPostBase: 'WebflowPostBase'
  }
}
export type AdminContextTokensKeySpecifier = ('refreshToken' | 'sessionToken' | AdminContextTokensKeySpecifier)[];
export type AdminContextTokensFieldPolicy = {
	refreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionToken?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdminTenantDataKeySpecifier = ('adminActiveStatus' | 'apiUrl' | 'assistantCredentials' | 'clusterId' | 'code' | 'country' | 'customPlan' | 'elineNumbers' | 'forwardEarthCredentials' | 'licensesCount' | 'modules' | 'name' | 'primaryContact' | 'primaryContactEmail' | 'primaryContactFirstName' | 'primaryContactLastName' | 'primaryContactName' | 'region' | 'reportingSlug' | 'standards' | 'status' | 'subscription' | 'subscriptionExpire' | 'subscriptionStart' | 'tenantAdminUuid' | 'uuid' | AdminTenantDataKeySpecifier)[];
export type AdminTenantDataFieldPolicy = {
	adminActiveStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	apiUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	assistantCredentials?: FieldPolicy<any> | FieldReadFunction<any>,
	clusterId?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	customPlan?: FieldPolicy<any> | FieldReadFunction<any>,
	elineNumbers?: FieldPolicy<any> | FieldReadFunction<any>,
	forwardEarthCredentials?: FieldPolicy<any> | FieldReadFunction<any>,
	licensesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	modules?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryContact?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryContactEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryContactFirstName?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryContactLastName?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryContactName?: FieldPolicy<any> | FieldReadFunction<any>,
	region?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingSlug?: FieldPolicy<any> | FieldReadFunction<any>,
	standards?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	subscription?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionExpire?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionStart?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantAdminUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdminTenantDataConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | AdminTenantDataConnectionKeySpecifier)[];
export type AdminTenantDataConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdminTenantDataEdgeKeySpecifier = ('cursor' | 'node' | AdminTenantDataEdgeKeySpecifier)[];
export type AdminTenantDataEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdminTenantModuleSettingsKeySpecifier = ('moduleCarbonLensEnabled' | 'moduleCasesEnabled' | 'moduleDemoEnabled' | 'moduleDisclosuresEnabled' | 'moduleInsightsEnabled' | 'moduleNicoleGptEnabled' | 'moduleSsoEnabled' | 'moduleSurveysEnabled' | 'moduleTasksEnabled' | 'moduleTeamsEnabled' | 'moduleTrainingsEnabled' | 'subscriberEmail' | 'teamsTenantId' | 'tenant' | 'tenantUuid' | AdminTenantModuleSettingsKeySpecifier)[];
export type AdminTenantModuleSettingsFieldPolicy = {
	moduleCarbonLensEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	moduleCasesEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	moduleDemoEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	moduleDisclosuresEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	moduleInsightsEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	moduleNicoleGptEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	moduleSsoEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	moduleSurveysEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	moduleTasksEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	moduleTeamsEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	moduleTrainingsEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriberEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	teamsTenantId?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdminTenantSubscriptionKeySpecifier = ('end' | 'inactiveChangeDate' | 'licenseCount' | 'limitedLicenseCount' | 'plan' | 'standardLicenseCount' | 'start' | 'status' | 'subscriberEmail' | 'toBeDeletedAt' | AdminTenantSubscriptionKeySpecifier)[];
export type AdminTenantSubscriptionFieldPolicy = {
	end?: FieldPolicy<any> | FieldReadFunction<any>,
	inactiveChangeDate?: FieldPolicy<any> | FieldReadFunction<any>,
	licenseCount?: FieldPolicy<any> | FieldReadFunction<any>,
	limitedLicenseCount?: FieldPolicy<any> | FieldReadFunction<any>,
	plan?: FieldPolicy<any> | FieldReadFunction<any>,
	standardLicenseCount?: FieldPolicy<any> | FieldReadFunction<any>,
	start?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriberEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	toBeDeletedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdminUserDataKeySpecifier = ('email' | 'firstName' | 'lastName' | 'name' | 'status' | 'uuid' | AdminUserDataKeySpecifier)[];
export type AdminUserDataFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdminUserDataConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | AdminUserDataConnectionKeySpecifier)[];
export type AdminUserDataConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdminUserDataEdgeKeySpecifier = ('cursor' | 'node' | AdminUserDataEdgeKeySpecifier)[];
export type AdminUserDataEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AiReportKeySpecifier = ('audience' | 'dateApplied' | 'file' | 'generatedBy' | 'maxWordsLength' | 'prompt' | 'purpose' | 'reportName' | 'topics' | 'uuid' | AiReportKeySpecifier)[];
export type AiReportFieldPolicy = {
	audience?: FieldPolicy<any> | FieldReadFunction<any>,
	dateApplied?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	generatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	maxWordsLength?: FieldPolicy<any> | FieldReadFunction<any>,
	prompt?: FieldPolicy<any> | FieldReadFunction<any>,
	purpose?: FieldPolicy<any> | FieldReadFunction<any>,
	reportName?: FieldPolicy<any> | FieldReadFunction<any>,
	topics?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AiReportTopicKeySpecifier = ('name' | 'riskAreaUuid' | AiReportTopicKeySpecifier)[];
export type AiReportTopicFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnalyticsDateRangeKeySpecifier = ('customDate' | 'type' | AnalyticsDateRangeKeySpecifier)[];
export type AnalyticsDateRangeFieldPolicy = {
	customDate?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnalyticsSitesFiltersKeySpecifier = ('sites' | AnalyticsSitesFiltersKeySpecifier)[];
export type AnalyticsSitesFiltersFieldPolicy = {
	sites?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnalyticsSitesFiltersItemKeySpecifier = ('key' | 'label' | AnalyticsSitesFiltersItemKeySpecifier)[];
export type AnalyticsSitesFiltersItemFieldPolicy = {
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssetSettingsKeySpecifier = ('createdAt' | 'createdBy' | 'lastUpdatedAt' | 'lastUpdatedBy' | 'nicoleAvatarUrl' | 'nicoleSetting' | 'tenant' | 'uuid' | AssetSettingsKeySpecifier)[];
export type AssetSettingsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	nicoleAvatarUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	nicoleSetting?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssistantCredentialsKeySpecifier = ('apiKey' | 'assistantId' | 'instanceUrl' | 'tenant' | 'tenantUuid' | 'uuid' | 'workspaceId' | 'workspaceName' | AssistantCredentialsKeySpecifier)[];
export type AssistantCredentialsFieldPolicy = {
	apiKey?: FieldPolicy<any> | FieldReadFunction<any>,
	assistantId?: FieldPolicy<any> | FieldReadFunction<any>,
	instanceUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	workspaceId?: FieldPolicy<any> | FieldReadFunction<any>,
	workspaceName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssistantCredentialsConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | AssistantCredentialsConnectionKeySpecifier)[];
export type AssistantCredentialsConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssistantCredentialsEdgeKeySpecifier = ('cursor' | 'node' | AssistantCredentialsEdgeKeySpecifier)[];
export type AssistantCredentialsEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssistantSlotKeySpecifier = ('actionId' | 'dataType' | 'isLegacy' | 'legacyType' | 'slotId' | 'text' | AssistantSlotKeySpecifier)[];
export type AssistantSlotFieldPolicy = {
	actionId?: FieldPolicy<any> | FieldReadFunction<any>,
	dataType?: FieldPolicy<any> | FieldReadFunction<any>,
	isLegacy?: FieldPolicy<any> | FieldReadFunction<any>,
	legacyType?: FieldPolicy<any> | FieldReadFunction<any>,
	slotId?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssistantSlotConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | AssistantSlotConnectionKeySpecifier)[];
export type AssistantSlotConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssistantSlotEdgeKeySpecifier = ('cursor' | 'node' | AssistantSlotEdgeKeySpecifier)[];
export type AssistantSlotEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssistantSlotIdentifiersKeySpecifier = ('actionId' | 'slotId' | AssistantSlotIdentifiersKeySpecifier)[];
export type AssistantSlotIdentifiersFieldPolicy = {
	actionId?: FieldPolicy<any> | FieldReadFunction<any>,
	slotId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AuditEventKeySpecifier = ('answerUuid' | 'context' | 'contextLabel' | 'createdAt' | 'detailsDescription' | 'esgAnswer' | 'esgQuestion' | 'loggedAt' | 'newValue' | 'oldValue' | 'programme' | 'programmeUuid' | 'questionUuid' | 'resourceId' | 'resourceType' | 'riskArea' | 'riskAreaUuid' | 'status' | 'typeKey' | 'typeLabel' | 'user' | 'userAgent' | 'userIp' | 'userUuid' | 'uuid' | 'year' | 'yearUuid' | AuditEventKeySpecifier)[];
export type AuditEventFieldPolicy = {
	answerUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	context?: FieldPolicy<any> | FieldReadFunction<any>,
	contextLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	detailsDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	esgAnswer?: FieldPolicy<any> | FieldReadFunction<any>,
	esgQuestion?: FieldPolicy<any> | FieldReadFunction<any>,
	loggedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	newValue?: FieldPolicy<any> | FieldReadFunction<any>,
	oldValue?: FieldPolicy<any> | FieldReadFunction<any>,
	programme?: FieldPolicy<any> | FieldReadFunction<any>,
	programmeUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	questionUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	resourceId?: FieldPolicy<any> | FieldReadFunction<any>,
	resourceType?: FieldPolicy<any> | FieldReadFunction<any>,
	riskArea?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	typeKey?: FieldPolicy<any> | FieldReadFunction<any>,
	typeLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userAgent?: FieldPolicy<any> | FieldReadFunction<any>,
	userIp?: FieldPolicy<any> | FieldReadFunction<any>,
	userUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	year?: FieldPolicy<any> | FieldReadFunction<any>,
	yearUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AuditEventConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | AuditEventConnectionKeySpecifier)[];
export type AuditEventConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AuditEventEdgeKeySpecifier = ('cursor' | 'node' | AuditEventEdgeKeySpecifier)[];
export type AuditEventEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AutomaticDeletionSettingsKeySpecifier = ('automaticDeletionAfterDays' | 'canEdit' | 'isActivityDeletionEnabled' | 'isChatHistoryDeletionEnabled' | 'isEnabled' | 'isFilesDeletionEnabled' | 'isParticipantDeletionEnabled' | AutomaticDeletionSettingsKeySpecifier)[];
export type AutomaticDeletionSettingsFieldPolicy = {
	automaticDeletionAfterDays?: FieldPolicy<any> | FieldReadFunction<any>,
	canEdit?: FieldPolicy<any> | FieldReadFunction<any>,
	isActivityDeletionEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	isChatHistoryDeletionEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	isFilesDeletionEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	isParticipantDeletionEnabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AvgDaysToCloseByIncidentTypeKeySpecifier = ('avgDaysToClose' | 'incidentTypeName' | AvgDaysToCloseByIncidentTypeKeySpecifier)[];
export type AvgDaysToCloseByIncidentTypeFieldPolicy = {
	avgDaysToClose?: FieldPolicy<any> | FieldReadFunction<any>,
	incidentTypeName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AvgDaysToCloseByTimeIntervalKeySpecifier = ('avgDaysToClose' | 'date' | AvgDaysToCloseByTimeIntervalKeySpecifier)[];
export type AvgDaysToCloseByTimeIntervalFieldPolicy = {
	avgDaysToClose?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BannedEmailKeySpecifier = ('createdAt' | 'createdBy' | 'email' | 'isActive' | 'updatedAt' | 'updatedBy' | 'uuid' | BannedEmailKeySpecifier)[];
export type BannedEmailFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BannedEmailConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | BannedEmailConnectionKeySpecifier)[];
export type BannedEmailConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BannedEmailEdgeKeySpecifier = ('cursor' | 'node' | BannedEmailEdgeKeySpecifier)[];
export type BannedEmailEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BusinessUnitKeySpecifier = ('isActive' | 'name' | 'reportingGroup' | 'uuid' | BusinessUnitKeySpecifier)[];
export type BusinessUnitFieldPolicy = {
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BusinessUnitConnectionKeySpecifier = ('all' | 'edges' | 'nodes' | 'pageInfo' | 'totalCount' | BusinessUnitConnectionKeySpecifier)[];
export type BusinessUnitConnectionFieldPolicy = {
	all?: FieldPolicy<any> | FieldReadFunction<any>,
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BusinessUnitEdgeKeySpecifier = ('cursor' | 'node' | BusinessUnitEdgeKeySpecifier)[];
export type BusinessUnitEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CallsCaseKeySpecifier = ('assignedCaseType' | 'caseCode' | 'caseCodeReadable' | 'caseTypes' | 'caseTypesCount' | 'country' | 'language' | 'pinCode' | 'pinCodeReadable' | 'recordingUrl' | 'tenantCode' | 'transcriptUpdatedAt' | 'transcription' | 'twilioCallSid' | 'uuid' | CallsCaseKeySpecifier)[];
export type CallsCaseFieldPolicy = {
	assignedCaseType?: FieldPolicy<any> | FieldReadFunction<any>,
	caseCode?: FieldPolicy<any> | FieldReadFunction<any>,
	caseCodeReadable?: FieldPolicy<any> | FieldReadFunction<any>,
	caseTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	caseTypesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>,
	pinCode?: FieldPolicy<any> | FieldReadFunction<any>,
	pinCodeReadable?: FieldPolicy<any> | FieldReadFunction<any>,
	recordingUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantCode?: FieldPolicy<any> | FieldReadFunction<any>,
	transcriptUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	transcription?: FieldPolicy<any> | FieldReadFunction<any>,
	twilioCallSid?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CallsIncidentTypeKeySpecifier = ('order' | 'type' | 'uuid' | CallsIncidentTypeKeySpecifier)[];
export type CallsIncidentTypeFieldPolicy = {
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseKeySpecifier = ('activities' | 'businessUnit' | 'caseId' | 'chatRoomSecret' | 'city' | 'closedAt' | 'conclusionType' | 'conversationMessages' | 'country' | 'createdAt' | 'createdBy' | 'createdByGuest' | 'currency' | 'customTitle' | 'damageCost' | 'duration' | 'entity' | 'excludedUsers' | 'file' | 'files' | 'firebaseToken' | 'guestEmail' | 'hasOriginalReport' | 'history' | 'inCasePermissions' | 'incidentType' | 'individualsInvolved' | 'investigators' | 'isSubmitted' | 'language' | 'location' | 'openedAt' | 'pinCode' | 'possibleBusinessUnits' | 'possibleInvestigators' | 'relationship' | 'reopenedAt' | 'reportCountry' | 'reportSource' | 'reporter' | 'reportingSource' | 'severity' | 'state' | 'status' | 'submittedAt' | 'subsidiarySite' | 'triageScore' | 'updatedAt' | 'urgency' | 'uuid' | CaseKeySpecifier)[];
export type CaseFieldPolicy = {
	activities?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	caseId?: FieldPolicy<any> | FieldReadFunction<any>,
	chatRoomSecret?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	closedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	conclusionType?: FieldPolicy<any> | FieldReadFunction<any>,
	conversationMessages?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByGuest?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	customTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	damageCost?: FieldPolicy<any> | FieldReadFunction<any>,
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	entity?: FieldPolicy<any> | FieldReadFunction<any>,
	excludedUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	files?: FieldPolicy<any> | FieldReadFunction<any>,
	firebaseToken?: FieldPolicy<any> | FieldReadFunction<any>,
	guestEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	hasOriginalReport?: FieldPolicy<any> | FieldReadFunction<any>,
	history?: FieldPolicy<any> | FieldReadFunction<any>,
	inCasePermissions?: FieldPolicy<any> | FieldReadFunction<any>,
	incidentType?: FieldPolicy<any> | FieldReadFunction<any>,
	individualsInvolved?: FieldPolicy<any> | FieldReadFunction<any>,
	investigators?: FieldPolicy<any> | FieldReadFunction<any>,
	isSubmitted?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	openedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	pinCode?: FieldPolicy<any> | FieldReadFunction<any>,
	possibleBusinessUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	possibleInvestigators?: FieldPolicy<any> | FieldReadFunction<any>,
	relationship?: FieldPolicy<any> | FieldReadFunction<any>,
	reopenedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	reportCountry?: FieldPolicy<any> | FieldReadFunction<any>,
	reportSource?: FieldPolicy<any> | FieldReadFunction<any>,
	reporter?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingSource?: FieldPolicy<any> | FieldReadFunction<any>,
	severity?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	submittedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySite?: FieldPolicy<any> | FieldReadFunction<any>,
	triageScore?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	urgency?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseActivityKeySpecifier = ('activityFiles' | 'activityType' | 'case' | 'conclusionType' | 'createdAt' | 'createdBy' | 'note' | 'relatedField' | 'title' | 'uuid' | CaseActivityKeySpecifier)[];
export type CaseActivityFieldPolicy = {
	activityFiles?: FieldPolicy<any> | FieldReadFunction<any>,
	activityType?: FieldPolicy<any> | FieldReadFunction<any>,
	case?: FieldPolicy<any> | FieldReadFunction<any>,
	conclusionType?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	note?: FieldPolicy<any> | FieldReadFunction<any>,
	relatedField?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseActivityConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | CaseActivityConnectionKeySpecifier)[];
export type CaseActivityConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseActivityEdgeKeySpecifier = ('cursor' | 'node' | CaseActivityEdgeKeySpecifier)[];
export type CaseActivityEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseActivityRelatedFieldKeySpecifier = ('fieldLabel' | 'fieldName' | 'fieldType' | 'fieldValue' | CaseActivityRelatedFieldKeySpecifier)[];
export type CaseActivityRelatedFieldFieldPolicy = {
	fieldLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldName?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldType?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldValue?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseActivitySettingsKeySpecifier = ('isActive' | 'name' | 'relatedField' | 'relatedFields' | 'uuid' | CaseActivitySettingsKeySpecifier)[];
export type CaseActivitySettingsFieldPolicy = {
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	relatedField?: FieldPolicy<any> | FieldReadFunction<any>,
	relatedFields?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseActivitySettingsConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | CaseActivitySettingsConnectionKeySpecifier)[];
export type CaseActivitySettingsConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseActivitySettingsEdgeKeySpecifier = ('cursor' | 'node' | CaseActivitySettingsEdgeKeySpecifier)[];
export type CaseActivitySettingsEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseActivitySettingsRelatedFieldKeySpecifier = ('fieldLabel' | 'fieldName' | 'fieldType' | CaseActivitySettingsRelatedFieldKeySpecifier)[];
export type CaseActivitySettingsRelatedFieldFieldPolicy = {
	fieldLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldName?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseAnalyticsKeySpecifier = ('avgDaysToCloseByIncidentType' | 'avgDaysToCloseByTimeInterval' | 'casesByCountry' | 'casesByReportSource' | 'casesByStatus' | 'casesStatusByIncidentType' | 'tenantUuid' | CaseAnalyticsKeySpecifier)[];
export type CaseAnalyticsFieldPolicy = {
	avgDaysToCloseByIncidentType?: FieldPolicy<any> | FieldReadFunction<any>,
	avgDaysToCloseByTimeInterval?: FieldPolicy<any> | FieldReadFunction<any>,
	casesByCountry?: FieldPolicy<any> | FieldReadFunction<any>,
	casesByReportSource?: FieldPolicy<any> | FieldReadFunction<any>,
	casesByStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	casesStatusByIncidentType?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseAnonymityConnectionKeySpecifier = ('edges' | 'isEnabled' | 'nodes' | 'pageInfo' | 'totalCount' | CaseAnonymityConnectionKeySpecifier)[];
export type CaseAnonymityConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseAnonymityRestrictionsKeySpecifier = ('country' | 'restrictions' | CaseAnonymityRestrictionsKeySpecifier)[];
export type CaseAnonymityRestrictionsFieldPolicy = {
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	restrictions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseAssignmentKeySpecifier = ('countries' | 'incidentTypes' | 'regions' | 'subsidiarySite' | 'users' | 'uuid' | CaseAssignmentKeySpecifier)[];
export type CaseAssignmentFieldPolicy = {
	countries?: FieldPolicy<any> | FieldReadFunction<any>,
	incidentTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	regions?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySite?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseAssignmentConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | CaseAssignmentConnectionKeySpecifier)[];
export type CaseAssignmentConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseAssignmentEdgeKeySpecifier = ('cursor' | 'node' | CaseAssignmentEdgeKeySpecifier)[];
export type CaseAssignmentEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseByCountryKeySpecifier = ('count' | 'country' | CaseByCountryKeySpecifier)[];
export type CaseByCountryFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseByReportSourceKeySpecifier = ('count' | 'source' | CaseByReportSourceKeySpecifier)[];
export type CaseByReportSourceFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseByStatusKeySpecifier = ('closed' | 'reported' | CaseByStatusKeySpecifier)[];
export type CaseByStatusFieldPolicy = {
	closed?: FieldPolicy<any> | FieldReadFunction<any>,
	reported?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseByStatusDataKeySpecifier = ('count' | 'date' | CaseByStatusDataKeySpecifier)[];
export type CaseByStatusDataFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseCustomReminderKeySpecifier = ('afterInactivityDays' | 'channels' | 'countries' | 'message' | 'receivers' | 'status' | 'title' | 'uuid' | CaseCustomReminderKeySpecifier)[];
export type CaseCustomReminderFieldPolicy = {
	afterInactivityDays?: FieldPolicy<any> | FieldReadFunction<any>,
	channels?: FieldPolicy<any> | FieldReadFunction<any>,
	countries?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	receivers?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseCustomReminderConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | CaseCustomReminderConnectionKeySpecifier)[];
export type CaseCustomReminderConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseCustomReminderEdgeKeySpecifier = ('cursor' | 'node' | CaseCustomReminderEdgeKeySpecifier)[];
export type CaseCustomReminderEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseEdgeKeySpecifier = ('cursor' | 'node' | CaseEdgeKeySpecifier)[];
export type CaseEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseExclusionOwnerKeySpecifier = ('email' | 'name' | 'uuid' | CaseExclusionOwnerKeySpecifier)[];
export type CaseExclusionOwnerFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseExclusionOwnerEdgeKeySpecifier = ('cursor' | 'node' | CaseExclusionOwnerEdgeKeySpecifier)[];
export type CaseExclusionOwnerEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseExclusionOwnerListPaginatedKeySpecifier = ('isEnabled' | 'page' | 'totalCount' | CaseExclusionOwnerListPaginatedKeySpecifier)[];
export type CaseExclusionOwnerListPaginatedFieldPolicy = {
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseExclusionOwnerPageKeySpecifier = ('edges' | 'info' | CaseExclusionOwnerPageKeySpecifier)[];
export type CaseExclusionOwnerPageFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	info?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseFileKeySpecifier = ('case' | 'caseActivity' | 'caseUuid' | 'mimeType' | 'name' | 's3Key' | 'size' | 'type' | 'uploadedAt' | 'uploadedBy' | 'uploadedByReporter' | 'uuid' | CaseFileKeySpecifier)[];
export type CaseFileFieldPolicy = {
	case?: FieldPolicy<any> | FieldReadFunction<any>,
	caseActivity?: FieldPolicy<any> | FieldReadFunction<any>,
	caseUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	mimeType?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	s3Key?: FieldPolicy<any> | FieldReadFunction<any>,
	size?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadedByReporter?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseFileConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | CaseFileConnectionKeySpecifier)[];
export type CaseFileConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseFileEdgeKeySpecifier = ('cursor' | 'node' | CaseFileEdgeKeySpecifier)[];
export type CaseFileEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseHistoryKeySpecifier = ('case' | 'changedAt' | 'changedBy' | 'newValue' | 'originalValue' | 'record' | 'uuid' | CaseHistoryKeySpecifier)[];
export type CaseHistoryFieldPolicy = {
	case?: FieldPolicy<any> | FieldReadFunction<any>,
	changedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	changedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	newValue?: FieldPolicy<any> | FieldReadFunction<any>,
	originalValue?: FieldPolicy<any> | FieldReadFunction<any>,
	record?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseHistoryConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | CaseHistoryConnectionKeySpecifier)[];
export type CaseHistoryConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseHistoryEdgeKeySpecifier = ('cursor' | 'node' | CaseHistoryEdgeKeySpecifier)[];
export type CaseHistoryEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseInvestigationKeySpecifier = ('caseId' | 'caseUuid' | 'createdAt' | 'customTitle' | 'originalReport' | 'status' | 'updatedAt' | CaseInvestigationKeySpecifier)[];
export type CaseInvestigationFieldPolicy = {
	caseId?: FieldPolicy<any> | FieldReadFunction<any>,
	caseUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	customTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	originalReport?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseInvestigationConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'statistics' | 'totalCount' | CaseInvestigationConnectionKeySpecifier)[];
export type CaseInvestigationConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseInvestigationPdfReportGenerateResponseKeySpecifier = ('url' | CaseInvestigationPdfReportGenerateResponseKeySpecifier)[];
export type CaseInvestigationPdfReportGenerateResponseFieldPolicy = {
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseInvestigationStatisticsKeySpecifier = ('closedCount' | 'longInactiveCount' | 'openedCount' | 'totalCount' | CaseInvestigationStatisticsKeySpecifier)[];
export type CaseInvestigationStatisticsFieldPolicy = {
	closedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	longInactiveCount?: FieldPolicy<any> | FieldReadFunction<any>,
	openedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseInvestigatorsKeySpecifier = ('owners' | 'stakeholders' | CaseInvestigatorsKeySpecifier)[];
export type CaseInvestigatorsFieldPolicy = {
	owners?: FieldPolicy<any> | FieldReadFunction<any>,
	stakeholders?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseOwnerExclusionKeySpecifier = ('excludableUsers' | 'fallbackUser' | 'subsidiarySite' | 'uuid' | CaseOwnerExclusionKeySpecifier)[];
export type CaseOwnerExclusionFieldPolicy = {
	excludableUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	fallbackUser?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySite?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseOwnerExclusionConnectionKeySpecifier = ('configurationStatus' | 'edges' | 'nodes' | 'pageInfo' | 'totalCount' | CaseOwnerExclusionConnectionKeySpecifier)[];
export type CaseOwnerExclusionConnectionFieldPolicy = {
	configurationStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseOwnerExclusionEdgeKeySpecifier = ('cursor' | 'node' | CaseOwnerExclusionEdgeKeySpecifier)[];
export type CaseOwnerExclusionEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CasePrintSectionsKeySpecifier = ('assistantConversation' | 'basicInformation' | 'caseActivity' | 'caseFiles' | 'caseOwnership' | 'chatConversation' | 'individualsInvolved' | CasePrintSectionsKeySpecifier)[];
export type CasePrintSectionsFieldPolicy = {
	assistantConversation?: FieldPolicy<any> | FieldReadFunction<any>,
	basicInformation?: FieldPolicy<any> | FieldReadFunction<any>,
	caseActivity?: FieldPolicy<any> | FieldReadFunction<any>,
	caseFiles?: FieldPolicy<any> | FieldReadFunction<any>,
	caseOwnership?: FieldPolicy<any> | FieldReadFunction<any>,
	chatConversation?: FieldPolicy<any> | FieldReadFunction<any>,
	individualsInvolved?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CasePrintSettingsKeySpecifier = ('ADMIN' | 'CASE_OWNER' | 'REGIONAL_USER' | 'STAKEHOLDER' | CasePrintSettingsKeySpecifier)[];
export type CasePrintSettingsFieldPolicy = {
	ADMIN?: FieldPolicy<any> | FieldReadFunction<any>,
	CASE_OWNER?: FieldPolicy<any> | FieldReadFunction<any>,
	REGIONAL_USER?: FieldPolicy<any> | FieldReadFunction<any>,
	STAKEHOLDER?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseReportKeySpecifier = ('caseId' | 'chatRoomSecret' | 'createdAt' | 'isNewMessageFromAdmin' | 'isStatusChanged' | 'language' | 'lastMessage' | 'lastMessageTranslated' | 'status' | 'uuid' | CaseReportKeySpecifier)[];
export type CaseReportFieldPolicy = {
	caseId?: FieldPolicy<any> | FieldReadFunction<any>,
	chatRoomSecret?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	isNewMessageFromAdmin?: FieldPolicy<any> | FieldReadFunction<any>,
	isStatusChanged?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>,
	lastMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	lastMessageTranslated?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseReportConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'statistics' | CaseReportConnectionKeySpecifier)[];
export type CaseReportConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseReportEdgeKeySpecifier = ('cursor' | 'node' | CaseReportEdgeKeySpecifier)[];
export type CaseReportEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseReportStatisticsKeySpecifier = ('all' | 'ongoing' | CaseReportStatisticsKeySpecifier)[];
export type CaseReportStatisticsFieldPolicy = {
	all?: FieldPolicy<any> | FieldReadFunction<any>,
	ongoing?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseReportSubmitKeySpecifier = ('caseId' | 'createdAt' | 'language' | 'status' | 'uuid' | CaseReportSubmitKeySpecifier)[];
export type CaseReportSubmitFieldPolicy = {
	caseId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseReportSummaryResponseKeySpecifier = ('businessUnit' | 'caseId' | 'chatRoomSecret' | 'conversationMessages' | 'country' | 'elineConversation' | 'entity' | 'excludedUsers' | 'files' | 'firebaseToken' | 'incidentType' | 'isStatusChanged' | 'language' | 'mobileApiToken' | 'status' | 'subsidiarySite' | 'uuid' | CaseReportSummaryResponseKeySpecifier)[];
export type CaseReportSummaryResponseFieldPolicy = {
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	caseId?: FieldPolicy<any> | FieldReadFunction<any>,
	chatRoomSecret?: FieldPolicy<any> | FieldReadFunction<any>,
	conversationMessages?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	elineConversation?: FieldPolicy<any> | FieldReadFunction<any>,
	entity?: FieldPolicy<any> | FieldReadFunction<any>,
	excludedUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	files?: FieldPolicy<any> | FieldReadFunction<any>,
	firebaseToken?: FieldPolicy<any> | FieldReadFunction<any>,
	incidentType?: FieldPolicy<any> | FieldReadFunction<any>,
	isStatusChanged?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>,
	mobileApiToken?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySite?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseReporterKeySpecifier = ('country' | 'email' | 'firstName' | 'lastName' | 'relationship' | CaseReporterKeySpecifier)[];
export type CaseReporterFieldPolicy = {
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	relationship?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseSettingAnonymityKeySpecifier = ('canEdit' | 'configuredCountries' | 'countryAnonymities' | 'isEnabled' | CaseSettingAnonymityKeySpecifier)[];
export type CaseSettingAnonymityFieldPolicy = {
	canEdit?: FieldPolicy<any> | FieldReadFunction<any>,
	configuredCountries?: FieldPolicy<any> | FieldReadFunction<any>,
	countryAnonymities?: FieldPolicy<any> | FieldReadFunction<any>,
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseSettingExclusionKeySpecifier = ('canEdit' | 'fallbackUserUuid' | 'isEnabled' | CaseSettingExclusionKeySpecifier)[];
export type CaseSettingExclusionFieldPolicy = {
	canEdit?: FieldPolicy<any> | FieldReadFunction<any>,
	fallbackUserUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseSettingsKeySpecifier = ('anonymitySettings' | 'automaticDeletionSettings' | 'caseActivity' | 'caseActivitySetting' | 'caseActivitySettingsAll' | 'caseAssignment' | 'caseAssignments' | 'caseOwnerExclusion' | 'caseOwnerExclusions' | 'conclusionType' | 'conclusionTypes' | 'conclusionTypesAll' | 'conversationEditingSettings' | 'customReminder' | 'customReminders' | 'emailTemplate' | 'emailTemplates' | 'exclusionSetting' | 'notifyCaseOwnersAfterInactivityDays' | 'printingSettings' | 'reportingSource' | 'reportingSources' | 'reportingSourcesAll' | 'subsidiaryReportingSettings' | 'tenantUuid' | 'triageScoreSettings' | CaseSettingsKeySpecifier)[];
export type CaseSettingsFieldPolicy = {
	anonymitySettings?: FieldPolicy<any> | FieldReadFunction<any>,
	automaticDeletionSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	caseActivity?: FieldPolicy<any> | FieldReadFunction<any>,
	caseActivitySetting?: FieldPolicy<any> | FieldReadFunction<any>,
	caseActivitySettingsAll?: FieldPolicy<any> | FieldReadFunction<any>,
	caseAssignment?: FieldPolicy<any> | FieldReadFunction<any>,
	caseAssignments?: FieldPolicy<any> | FieldReadFunction<any>,
	caseOwnerExclusion?: FieldPolicy<any> | FieldReadFunction<any>,
	caseOwnerExclusions?: FieldPolicy<any> | FieldReadFunction<any>,
	conclusionType?: FieldPolicy<any> | FieldReadFunction<any>,
	conclusionTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	conclusionTypesAll?: FieldPolicy<any> | FieldReadFunction<any>,
	conversationEditingSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	customReminder?: FieldPolicy<any> | FieldReadFunction<any>,
	customReminders?: FieldPolicy<any> | FieldReadFunction<any>,
	emailTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	emailTemplates?: FieldPolicy<any> | FieldReadFunction<any>,
	exclusionSetting?: FieldPolicy<any> | FieldReadFunction<any>,
	notifyCaseOwnersAfterInactivityDays?: FieldPolicy<any> | FieldReadFunction<any>,
	printingSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingSource?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingSources?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingSourcesAll?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiaryReportingSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	triageScoreSettings?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaseStatusByIncidentTypeKeySpecifier = ('closed' | 'incidentTypeName' | 'new' | 'open' | 'reopen' | CaseStatusByIncidentTypeKeySpecifier)[];
export type CaseStatusByIncidentTypeFieldPolicy = {
	closed?: FieldPolicy<any> | FieldReadFunction<any>,
	incidentTypeName?: FieldPolicy<any> | FieldReadFunction<any>,
	new?: FieldPolicy<any> | FieldReadFunction<any>,
	open?: FieldPolicy<any> | FieldReadFunction<any>,
	reopen?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CasesRolePermissionKeySpecifier = ('permission' | 'subsidiarySite' | 'uuid' | CasesRolePermissionKeySpecifier)[];
export type CasesRolePermissionFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySite?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CategoryKeySpecifier = ('name' | 'riskAreas' | 'uuid' | CategoryKeySpecifier)[];
export type CategoryFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChatRoomKeySpecifier = ('referenceType' | 'referenceUuid' | 'secret' | 'status' | ChatRoomKeySpecifier)[];
export type ChatRoomFieldPolicy = {
	referenceType?: FieldPolicy<any> | FieldReadFunction<any>,
	referenceUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	secret?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChatbotKeySpecifier = ('answersCount' | 'createdAt' | 'createdBy' | 'messages' | 'uuid' | ChatbotKeySpecifier)[];
export type ChatbotFieldPolicy = {
	answersCount?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	messages?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChatbotMessageKeySpecifier = ('content' | 'createdAt' | 'createdBy' | 'role' | 'uuid' | ChatbotMessageKeySpecifier)[];
export type ChatbotMessageFieldPolicy = {
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChatbotMessageConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | ChatbotMessageConnectionKeySpecifier)[];
export type ChatbotMessageConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChatbotMessageEdgeKeySpecifier = ('cursor' | 'node' | ChatbotMessageEdgeKeySpecifier)[];
export type ChatbotMessageEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChatsFileKeySpecifier = ('chatRoomUuid' | 'mimeType' | 'name' | 's3Key' | 'signedUrl' | 'size' | 'uuid' | ChatsFileKeySpecifier)[];
export type ChatsFileFieldPolicy = {
	chatRoomUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	mimeType?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	s3Key?: FieldPolicy<any> | FieldReadFunction<any>,
	signedUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	size?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ClientSubsidiarySiteKeySpecifier = ('admins' | 'isActive' | 'name' | 'reportingSlug' | 'uuid' | ClientSubsidiarySiteKeySpecifier)[];
export type ClientSubsidiarySiteFieldPolicy = {
	admins?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingSlug?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ClientSubsidiarySiteAdminKeySpecifier = ('firstName' | 'lastName' | 'uuid' | ClientSubsidiarySiteAdminKeySpecifier)[];
export type ClientSubsidiarySiteAdminFieldPolicy = {
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ClientSubsidiarySiteEdgeKeySpecifier = ('cursor' | 'node' | ClientSubsidiarySiteEdgeKeySpecifier)[];
export type ClientSubsidiarySiteEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ClientSubsidiarySitesConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | ClientSubsidiarySitesConnectionKeySpecifier)[];
export type ClientSubsidiarySitesConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ClientUserKeySpecifier = ('firstName' | 'lastName' | 'uuid' | ClientUserKeySpecifier)[];
export type ClientUserFieldPolicy = {
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConclusionTypeKeySpecifier = ('isActive' | 'name' | 'uuid' | ConclusionTypeKeySpecifier)[];
export type ConclusionTypeFieldPolicy = {
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConclusionTypeConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | ConclusionTypeConnectionKeySpecifier)[];
export type ConclusionTypeConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConclusionTypeEdgeKeySpecifier = ('cursor' | 'node' | ConclusionTypeEdgeKeySpecifier)[];
export type ConclusionTypeEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConversationActionSlotKeySpecifier = ('actionId' | 'extraType' | 'text' | 'textTranslated' | 'type' | ConversationActionSlotKeySpecifier)[];
export type ConversationActionSlotFieldPolicy = {
	actionId?: FieldPolicy<any> | FieldReadFunction<any>,
	extraType?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>,
	textTranslated?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConversationAssistantResponseKeySpecifier = ('assistantResponses' | 'assistantResponsesTranslated' | 'caseUuid' | 'isDescribed' | 'nextSlotId' | 'progress' | 'slotOptions' | ConversationAssistantResponseKeySpecifier)[];
export type ConversationAssistantResponseFieldPolicy = {
	assistantResponses?: FieldPolicy<any> | FieldReadFunction<any>,
	assistantResponsesTranslated?: FieldPolicy<any> | FieldReadFunction<any>,
	caseUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	isDescribed?: FieldPolicy<any> | FieldReadFunction<any>,
	nextSlotId?: FieldPolicy<any> | FieldReadFunction<any>,
	progress?: FieldPolicy<any> | FieldReadFunction<any>,
	slotOptions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConversationEditingSettingsKeySpecifier = ('canEdit' | 'isEnabled' | ConversationEditingSettingsKeySpecifier)[];
export type ConversationEditingSettingsFieldPolicy = {
	canEdit?: FieldPolicy<any> | FieldReadFunction<any>,
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConversationMessageKeySpecifier = ('canEdit' | 'isAssistant' | 'order' | 'text' | 'textTranslated' | 'textTranslatedOverride' | 'uuid' | ConversationMessageKeySpecifier)[];
export type ConversationMessageFieldPolicy = {
	canEdit?: FieldPolicy<any> | FieldReadFunction<any>,
	isAssistant?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>,
	textTranslated?: FieldPolicy<any> | FieldReadFunction<any>,
	textTranslatedOverride?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConversationProgressKeySpecifier = ('conversationUuid' | 'stepLabel' | 'stepLabelTranslated' | 'stepOrder' | 'stepsCount' | ConversationProgressKeySpecifier)[];
export type ConversationProgressFieldPolicy = {
	conversationUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	stepLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	stepLabelTranslated?: FieldPolicy<any> | FieldReadFunction<any>,
	stepOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	stepsCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CountryAnonymityKeySpecifier = ('country' | 'incidentAnonymities' | CountryAnonymityKeySpecifier)[];
export type CountryAnonymityFieldPolicy = {
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	incidentAnonymities?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CountryAnonymityEdgeKeySpecifier = ('cursor' | 'node' | CountryAnonymityEdgeKeySpecifier)[];
export type CountryAnonymityEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DashboardColumnKeySpecifier = ('label' | 'value' | DashboardColumnKeySpecifier)[];
export type DashboardColumnFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DashboardDateRangeKeySpecifier = ('customDate' | 'type' | DashboardDateRangeKeySpecifier)[];
export type DashboardDateRangeFieldPolicy = {
	customDate?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DashboardFiltersKeySpecifier = ('businessUnits' | 'countries' | 'incidentTypes' | DashboardFiltersKeySpecifier)[];
export type DashboardFiltersFieldPolicy = {
	businessUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	countries?: FieldPolicy<any> | FieldReadFunction<any>,
	incidentTypes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DashboardSortKeySpecifier = ('direction' | 'field' | DashboardSortKeySpecifier)[];
export type DashboardSortFieldPolicy = {
	direction?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DataCategoryKeySpecifier = ('category' | 'createdAt' | 'createdBy' | 'lastUpdatedAt' | 'lastUpdatedBy' | 'uuid' | DataCategoryKeySpecifier)[];
export type DataCategoryFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DataCategoryConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | DataCategoryConnectionKeySpecifier)[];
export type DataCategoryConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DataCategoryEdgeKeySpecifier = ('cursor' | 'node' | DataCategoryEdgeKeySpecifier)[];
export type DataCategoryEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureKeySpecifier = ('applicantsNumber' | 'audienceType' | 'canAnswer' | 'canEdit' | 'countries' | 'createdAt' | 'description' | 'emailTargets' | 'hasAnswered' | 'hasNewAnswers' | 'isAuthor' | 'json' | 'lastResponded' | 'name' | 'relationships' | 'respondentType' | 'responseCount' | 'responses' | 'riskAreas' | 'status' | 'updatedAt' | 'userResponseCount' | 'uuid' | DisclosureKeySpecifier)[];
export type DisclosureFieldPolicy = {
	applicantsNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	audienceType?: FieldPolicy<any> | FieldReadFunction<any>,
	canAnswer?: FieldPolicy<any> | FieldReadFunction<any>,
	canEdit?: FieldPolicy<any> | FieldReadFunction<any>,
	countries?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	emailTargets?: FieldPolicy<any> | FieldReadFunction<any>,
	hasAnswered?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNewAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	isAuthor?: FieldPolicy<any> | FieldReadFunction<any>,
	json?: FieldPolicy<any> | FieldReadFunction<any>,
	lastResponded?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	relationships?: FieldPolicy<any> | FieldReadFunction<any>,
	respondentType?: FieldPolicy<any> | FieldReadFunction<any>,
	responseCount?: FieldPolicy<any> | FieldReadFunction<any>,
	responses?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	userResponseCount?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureChatNotificationExtraKeySpecifier = ('disclosureUuid' | DisclosureChatNotificationExtraKeySpecifier)[];
export type DisclosureChatNotificationExtraFieldPolicy = {
	disclosureUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureCommentsPaginatedKeySpecifier = ('page' | 'totalCount' | DisclosureCommentsPaginatedKeySpecifier)[];
export type DisclosureCommentsPaginatedFieldPolicy = {
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'statistics' | 'totalCount' | DisclosureConnectionKeySpecifier)[];
export type DisclosureConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureEdgeKeySpecifier = ('cursor' | 'node' | DisclosureEdgeKeySpecifier)[];
export type DisclosureEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureEmailTargetKeySpecifier = ('answered' | 'email' | 'sent' | 'uuid' | DisclosureEmailTargetKeySpecifier)[];
export type DisclosureEmailTargetFieldPolicy = {
	answered?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	sent?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosurePageKeySpecifier = ('edges' | 'info' | DisclosurePageKeySpecifier)[];
export type DisclosurePageFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	info?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosurePaginatedKeySpecifier = ('page' | 'statistics' | 'totalCount' | DisclosurePaginatedKeySpecifier)[];
export type DisclosurePaginatedFieldPolicy = {
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureResponseKeySpecifier = ('approvalReason' | 'approvalStatus' | 'chatRoomSecret' | 'commentCount' | 'contactEmail' | 'createdAt' | 'createdByFirstName' | 'createdByLastName' | 'createdByUuid' | 'disclosure' | 'disclosureJson' | 'disclosureUuid' | 'isNew' | 'json' | 'phoneNumber' | 'source' | 'uuid' | DisclosureResponseKeySpecifier)[];
export type DisclosureResponseFieldPolicy = {
	approvalReason?: FieldPolicy<any> | FieldReadFunction<any>,
	approvalStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	chatRoomSecret?: FieldPolicy<any> | FieldReadFunction<any>,
	commentCount?: FieldPolicy<any> | FieldReadFunction<any>,
	contactEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByFirstName?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByLastName?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosure?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureJson?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	isNew?: FieldPolicy<any> | FieldReadFunction<any>,
	json?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureResponseCommentKeySpecifier = ('approvalStatus' | 'commentedBy' | 'content' | 'createdAt' | 'createdBy' | 'isEdited' | 'isMyComment' | 'updatedAt' | 'uuid' | DisclosureResponseCommentKeySpecifier)[];
export type DisclosureResponseCommentFieldPolicy = {
	approvalStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	commentedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	isEdited?: FieldPolicy<any> | FieldReadFunction<any>,
	isMyComment?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureResponseCommentEdgeKeySpecifier = ('cursor' | 'node' | DisclosureResponseCommentEdgeKeySpecifier)[];
export type DisclosureResponseCommentEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureResponseCommentPageKeySpecifier = ('edges' | 'info' | DisclosureResponseCommentPageKeySpecifier)[];
export type DisclosureResponseCommentPageFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	info?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureResponseConnectionKeySpecifier = ('disclosureData' | 'edges' | 'nodes' | 'pageInfo' | 'totalCount' | DisclosureResponseConnectionKeySpecifier)[];
export type DisclosureResponseConnectionFieldPolicy = {
	disclosureData?: FieldPolicy<any> | FieldReadFunction<any>,
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureResponseEdgeKeySpecifier = ('cursor' | 'node' | DisclosureResponseEdgeKeySpecifier)[];
export type DisclosureResponseEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureResponsePageKeySpecifier = ('edges' | 'info' | DisclosureResponsePageKeySpecifier)[];
export type DisclosureResponsePageFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	info?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureResponsesPaginatedKeySpecifier = ('disclosureData' | 'disclosureJson' | 'page' | 'totalCount' | DisclosureResponsesPaginatedKeySpecifier)[];
export type DisclosureResponsesPaginatedFieldPolicy = {
	disclosureData?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureJson?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureStatisticsKeySpecifier = ('approvedCount' | 'disclosuresCount' | 'newAnswersCount' | 'responsesCount' | 'usersCount' | DisclosureStatisticsKeySpecifier)[];
export type DisclosureStatisticsFieldPolicy = {
	approvedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosuresCount?: FieldPolicy<any> | FieldReadFunction<any>,
	newAnswersCount?: FieldPolicy<any> | FieldReadFunction<any>,
	responsesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	usersCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureUserKeySpecifier = ('approvedCount' | 'contactEmail' | 'country' | 'disapprovedCount' | 'firstName' | 'hasNewAnswers' | 'lastName' | 'lastSubmittedDate' | 'organizationName' | 'organizationRole' | 'phoneNumber' | 'responses' | 'submittedResponsesCount' | 'uuid' | DisclosureUserKeySpecifier)[];
export type DisclosureUserFieldPolicy = {
	approvedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	contactEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	disapprovedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNewAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastSubmittedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationName?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationRole?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	responses?: FieldPolicy<any> | FieldReadFunction<any>,
	submittedResponsesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureUserConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | DisclosureUserConnectionKeySpecifier)[];
export type DisclosureUserConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureUserEdgeKeySpecifier = ('cursor' | 'node' | DisclosureUserEdgeKeySpecifier)[];
export type DisclosureUserEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ESGGroupTagEdgeKeySpecifier = ('cursor' | 'node' | ESGGroupTagEdgeKeySpecifier)[];
export type ESGGroupTagEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ElineConversationKeySpecifier = ('caseUuid' | 'transcription' | 'transcriptionTranslated' | ElineConversationKeySpecifier)[];
export type ElineConversationFieldPolicy = {
	caseUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	transcription?: FieldPolicy<any> | FieldReadFunction<any>,
	transcriptionTranslated?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ElineNumberKeySpecifier = ('assignedCountry' | 'createdAt' | 'defaultCountry' | 'lastUpdatedAt' | 'number' | 'uuid' | ElineNumberKeySpecifier)[];
export type ElineNumberFieldPolicy = {
	assignedCountry?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultCountry?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	number?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ElinePhoneNumberKeySpecifier = ('number' | ElinePhoneNumberKeySpecifier)[];
export type ElinePhoneNumberFieldPolicy = {
	number?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmailEntryKeySpecifier = ('createdAt' | 'email' | 'listUuid' | 'updatedAt' | 'uuid' | EmailEntryKeySpecifier)[];
export type EmailEntryFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	listUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmailEntryEditResultKeySpecifier = ('deletedEntryUuid' | 'entry' | EmailEntryEditResultKeySpecifier)[];
export type EmailEntryEditResultFieldPolicy = {
	deletedEntryUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	entry?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmailListKeySpecifier = ('active' | 'createdAt' | 'entries' | 'entriesCount' | 'name' | 'updatedAt' | 'uuid' | EmailListKeySpecifier)[];
export type EmailListFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	entries?: FieldPolicy<any> | FieldReadFunction<any>,
	entriesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmailListConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | EmailListConnectionKeySpecifier)[];
export type EmailListConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmailListEdgeKeySpecifier = ('cursor' | 'node' | EmailListEdgeKeySpecifier)[];
export type EmailListEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmailMessageParsedResponseKeySpecifier = ('body' | 'subject' | EmailMessageParsedResponseKeySpecifier)[];
export type EmailMessageParsedResponseFieldPolicy = {
	body?: FieldPolicy<any> | FieldReadFunction<any>,
	subject?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmailTemplateKeySpecifier = ('body' | 'changedActive' | 'isActive' | 'isCarbonCopyEnabled' | 'label' | 'recipients' | 'subject' | 'type' | 'variables' | EmailTemplateKeySpecifier)[];
export type EmailTemplateFieldPolicy = {
	body?: FieldPolicy<any> | FieldReadFunction<any>,
	changedActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isCarbonCopyEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	recipients?: FieldPolicy<any> | FieldReadFunction<any>,
	subject?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	variables?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmailTemplateRecipientsKeySpecifier = ('cc' | 'to' | EmailTemplateRecipientsKeySpecifier)[];
export type EmailTemplateRecipientsFieldPolicy = {
	cc?: FieldPolicy<any> | FieldReadFunction<any>,
	to?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EnabledSsoMethodsForTenantKeySpecifier = ('azure' | 'saml' | EnabledSsoMethodsForTenantKeySpecifier)[];
export type EnabledSsoMethodsForTenantFieldPolicy = {
	azure?: FieldPolicy<any> | FieldReadFunction<any>,
	saml?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgActivitiesForActivityReportKeySpecifier = ('name' | 'topicsCount' | EsgActivitiesForActivityReportKeySpecifier)[];
export type EsgActivitiesForActivityReportFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	topicsCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgAnswerKeySpecifier = ('answer' | 'assignedTags' | 'chatbot' | 'createdAt' | 'createdBy' | 'embeddedTags' | 'files' | 'images' | 'isDefault' | 'isLinked' | 'linkedMetrics' | 'question' | 'tasks' | 'updatedAt' | 'updatedBy' | 'uuid' | 'version' | 'versionTag' | 'year' | EsgAnswerKeySpecifier)[];
export type EsgAnswerFieldPolicy = {
	answer?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedTags?: FieldPolicy<any> | FieldReadFunction<any>,
	chatbot?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	embeddedTags?: FieldPolicy<any> | FieldReadFunction<any>,
	files?: FieldPolicy<any> | FieldReadFunction<any>,
	images?: FieldPolicy<any> | FieldReadFunction<any>,
	isDefault?: FieldPolicy<any> | FieldReadFunction<any>,
	isLinked?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedMetrics?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>,
	tasks?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>,
	versionTag?: FieldPolicy<any> | FieldReadFunction<any>,
	year?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgAnswerGenerateResultKeySpecifier = ('generatedAnswer' | 'question' | EsgAnswerGenerateResultKeySpecifier)[];
export type EsgAnswerGenerateResultFieldPolicy = {
	generatedAnswer?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgAnswerTagsKeySpecifier = ('groupTag' | 'tagCount' | 'tags' | EsgAnswerTagsKeySpecifier)[];
export type EsgAnswerTagsFieldPolicy = {
	groupTag?: FieldPolicy<any> | FieldReadFunction<any>,
	tagCount?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgCategoryKeySpecifier = ('description' | 'name' | 'riskAreas' | 'statistics' | 'subcategories' | 'type' | 'uuid' | EsgCategoryKeySpecifier)[];
export type EsgCategoryFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>,
	subcategories?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgFileKeySpecifier = ('answers' | 'mimeType' | 'name' | 'size' | 'uploadedBy' | 'url' | 'uuid' | EsgFileKeySpecifier)[];
export type EsgFileFieldPolicy = {
	answers?: FieldPolicy<any> | FieldReadFunction<any>,
	mimeType?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	size?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgGroupTagConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | EsgGroupTagConnectionKeySpecifier)[];
export type EsgGroupTagConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgGroupedStatisticsKeySpecifier = ('id' | 'standard' | 'statistics' | EsgGroupedStatisticsKeySpecifier)[];
export type EsgGroupedStatisticsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	standard?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgHistoryElementKeySpecifier = ('createdAt' | 'editedBy' | 'uuid' | EsgHistoryElementKeySpecifier)[];
export type EsgHistoryElementFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	editedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgQuestionKeySpecifier = ('activity' | 'answerForVersion' | 'answers' | 'answersCount' | 'auditEvents' | 'defaultAnswer' | 'files' | 'filesCount' | 'header' | 'isAnswered' | 'isLinked' | 'lastActivityDate' | 'linkedMetrics' | 'metadata' | 'navigationTitle' | 'order' | 'question' | 'questionActivity' | 'status' | 'step' | 'tasks' | 'templateURL' | 'uuid' | 'videoTitle' | 'videoURL' | EsgQuestionKeySpecifier)[];
export type EsgQuestionFieldPolicy = {
	activity?: FieldPolicy<any> | FieldReadFunction<any>,
	answerForVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	answers?: FieldPolicy<any> | FieldReadFunction<any>,
	answersCount?: FieldPolicy<any> | FieldReadFunction<any>,
	auditEvents?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultAnswer?: FieldPolicy<any> | FieldReadFunction<any>,
	files?: FieldPolicy<any> | FieldReadFunction<any>,
	filesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	header?: FieldPolicy<any> | FieldReadFunction<any>,
	isAnswered?: FieldPolicy<any> | FieldReadFunction<any>,
	isLinked?: FieldPolicy<any> | FieldReadFunction<any>,
	lastActivityDate?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedMetrics?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	navigationTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>,
	questionActivity?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	step?: FieldPolicy<any> | FieldReadFunction<any>,
	tasks?: FieldPolicy<any> | FieldReadFunction<any>,
	templateURL?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	videoTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	videoURL?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgQuestionConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | EsgQuestionConnectionKeySpecifier)[];
export type EsgQuestionConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgQuestionEdgeKeySpecifier = ('cursor' | 'node' | EsgQuestionEdgeKeySpecifier)[];
export type EsgQuestionEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgQuestionMetadataKeySpecifier = ('id' | 'metadata' | 'standard' | EsgQuestionMetadataKeySpecifier)[];
export type EsgQuestionMetadataFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	standard?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgQuestionRiskAreaMetadataKeySpecifier = ('guidelinePath' | 'id' | 'tagData' | 'unit' | EsgQuestionRiskAreaMetadataKeySpecifier)[];
export type EsgQuestionRiskAreaMetadataFieldPolicy = {
	guidelinePath?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	tagData?: FieldPolicy<any> | FieldReadFunction<any>,
	unit?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgQuestionSearchConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | EsgQuestionSearchConnectionKeySpecifier)[];
export type EsgQuestionSearchConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgQuestionTagMetadataKeySpecifier = ('guidelinePath' | 'id' | 'tag' | EsgQuestionTagMetadataKeySpecifier)[];
export type EsgQuestionTagMetadataFieldPolicy = {
	guidelinePath?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	tag?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgQuestionTagsMetadataKeySpecifier = ('groupTag' | 'guidelinePath' | 'id' | 'tags' | 'totalCount' | EsgQuestionTagsMetadataKeySpecifier)[];
export type EsgQuestionTagsMetadataFieldPolicy = {
	groupTag?: FieldPolicy<any> | FieldReadFunction<any>,
	guidelinePath?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgQuestionnaireFiltersKeySpecifier = ('answered' | 'standards' | 'unanswered' | EsgQuestionnaireFiltersKeySpecifier)[];
export type EsgQuestionnaireFiltersFieldPolicy = {
	answered?: FieldPolicy<any> | FieldReadFunction<any>,
	standards?: FieldPolicy<any> | FieldReadFunction<any>,
	unanswered?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgRiskAreaSettingByProgramKeySpecifier = ('isEnabled' | 'name' | 'uuid' | EsgRiskAreaSettingByProgramKeySpecifier)[];
export type EsgRiskAreaSettingByProgramFieldPolicy = {
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgRiskAreaSettingsByProgramKeySpecifier = ('programUuid' | 'riskAreaSettings' | 'tenantUuid' | EsgRiskAreaSettingsByProgramKeySpecifier)[];
export type EsgRiskAreaSettingsByProgramFieldPolicy = {
	programUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgRolePermissionKeySpecifier = ('permission' | 'riskArea' | 'uuid' | EsgRolePermissionKeySpecifier)[];
export type EsgRolePermissionFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	riskArea?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgSmartFillDraftAnswerKeySpecifier = ('confidence' | 'draftAnswer' | 'isAiDraft' | 'question' | 'sources' | 'status' | EsgSmartFillDraftAnswerKeySpecifier)[];
export type EsgSmartFillDraftAnswerFieldPolicy = {
	confidence?: FieldPolicy<any> | FieldReadFunction<any>,
	draftAnswer?: FieldPolicy<any> | FieldReadFunction<any>,
	isAiDraft?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>,
	sources?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgSmartFillJobKeySpecifier = ('drafts' | 'programme' | 'riskArea' | 'status' | 'uuid' | EsgSmartFillJobKeySpecifier)[];
export type EsgSmartFillJobFieldPolicy = {
	drafts?: FieldPolicy<any> | FieldReadFunction<any>,
	programme?: FieldPolicy<any> | FieldReadFunction<any>,
	riskArea?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgSmartFillSourceKeySpecifier = ('file' | 'sectionOrExcerpt' | 'type' | EsgSmartFillSourceKeySpecifier)[];
export type EsgSmartFillSourceFieldPolicy = {
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionOrExcerpt?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgStandardKeySpecifier = ('enabled' | 'name' | 'uuid' | EsgStandardKeySpecifier)[];
export type EsgStandardFieldPolicy = {
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgStandardWithConnectedRiskAreasKeySpecifier = ('name' | 'uuid' | EsgStandardWithConnectedRiskAreasKeySpecifier)[];
export type EsgStandardWithConnectedRiskAreasFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgStatisticsKeySpecifier = ('answeredQuestions' | 'id' | 'totalQuestions' | EsgStatisticsKeySpecifier)[];
export type EsgStatisticsFieldPolicy = {
	answeredQuestions?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	totalQuestions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgStepKeySpecifier = ('id' | 'isAnswered' | 'name' | 'order' | 'questions' | 'riskArea' | 'uuid' | EsgStepKeySpecifier)[];
export type EsgStepFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isAnswered?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	questions?: FieldPolicy<any> | FieldReadFunction<any>,
	riskArea?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgSubcategoryKeySpecifier = ('category' | 'categoryUuid' | 'history' | 'lastActiveDate' | 'name' | 'order' | 'uuid' | EsgSubcategoryKeySpecifier)[];
export type EsgSubcategoryFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	history?: FieldPolicy<any> | FieldReadFunction<any>,
	lastActiveDate?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgTagConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | EsgTagConnectionKeySpecifier)[];
export type EsgTagConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgTagEdgeKeySpecifier = ('cursor' | 'node' | EsgTagEdgeKeySpecifier)[];
export type EsgTagEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgTaskDisabledReasonKeySpecifier = ('conditionalSectors' | 'riskArea' | 'riskAreaDisabled' | 'sectors' | 'standard' | 'standardDisabled' | 'unitDisabled' | 'units' | EsgTaskDisabledReasonKeySpecifier)[];
export type EsgTaskDisabledReasonFieldPolicy = {
	conditionalSectors?: FieldPolicy<any> | FieldReadFunction<any>,
	riskArea?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaDisabled?: FieldPolicy<any> | FieldReadFunction<any>,
	sectors?: FieldPolicy<any> | FieldReadFunction<any>,
	standard?: FieldPolicy<any> | FieldReadFunction<any>,
	standardDisabled?: FieldPolicy<any> | FieldReadFunction<any>,
	unitDisabled?: FieldPolicy<any> | FieldReadFunction<any>,
	units?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgTenantProgramSettingKeySpecifier = ('allRiskAreasCount' | 'category' | 'enabledRiskAreasCount' | 'isEnabled' | 'name' | 'uuid' | EsgTenantProgramSettingKeySpecifier)[];
export type EsgTenantProgramSettingFieldPolicy = {
	allRiskAreasCount?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	enabledRiskAreasCount?: FieldPolicy<any> | FieldReadFunction<any>,
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgTenantProgramSettingsKeySpecifier = ('settings' | 'tenantUuid' | EsgTenantProgramSettingsKeySpecifier)[];
export type EsgTenantProgramSettingsFieldPolicy = {
	settings?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgVideoKeySpecifier = ('videoTitle' | 'videoURL' | EsgVideoKeySpecifier)[];
export type EsgVideoFieldPolicy = {
	videoTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	videoURL?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgVideoConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | EsgVideoConnectionKeySpecifier)[];
export type EsgVideoConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EsgVideoEdgeKeySpecifier = ('cursor' | 'node' | EsgVideoEdgeKeySpecifier)[];
export type EsgVideoEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExclusionAdminUserConnectionKeySpecifier = ('edges' | 'isEnabled' | 'nodes' | 'pageInfo' | 'totalCount' | ExclusionAdminUserConnectionKeySpecifier)[];
export type ExclusionAdminUserConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExternalUserAvailableRiskAreaKeySpecifier = ('allRiskAreas' | 'hasUnmappedTask' | 'riskArea' | ExternalUserAvailableRiskAreaKeySpecifier)[];
export type ExternalUserAvailableRiskAreaFieldPolicy = {
	allRiskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	hasUnmappedTask?: FieldPolicy<any> | FieldReadFunction<any>,
	riskArea?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FeatureSettingKeySpecifier = ('enabled' | 'module' | 'moduleUuid' | 'name' | 'uuid' | FeatureSettingKeySpecifier)[];
export type FeatureSettingFieldPolicy = {
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	module?: FieldPolicy<any> | FieldReadFunction<any>,
	moduleUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FilterQuestionStatusesKeySpecifier = ('answered' | 'inProgress' | 'unanswered' | FilterQuestionStatusesKeySpecifier)[];
export type FilterQuestionStatusesFieldPolicy = {
	answered?: FieldPolicy<any> | FieldReadFunction<any>,
	inProgress?: FieldPolicy<any> | FieldReadFunction<any>,
	unanswered?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FilterQuestionTaskRelationKeySpecifier = ('withTasks' | 'withoutTasks' | FilterQuestionTaskRelationKeySpecifier)[];
export type FilterQuestionTaskRelationFieldPolicy = {
	withTasks?: FieldPolicy<any> | FieldReadFunction<any>,
	withoutTasks?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FilterTaskStatusesKeySpecifier = ('completed' | 'inProgress' | 'open' | FilterTaskStatusesKeySpecifier)[];
export type FilterTaskStatusesFieldPolicy = {
	completed?: FieldPolicy<any> | FieldReadFunction<any>,
	inProgress?: FieldPolicy<any> | FieldReadFunction<any>,
	open?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FirebaseResponseKeySpecifier = ('type' | 'value' | FirebaseResponseKeySpecifier)[];
export type FirebaseResponseFieldPolicy = {
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FirebaseTokenKeySpecifier = ('token' | FirebaseTokenKeySpecifier)[];
export type FirebaseTokenFieldPolicy = {
	token?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FirebaseTopicSubscriptionKeySpecifier = ('createdAt' | 'lastUpdatedAt' | 'type' | 'uuid' | 'value' | FirebaseTopicSubscriptionKeySpecifier)[];
export type FirebaseTopicSubscriptionFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ForwardEarthCredentialsKeySpecifier = ('apiKey' | 'forwardEarthApiKeyUuid' | 'forwardEarthTenantUuid' | 'instanceUrl' | 'tenantUuid' | 'uuid' | ForwardEarthCredentialsKeySpecifier)[];
export type ForwardEarthCredentialsFieldPolicy = {
	apiKey?: FieldPolicy<any> | FieldReadFunction<any>,
	forwardEarthApiKeyUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	forwardEarthTenantUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	instanceUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GlobalTenantBaseDataKeySpecifier = ('apiUrl' | 'clusterId' | 'code' | 'name' | 'spreadsheetApiUrl' | 'subsidiarySiteUuid' | 'uuid' | GlobalTenantBaseDataKeySpecifier)[];
export type GlobalTenantBaseDataFieldPolicy = {
	apiUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	clusterId?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	spreadsheetApiUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySiteUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GlossaryConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | GlossaryConnectionKeySpecifier)[];
export type GlossaryConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GlossaryEntryKeySpecifier = ('description' | 'subject' | 'uuid' | GlossaryEntryKeySpecifier)[];
export type GlossaryEntryFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	subject?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GlossaryEntryEdgeKeySpecifier = ('cursor' | 'node' | GlossaryEntryEdgeKeySpecifier)[];
export type GlossaryEntryEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupTagKeySpecifier = ('childGroupTags' | 'color' | 'colorBackground' | 'colorPrimary' | 'colorSecondary' | 'createdAt' | 'createdBy' | 'esgMetadata' | 'isAssigned' | 'isPublic' | 'name' | 'parentGroupTag' | 'riskArea' | 'tags' | 'tenant' | 'updatedAt' | 'updatedBy' | 'uuid' | GroupTagKeySpecifier)[];
export type GroupTagFieldPolicy = {
	childGroupTags?: FieldPolicy<any> | FieldReadFunction<any>,
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	colorBackground?: FieldPolicy<any> | FieldReadFunction<any>,
	colorPrimary?: FieldPolicy<any> | FieldReadFunction<any>,
	colorSecondary?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	esgMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	isAssigned?: FieldPolicy<any> | FieldReadFunction<any>,
	isPublic?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	parentGroupTag?: FieldPolicy<any> | FieldReadFunction<any>,
	riskArea?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupTagConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | GroupTagConnectionKeySpecifier)[];
export type GroupTagConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupTagEdgeKeySpecifier = ('cursor' | 'node' | GroupTagEdgeKeySpecifier)[];
export type GroupTagEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupTagEsgMetadataKeySpecifier = ('tagDescriptionPlaceholder' | 'tagPlaceholder' | GroupTagEsgMetadataKeySpecifier)[];
export type GroupTagEsgMetadataFieldPolicy = {
	tagDescriptionPlaceholder?: FieldPolicy<any> | FieldReadFunction<any>,
	tagPlaceholder?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupTagRowKeySpecifier = ('groupTag' | 'id' | 'tag' | GroupTagRowKeySpecifier)[];
export type GroupTagRowFieldPolicy = {
	groupTag?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	tag?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupTagRowConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | GroupTagRowConnectionKeySpecifier)[];
export type GroupTagRowConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupTagRowEdgeKeySpecifier = ('cursor' | 'node' | GroupTagRowEdgeKeySpecifier)[];
export type GroupTagRowEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GuidelineKeySpecifier = ('categoryName' | 'label' | 'markdown' | 'name' | 'order' | 'path' | 'riskArea' | 'subcategories' | 'subcategoriesCount' | 'unit' | 'uuid' | GuidelineKeySpecifier)[];
export type GuidelineFieldPolicy = {
	categoryName?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	markdown?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	path?: FieldPolicy<any> | FieldReadFunction<any>,
	riskArea?: FieldPolicy<any> | FieldReadFunction<any>,
	subcategories?: FieldPolicy<any> | FieldReadFunction<any>,
	subcategoriesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	unit?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GuidelineConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | GuidelineConnectionKeySpecifier)[];
export type GuidelineConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GuidelineEdgeKeySpecifier = ('cursor' | 'node' | GuidelineEdgeKeySpecifier)[];
export type GuidelineEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IncidentAnonymityRestrictionKeySpecifier = ('isRestricted' | 'name' | 'uuid' | IncidentAnonymityRestrictionKeySpecifier)[];
export type IncidentAnonymityRestrictionFieldPolicy = {
	isRestricted?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IncidentTypeKeySpecifier = ('description' | 'descriptionTranslated' | 'name' | 'nameTranslated' | 'uuid' | IncidentTypeKeySpecifier)[];
export type IncidentTypeFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	descriptionTranslated?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	nameTranslated?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IncidentTypeAnonymityKeySpecifier = ('isEnabled' | 'name' | 'uuid' | IncidentTypeAnonymityKeySpecifier)[];
export type IncidentTypeAnonymityFieldPolicy = {
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IncidentTypeConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | IncidentTypeConnectionKeySpecifier)[];
export type IncidentTypeConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IncidentTypeEdgeKeySpecifier = ('cursor' | 'node' | IncidentTypeEdgeKeySpecifier)[];
export type IncidentTypeEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IndividualInvolvedKeySpecifier = ('businessUnit' | 'email' | 'emailSentAt' | 'firstName' | 'lastName' | 'position' | 'relationship' | 'type' | 'uuid' | IndividualInvolvedKeySpecifier)[];
export type IndividualInvolvedFieldPolicy = {
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	emailSentAt?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	relationship?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IndustryUnitConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | IndustryUnitConnectionKeySpecifier)[];
export type IndustryUnitConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InsightsFileKeySpecifier = ('mimeType' | 'name' | 'size' | 'uploadedBy' | 'url' | 'uuid' | InsightsFileKeySpecifier)[];
export type InsightsFileFieldPolicy = {
	mimeType?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	size?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type KnowledgeLibraryAssetsKeySpecifier = ('answerGenerateExample' | 'knowledgeLibraryUploadExample' | KnowledgeLibraryAssetsKeySpecifier)[];
export type KnowledgeLibraryAssetsFieldPolicy = {
	answerGenerateExample?: FieldPolicy<any> | FieldReadFunction<any>,
	knowledgeLibraryUploadExample?: FieldPolicy<any> | FieldReadFunction<any>
};
export type KnowledgeLibraryConnectionStatisticsKeySpecifier = ('answeredCount' | 'categories' | 'categoryCount' | KnowledgeLibraryConnectionStatisticsKeySpecifier)[];
export type KnowledgeLibraryConnectionStatisticsFieldPolicy = {
	answeredCount?: FieldPolicy<any> | FieldReadFunction<any>,
	categories?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type KnowledgeLibraryGeneratedAnswerKeySpecifier = ('answer' | 'answerOptions' | 'category' | 'confidenceReason' | 'confidenceScore' | 'question' | 'reasoning' | 'riskAreas' | 'rowId' | 'sourcesUsed' | KnowledgeLibraryGeneratedAnswerKeySpecifier)[];
export type KnowledgeLibraryGeneratedAnswerFieldPolicy = {
	answer?: FieldPolicy<any> | FieldReadFunction<any>,
	answerOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	confidenceReason?: FieldPolicy<any> | FieldReadFunction<any>,
	confidenceScore?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>,
	reasoning?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	rowId?: FieldPolicy<any> | FieldReadFunction<any>,
	sourcesUsed?: FieldPolicy<any> | FieldReadFunction<any>
};
export type KnowledgeLibraryOptionsQuestionKeySpecifier = ('answer' | 'answerOptions' | 'category' | 'createdAt' | 'createdBy' | 'lastUpdatedAt' | 'lastUpdatedBy' | 'question' | 'uuid' | KnowledgeLibraryOptionsQuestionKeySpecifier)[];
export type KnowledgeLibraryOptionsQuestionFieldPolicy = {
	answer?: FieldPolicy<any> | FieldReadFunction<any>,
	answerOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type KnowledgeLibraryQuestionKeySpecifier = ('answer' | 'category' | 'createdAt' | 'createdBy' | 'lastUpdatedAt' | 'lastUpdatedBy' | 'question' | 'uuid' | KnowledgeLibraryQuestionKeySpecifier)[];
export type KnowledgeLibraryQuestionFieldPolicy = {
	answer?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type KnowledgeLibraryQuestionConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'statistics' | 'totalCount' | KnowledgeLibraryQuestionConnectionKeySpecifier)[];
export type KnowledgeLibraryQuestionConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type KnowledgeLibraryQuestionEdgeKeySpecifier = ('cursor' | 'node' | KnowledgeLibraryQuestionEdgeKeySpecifier)[];
export type KnowledgeLibraryQuestionEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type KnowledgeLibraryScalarQuestionKeySpecifier = ('answer' | 'category' | 'createdAt' | 'createdBy' | 'lastUpdatedAt' | 'lastUpdatedBy' | 'question' | 'uuid' | KnowledgeLibraryScalarQuestionKeySpecifier)[];
export type KnowledgeLibraryScalarQuestionFieldPolicy = {
	answer?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LicenseKeySpecifier = ('allLicenses' | 'availableLimitedLicenses' | 'availableStandardLicenses' | 'totalLimitedLicenses' | 'totalStandardLicenses' | 'usedLimitedLicenses' | 'usedLimitedLicensesRaw' | 'usedStandardLicenses' | 'usedStandardLicensesRaw' | LicenseKeySpecifier)[];
export type LicenseFieldPolicy = {
	allLicenses?: FieldPolicy<any> | FieldReadFunction<any>,
	availableLimitedLicenses?: FieldPolicy<any> | FieldReadFunction<any>,
	availableStandardLicenses?: FieldPolicy<any> | FieldReadFunction<any>,
	totalLimitedLicenses?: FieldPolicy<any> | FieldReadFunction<any>,
	totalStandardLicenses?: FieldPolicy<any> | FieldReadFunction<any>,
	usedLimitedLicenses?: FieldPolicy<any> | FieldReadFunction<any>,
	usedLimitedLicensesRaw?: FieldPolicy<any> | FieldReadFunction<any>,
	usedStandardLicenses?: FieldPolicy<any> | FieldReadFunction<any>,
	usedStandardLicensesRaw?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LinkAnswersToMetricResultKeySpecifier = ('metricUuid' | LinkAnswersToMetricResultKeySpecifier)[];
export type LinkAnswersToMetricResultFieldPolicy = {
	metricUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LinkMetricsToAnswerResultKeySpecifier = ('answerUuid' | 'questionUuid' | LinkMetricsToAnswerResultKeySpecifier)[];
export type LinkMetricsToAnswerResultFieldPolicy = {
	answerUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	questionUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetadataKeySpecifier = ('requireSetup' | 'type' | 'uuid' | MetadataKeySpecifier)[];
export type MetadataFieldPolicy = {
	requireSetup?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MethodTypeKeySpecifier = ('confirmedAt' | 'qrCode' | 'secret' | 'type' | 'userUuid' | 'uuid' | MethodTypeKeySpecifier)[];
export type MethodTypeFieldPolicy = {
	confirmedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	qrCode?: FieldPolicy<any> | FieldReadFunction<any>,
	secret?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	userUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetricKeySpecifier = ('availableYears' | 'createdBy' | 'description' | 'isFavourite' | 'isLinked' | 'lastUpdatedBy' | 'linkedQuestions' | 'metricSource' | 'metricsData' | 'name' | 'owner' | 'riskArea' | 'riskAreas' | 'uuid' | MetricKeySpecifier)[];
export type MetricFieldPolicy = {
	availableYears?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	isFavourite?: FieldPolicy<any> | FieldReadFunction<any>,
	isLinked?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedQuestions?: FieldPolicy<any> | FieldReadFunction<any>,
	metricSource?: FieldPolicy<any> | FieldReadFunction<any>,
	metricsData?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	owner?: FieldPolicy<any> | FieldReadFunction<any>,
	riskArea?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetricConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | MetricConnectionKeySpecifier)[];
export type MetricConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetricDataKeySpecifier = ('createdBy' | 'data' | 'settings' | 'updatedBy' | 'uuid' | 'year' | MetricDataKeySpecifier)[];
export type MetricDataFieldPolicy = {
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	settings?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	year?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetricDataColumnSelectorKeySpecifier = ('columnName' | 'id' | MetricDataColumnSelectorKeySpecifier)[];
export type MetricDataColumnSelectorFieldPolicy = {
	columnName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetricDataSelectorKeySpecifier = ('id' | 'rowName' | 'subRowName' | MetricDataSelectorKeySpecifier)[];
export type MetricDataSelectorFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	rowName?: FieldPolicy<any> | FieldReadFunction<any>,
	subRowName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetricDataYearKeySpecifier = ('id' | 'year' | MetricDataYearKeySpecifier)[];
export type MetricDataYearFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	year?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetricEdgeKeySpecifier = ('cursor' | 'node' | MetricEdgeKeySpecifier)[];
export type MetricEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetricLinkedQuestionKeySpecifier = ('linkedAnswers' | 'question' | MetricLinkedQuestionKeySpecifier)[];
export type MetricLinkedQuestionFieldPolicy = {
	linkedAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MfaKeySpecifier = ('requireSetup' | 'type' | 'uuid' | MfaKeySpecifier)[];
export type MfaFieldPolicy = {
	requireSetup?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ModuleSettingKeySpecifier = ('enabled' | 'features' | 'name' | 'plan' | 'planUuid' | 'uuid' | ModuleSettingKeySpecifier)[];
export type ModuleSettingFieldPolicy = {
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	features?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	plan?: FieldPolicy<any> | FieldReadFunction<any>,
	planUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ModuleSettingsKeySpecifier = ('carbonLens' | 'cases' | 'demo' | 'disclosures' | 'dueDiligence' | 'esg' | 'insights' | 'nicoleGpt' | 'sso' | 'subsidiarySites' | 'surveys' | 'tasks' | 'teams' | 'trainings' | ModuleSettingsKeySpecifier)[];
export type ModuleSettingsFieldPolicy = {
	carbonLens?: FieldPolicy<any> | FieldReadFunction<any>,
	cases?: FieldPolicy<any> | FieldReadFunction<any>,
	demo?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosures?: FieldPolicy<any> | FieldReadFunction<any>,
	dueDiligence?: FieldPolicy<any> | FieldReadFunction<any>,
	esg?: FieldPolicy<any> | FieldReadFunction<any>,
	insights?: FieldPolicy<any> | FieldReadFunction<any>,
	nicoleGpt?: FieldPolicy<any> | FieldReadFunction<any>,
	sso?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySites?: FieldPolicy<any> | FieldReadFunction<any>,
	surveys?: FieldPolicy<any> | FieldReadFunction<any>,
	tasks?: FieldPolicy<any> | FieldReadFunction<any>,
	teams?: FieldPolicy<any> | FieldReadFunction<any>,
	trainings?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationKeySpecifier = ('adminUserDelete' | 'adminUserUpsert' | 'bannedEmailBatchStatusChange' | 'bannedEmailDelete' | 'bannedEmailStatusChange' | 'bannedEmailUpsert' | 'biometricsClear' | 'biometricsSetup' | 'callsCaseCreate' | 'callsCaseUpdate' | 'carbonLensFinalizeSSO' | 'carbonLensInitializeSSO' | 'caseActivityCreate' | 'caseActivitySettingsBatchUpsert' | 'caseActivitySettingsUpsert' | 'caseAnalyticsReportPdf' | 'caseAnonymitySettingsDelete' | 'caseAssignmentDelete' | 'caseAssignmentUpsert' | 'caseAttachmentUpload' | 'caseBusinessUnitAssign' | 'caseClose' | 'caseConversationUpdate' | 'caseCustomReminderDelete' | 'caseCustomReminderUpsert' | 'caseCustomTitleUpdate' | 'caseDetailsUpdate' | 'caseIncidentTypeAssign' | 'caseIndividualInvolvedMessageSend' | 'caseIndividualInvolvedUpsert' | 'caseIndividualsInvolvedDelete' | 'caseInvestigationPdfReportGenerate' | 'caseInvestigationsXlsxReportGenerate' | 'caseInvestigatorsUpdate' | 'caseOwnerExclusionUpsert' | 'caseOwnerExclusionsDelete' | 'caseReopen' | 'caseReportCreate' | 'caseSettingsUpdate' | 'caseTriageScoreUpdate' | 'casesSubsidiarySiteUpdate' | 'changeDisclosureStatus' | 'changePassword' | 'changeSurveyReminder' | 'changeSurveyStatus' | 'chatRoomFilesUpload' | 'chatbotCreate' | 'chatbotMessageCreate' | 'checkPasswordResetToken' | 'conclusionTypeBatchUpsert' | 'conclusionTypeUpsert' | 'confirmMfaSetup' | 'createAdminToken' | 'createAssistantSlot' | 'createBusinessUnit' | 'createEmployeeAccount' | 'customPlanUpdate' | 'dataCategoryCreate' | 'dataCategoryCreateMany' | 'deleteAssistantSlot' | 'deleteBannedEmail' | 'deleteDisclosureDraft' | 'deleteEmailEntry' | 'deleteEmailList' | 'deleteEmailTarget' | 'deleteEmployeeAccount' | 'deleteForwardEarthCredentials' | 'deleteTenantLogo' | 'disablePushNotificationsForDevice' | 'disclosureDelete' | 'disclosureResponseApprove' | 'disclosureResponseCommentUpsert' | 'disclosureRiskAreasUpsert' | 'disclosureUpsert' | 'disclosureUserFill' | 'editEmailEntry' | 'editEmailTarget' | 'elineNumberDelete' | 'elineNumberUpsert' | 'emailListDelete' | 'emailListUpsert' | 'emailTemplateCarbonCopyUpdate' | 'emailTemplateUpdate' | 'emailTemplatesStatusUpdate' | 'enablePushNotificationsForDevice' | 'esgActivityReportGenerate' | 'esgAnswerDelete' | 'esgAnswerFilesSet' | 'esgAnswerGenerate' | 'esgAnswerUpsert' | 'esgAnswerUpsertByUuid' | 'esgAnswerUpsertByVersionData' | 'esgAuditReportGenerate' | 'esgCountryReportGenerate' | 'esgEsrsReportGenerate' | 'esgFilesUpload' | 'esgGriReportGenerate' | 'esgQuestionAssignFiles' | 'esgQuestionUnassignFiles' | 'esgQuestionUpdate' | 'esgSmartFillStart' | 'esgStakeholderReportGenerate' | 'esgStandardReportGenerate' | 'exchangeAzureSingleSignOnToken' | 'exportMetric' | 'fetchDisclosureReport' | 'fetchPdfSurveyReport' | 'fetchWhistleblowerCaseReportPdf' | 'forwardEarthDataFetch' | 'generateAiReport' | 'genericPlanUpdate' | 'getFirebaseToken' | 'glossaryInsert' | 'graphStorageUpdate' | 'groupTagUpsert' | 'groupTagsDelete' | 'guidelineDelete' | 'guidelineUpsert' | 'hotspotBurn' | 'hotspotBurnAll' | 'hotspotReset' | 'initFirebaseChatRoom' | 'ixbrlGenerate' | 'knowledgeLibraryDeleteMany' | 'knowledgeLibraryGenerateAnswers' | 'knowledgeLibraryUpsert' | 'linkAnswersToMetric' | 'linkMetricsToAnswer' | 'linkMetricsToAnswerByUuidOrVersion' | 'loginAdmin' | 'loginAzureSso' | 'loginBiometrics' | 'loginExternal' | 'loginGuest' | 'loginPassword' | 'loginSpreadsheetServer' | 'loginWithMfa' | 'markAllNotificationsAsRead' | 'markAllNotificationsAsUnread' | 'markNotificationsAsRead' | 'markNotificationsAsUnread' | 'markQuestionAsAnswered' | 'metricDataDeleteByUuid' | 'metricDataUpsert' | 'metricDeleteByUuid' | 'metricFavouriteToggle' | 'metricUpsert' | 'mfaResetConfirm' | 'mfaResetRequest' | 'nicoleAvatarDelete' | 'nicoleAvatarSettingUpdate' | 'nicoleAvatarUpload' | 'nicoleGptSessionContinue' | 'nicoleGptSessionDescriptionUpdate' | 'nicoleGptSessionEntryRegenerate' | 'nicoleGptSessionInitialize' | 'nicoleGptSessionsDelete' | 'oAuthClientUpsert' | 'oAuthClientsDelete' | 'passwordResetAdmin' | 'planUpdate' | 'questionnaireFiltersSet' | 'refreshAdminSession' | 'refreshSession' | 'regionUpsert' | 'releaseNoteMarkRead' | 'releaseNoteUpsert' | 'removeTeamsId' | 'reportCaseFilesUpload' | 'reportCaseStart' | 'reportCaseSubmit' | 'reportCaseSummarize' | 'reportDeleteCaseFiles' | 'reportEditConversation' | 'reportPromptTemplateDelete' | 'reportPromptTemplateUpsert' | 'reportingGroupUpsert' | 'reportingGroupsDelete' | 'reportingPeriodSet' | 'reportingSourceBatchUpsert' | 'reportingSourceUpsert' | 'requestAccountUnlock' | 'requestMfaSetup' | 'requestPasswordReset' | 'requestPasswordResetAdmin' | 'resendAuthEmail' | 'resendCreateTenantEmail' | 'resetPassword' | 'respondQuestionnaireEntriesDelete' | 'respondQuestionnaireEntriesUpsert' | 'respondQuestionnaireUpsert' | 'respondQuestionnaireV2ChangeStatus' | 'respondQuestionnaireV2Create' | 'respondQuestionnaireV2Delete' | 'respondQuestionnaireV2EntriesDelete' | 'respondQuestionnaireV2EntriesUpdateByAddress' | 'respondQuestionnaireV2EntriesUpdateByUuid' | 'respondQuestionnaireV2EntryUpdateByAddress' | 'respondQuestionnaireV2EntryUpdateByUuid' | 'respondQuestionnaireV2MarkAsSaved' | 'respondQuestionnaireV2UpdateExcelFile' | 'respondQuestionnairesDelete' | 'riskAreaSettingsSet' | 'riskAreaUpdate' | 'rolesChangeStatus' | 'rolesDelete' | 'rolesUpsert' | 'sectorsSetState' | 'sendConversationMessage' | 'sendInvitationEmail' | 'setMsTenantID' | 'setRecoveryEmail' | 'setRecoveryEmailTenantAdmin' | 'setRiskAreaSettingsByProgram' | 'setTenantRiskAreaCustomLabel' | 'setTenantRiskAreaSettings' | 'setupAzureSingleSignOnForTenant' | 'skipMfa' | 'ssoAzureSetup' | 'ssoProviderDelete' | 'ssoProviderUpsert' | 'subscriptionRenewalRequest' | 'subsidiarySiteHeadquartersReportingLabelUpdate' | 'subsidiarySiteRoleUpdate' | 'subsidiarySiteStatusUpdate' | 'subsidiarySiteSwitch' | 'subsidiarySiteUpdate' | 'subsidiarySiteUpsert' | 'surveyRiskAreasUpsert' | 'surveySummary' | 'surveyTemplateUpsert' | 'surveyTemplatesDeletion' | 'surveyUpsert' | 'surveyUserFill' | 'surveysDeletion' | 'symbolDelete' | 'symbolUpsert' | 'tagCreateForVersion' | 'tagDescriptionDelete' | 'tagDescriptionUpdate' | 'tagUpdate' | 'tagUpsert' | 'tagsDelete' | 'tagsUpsert' | 'targetBatchDelete' | 'targetDelete' | 'targetUpsert' | 'taskDelete' | 'taskMarkAsSeen' | 'taskUpdateStatus' | 'taskUpsert' | 'taxonomyReportCreate' | 'taxonomyReportFactDelete' | 'taxonomyReportFactUpsert' | 'templateDelete' | 'templateRiskAreasUpsert' | 'templateUpsert' | 'tenantAdminInvite' | 'tenantAdminInviteFinish' | 'tenantAdminRegionsChange' | 'tenantAdminRolesUpdate' | 'tenantAdminUpdate' | 'tenantAdminsStatusesUpdate' | 'tenantBeginSetup' | 'tenantChangeStatus' | 'tenantCheckStatus' | 'tenantCountryUpdate' | 'tenantHeadlineRemove' | 'tenantHeadlineUpdate' | 'tenantInformationUpdate' | 'tenantLicenseCountUpdate' | 'tenantNameUpdate' | 'tenantPrimaryContactDataUpdate' | 'tenantSignup' | 'tenantStandardsStatusBatchUpdate' | 'tenantSubscriberEmailUpdate' | 'tenantSubscriptionDatesUpdate' | 'tenantSubscriptionUpdate' | 'tenantUnitsBatchUpdate' | 'tenantUpdateDefaultAnswerLabel' | 'tenantsDelete' | 'toggleProgramSetting' | 'translate' | 'unlinkMetricFromAnswer' | 'unlinkQuestionFromMetric' | 'unlockAccount' | 'updateAssistantCredentials' | 'updateAssistantSlot' | 'updateBusinessUnit' | 'updateRecoveryEmail' | 'updateTenant' | 'updateUserDetails' | 'updateUserSettings' | 'upsertBannedEmail' | 'upsertEmailList' | 'upsertForwardEarthCredentials' | 'upsertTask' | 'upsertTaskComment' | 'userEnabledStandardsSet' | 'userProfileUpdate' | 'xbrlGenerate' | 'yearClearData' | 'yearClone' | 'yearCreate' | 'yearDelete' | 'yearSetActive' | 'yearSetClosed' | 'yearSetOpen' | MutationKeySpecifier)[];
export type MutationFieldPolicy = {
	adminUserDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	adminUserUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	bannedEmailBatchStatusChange?: FieldPolicy<any> | FieldReadFunction<any>,
	bannedEmailDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	bannedEmailStatusChange?: FieldPolicy<any> | FieldReadFunction<any>,
	bannedEmailUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	biometricsClear?: FieldPolicy<any> | FieldReadFunction<any>,
	biometricsSetup?: FieldPolicy<any> | FieldReadFunction<any>,
	callsCaseCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	callsCaseUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	carbonLensFinalizeSSO?: FieldPolicy<any> | FieldReadFunction<any>,
	carbonLensInitializeSSO?: FieldPolicy<any> | FieldReadFunction<any>,
	caseActivityCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	caseActivitySettingsBatchUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	caseActivitySettingsUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	caseAnalyticsReportPdf?: FieldPolicy<any> | FieldReadFunction<any>,
	caseAnonymitySettingsDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	caseAssignmentDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	caseAssignmentUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	caseAttachmentUpload?: FieldPolicy<any> | FieldReadFunction<any>,
	caseBusinessUnitAssign?: FieldPolicy<any> | FieldReadFunction<any>,
	caseClose?: FieldPolicy<any> | FieldReadFunction<any>,
	caseConversationUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	caseCustomReminderDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	caseCustomReminderUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	caseCustomTitleUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	caseDetailsUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	caseIncidentTypeAssign?: FieldPolicy<any> | FieldReadFunction<any>,
	caseIndividualInvolvedMessageSend?: FieldPolicy<any> | FieldReadFunction<any>,
	caseIndividualInvolvedUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	caseIndividualsInvolvedDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	caseInvestigationPdfReportGenerate?: FieldPolicy<any> | FieldReadFunction<any>,
	caseInvestigationsXlsxReportGenerate?: FieldPolicy<any> | FieldReadFunction<any>,
	caseInvestigatorsUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	caseOwnerExclusionUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	caseOwnerExclusionsDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	caseReopen?: FieldPolicy<any> | FieldReadFunction<any>,
	caseReportCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	caseSettingsUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	caseTriageScoreUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	casesSubsidiarySiteUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	changeDisclosureStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	changePassword?: FieldPolicy<any> | FieldReadFunction<any>,
	changeSurveyReminder?: FieldPolicy<any> | FieldReadFunction<any>,
	changeSurveyStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	chatRoomFilesUpload?: FieldPolicy<any> | FieldReadFunction<any>,
	chatbotCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	chatbotMessageCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	checkPasswordResetToken?: FieldPolicy<any> | FieldReadFunction<any>,
	conclusionTypeBatchUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	conclusionTypeUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	confirmMfaSetup?: FieldPolicy<any> | FieldReadFunction<any>,
	createAdminToken?: FieldPolicy<any> | FieldReadFunction<any>,
	createAssistantSlot?: FieldPolicy<any> | FieldReadFunction<any>,
	createBusinessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	createEmployeeAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	customPlanUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	dataCategoryCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	dataCategoryCreateMany?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAssistantSlot?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteBannedEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDisclosureDraft?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEmailEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEmailList?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEmailTarget?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEmployeeAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteForwardEarthCredentials?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteTenantLogo?: FieldPolicy<any> | FieldReadFunction<any>,
	disablePushNotificationsForDevice?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureResponseApprove?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureResponseCommentUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureRiskAreasUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureUserFill?: FieldPolicy<any> | FieldReadFunction<any>,
	editEmailEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	editEmailTarget?: FieldPolicy<any> | FieldReadFunction<any>,
	elineNumberDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	elineNumberUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	emailListDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	emailListUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	emailTemplateCarbonCopyUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	emailTemplateUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	emailTemplatesStatusUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	enablePushNotificationsForDevice?: FieldPolicy<any> | FieldReadFunction<any>,
	esgActivityReportGenerate?: FieldPolicy<any> | FieldReadFunction<any>,
	esgAnswerDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	esgAnswerFilesSet?: FieldPolicy<any> | FieldReadFunction<any>,
	esgAnswerGenerate?: FieldPolicy<any> | FieldReadFunction<any>,
	esgAnswerUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	esgAnswerUpsertByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	esgAnswerUpsertByVersionData?: FieldPolicy<any> | FieldReadFunction<any>,
	esgAuditReportGenerate?: FieldPolicy<any> | FieldReadFunction<any>,
	esgCountryReportGenerate?: FieldPolicy<any> | FieldReadFunction<any>,
	esgEsrsReportGenerate?: FieldPolicy<any> | FieldReadFunction<any>,
	esgFilesUpload?: FieldPolicy<any> | FieldReadFunction<any>,
	esgGriReportGenerate?: FieldPolicy<any> | FieldReadFunction<any>,
	esgQuestionAssignFiles?: FieldPolicy<any> | FieldReadFunction<any>,
	esgQuestionUnassignFiles?: FieldPolicy<any> | FieldReadFunction<any>,
	esgQuestionUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	esgSmartFillStart?: FieldPolicy<any> | FieldReadFunction<any>,
	esgStakeholderReportGenerate?: FieldPolicy<any> | FieldReadFunction<any>,
	esgStandardReportGenerate?: FieldPolicy<any> | FieldReadFunction<any>,
	exchangeAzureSingleSignOnToken?: FieldPolicy<any> | FieldReadFunction<any>,
	exportMetric?: FieldPolicy<any> | FieldReadFunction<any>,
	fetchDisclosureReport?: FieldPolicy<any> | FieldReadFunction<any>,
	fetchPdfSurveyReport?: FieldPolicy<any> | FieldReadFunction<any>,
	fetchWhistleblowerCaseReportPdf?: FieldPolicy<any> | FieldReadFunction<any>,
	forwardEarthDataFetch?: FieldPolicy<any> | FieldReadFunction<any>,
	generateAiReport?: FieldPolicy<any> | FieldReadFunction<any>,
	genericPlanUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	getFirebaseToken?: FieldPolicy<any> | FieldReadFunction<any>,
	glossaryInsert?: FieldPolicy<any> | FieldReadFunction<any>,
	graphStorageUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	groupTagUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	groupTagsDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	guidelineDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	guidelineUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	hotspotBurn?: FieldPolicy<any> | FieldReadFunction<any>,
	hotspotBurnAll?: FieldPolicy<any> | FieldReadFunction<any>,
	hotspotReset?: FieldPolicy<any> | FieldReadFunction<any>,
	initFirebaseChatRoom?: FieldPolicy<any> | FieldReadFunction<any>,
	ixbrlGenerate?: FieldPolicy<any> | FieldReadFunction<any>,
	knowledgeLibraryDeleteMany?: FieldPolicy<any> | FieldReadFunction<any>,
	knowledgeLibraryGenerateAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	knowledgeLibraryUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	linkAnswersToMetric?: FieldPolicy<any> | FieldReadFunction<any>,
	linkMetricsToAnswer?: FieldPolicy<any> | FieldReadFunction<any>,
	linkMetricsToAnswerByUuidOrVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	loginAdmin?: FieldPolicy<any> | FieldReadFunction<any>,
	loginAzureSso?: FieldPolicy<any> | FieldReadFunction<any>,
	loginBiometrics?: FieldPolicy<any> | FieldReadFunction<any>,
	loginExternal?: FieldPolicy<any> | FieldReadFunction<any>,
	loginGuest?: FieldPolicy<any> | FieldReadFunction<any>,
	loginPassword?: FieldPolicy<any> | FieldReadFunction<any>,
	loginSpreadsheetServer?: FieldPolicy<any> | FieldReadFunction<any>,
	loginWithMfa?: FieldPolicy<any> | FieldReadFunction<any>,
	markAllNotificationsAsRead?: FieldPolicy<any> | FieldReadFunction<any>,
	markAllNotificationsAsUnread?: FieldPolicy<any> | FieldReadFunction<any>,
	markNotificationsAsRead?: FieldPolicy<any> | FieldReadFunction<any>,
	markNotificationsAsUnread?: FieldPolicy<any> | FieldReadFunction<any>,
	markQuestionAsAnswered?: FieldPolicy<any> | FieldReadFunction<any>,
	metricDataDeleteByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	metricDataUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	metricDeleteByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	metricFavouriteToggle?: FieldPolicy<any> | FieldReadFunction<any>,
	metricUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	mfaResetConfirm?: FieldPolicy<any> | FieldReadFunction<any>,
	mfaResetRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	nicoleAvatarDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	nicoleAvatarSettingUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	nicoleAvatarUpload?: FieldPolicy<any> | FieldReadFunction<any>,
	nicoleGptSessionContinue?: FieldPolicy<any> | FieldReadFunction<any>,
	nicoleGptSessionDescriptionUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	nicoleGptSessionEntryRegenerate?: FieldPolicy<any> | FieldReadFunction<any>,
	nicoleGptSessionInitialize?: FieldPolicy<any> | FieldReadFunction<any>,
	nicoleGptSessionsDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	oAuthClientUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	oAuthClientsDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	passwordResetAdmin?: FieldPolicy<any> | FieldReadFunction<any>,
	planUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	questionnaireFiltersSet?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshAdminSession?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshSession?: FieldPolicy<any> | FieldReadFunction<any>,
	regionUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	releaseNoteMarkRead?: FieldPolicy<any> | FieldReadFunction<any>,
	releaseNoteUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	removeTeamsId?: FieldPolicy<any> | FieldReadFunction<any>,
	reportCaseFilesUpload?: FieldPolicy<any> | FieldReadFunction<any>,
	reportCaseStart?: FieldPolicy<any> | FieldReadFunction<any>,
	reportCaseSubmit?: FieldPolicy<any> | FieldReadFunction<any>,
	reportCaseSummarize?: FieldPolicy<any> | FieldReadFunction<any>,
	reportDeleteCaseFiles?: FieldPolicy<any> | FieldReadFunction<any>,
	reportEditConversation?: FieldPolicy<any> | FieldReadFunction<any>,
	reportPromptTemplateDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	reportPromptTemplateUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingGroupUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingGroupsDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingPeriodSet?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingSourceBatchUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingSourceUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	requestAccountUnlock?: FieldPolicy<any> | FieldReadFunction<any>,
	requestMfaSetup?: FieldPolicy<any> | FieldReadFunction<any>,
	requestPasswordReset?: FieldPolicy<any> | FieldReadFunction<any>,
	requestPasswordResetAdmin?: FieldPolicy<any> | FieldReadFunction<any>,
	resendAuthEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	resendCreateTenantEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	resetPassword?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireEntriesDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireEntriesUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireV2ChangeStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireV2Create?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireV2Delete?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireV2EntriesDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireV2EntriesUpdateByAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireV2EntriesUpdateByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireV2EntryUpdateByAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireV2EntryUpdateByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireV2MarkAsSaved?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireV2UpdateExcelFile?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnairesDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaSettingsSet?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	rolesChangeStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	rolesDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	rolesUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	sectorsSetState?: FieldPolicy<any> | FieldReadFunction<any>,
	sendConversationMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	sendInvitationEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	setMsTenantID?: FieldPolicy<any> | FieldReadFunction<any>,
	setRecoveryEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	setRecoveryEmailTenantAdmin?: FieldPolicy<any> | FieldReadFunction<any>,
	setRiskAreaSettingsByProgram?: FieldPolicy<any> | FieldReadFunction<any>,
	setTenantRiskAreaCustomLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	setTenantRiskAreaSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	setupAzureSingleSignOnForTenant?: FieldPolicy<any> | FieldReadFunction<any>,
	skipMfa?: FieldPolicy<any> | FieldReadFunction<any>,
	ssoAzureSetup?: FieldPolicy<any> | FieldReadFunction<any>,
	ssoProviderDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	ssoProviderUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionRenewalRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySiteHeadquartersReportingLabelUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySiteRoleUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySiteStatusUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySiteSwitch?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySiteUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySiteUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyRiskAreasUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	surveySummary?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyTemplateUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyTemplatesDeletion?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyUserFill?: FieldPolicy<any> | FieldReadFunction<any>,
	surveysDeletion?: FieldPolicy<any> | FieldReadFunction<any>,
	symbolDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	symbolUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	tagCreateForVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	tagDescriptionDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	tagDescriptionUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	tagUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	tagUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	tagsDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	tagsUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	targetBatchDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	targetDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	targetUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	taskDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	taskMarkAsSeen?: FieldPolicy<any> | FieldReadFunction<any>,
	taskUpdateStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	taskUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	taxonomyReportCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	taxonomyReportFactDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	taxonomyReportFactUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	templateDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	templateRiskAreasUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	templateUpsert?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantAdminInvite?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantAdminInviteFinish?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantAdminRegionsChange?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantAdminRolesUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantAdminUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantAdminsStatusesUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantBeginSetup?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantChangeStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantCheckStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantCountryUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantHeadlineRemove?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantHeadlineUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantInformationUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantLicenseCountUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantNameUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantPrimaryContactDataUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantSignup?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantStandardsStatusBatchUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantSubscriberEmailUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantSubscriptionDatesUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantSubscriptionUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantUnitsBatchUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantUpdateDefaultAnswerLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantsDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	toggleProgramSetting?: FieldPolicy<any> | FieldReadFunction<any>,
	translate?: FieldPolicy<any> | FieldReadFunction<any>,
	unlinkMetricFromAnswer?: FieldPolicy<any> | FieldReadFunction<any>,
	unlinkQuestionFromMetric?: FieldPolicy<any> | FieldReadFunction<any>,
	unlockAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAssistantCredentials?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAssistantSlot?: FieldPolicy<any> | FieldReadFunction<any>,
	updateBusinessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	updateRecoveryEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTenant?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUserDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUserSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	upsertBannedEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	upsertEmailList?: FieldPolicy<any> | FieldReadFunction<any>,
	upsertForwardEarthCredentials?: FieldPolicy<any> | FieldReadFunction<any>,
	upsertTask?: FieldPolicy<any> | FieldReadFunction<any>,
	upsertTaskComment?: FieldPolicy<any> | FieldReadFunction<any>,
	userEnabledStandardsSet?: FieldPolicy<any> | FieldReadFunction<any>,
	userProfileUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	xbrlGenerate?: FieldPolicy<any> | FieldReadFunction<any>,
	yearClearData?: FieldPolicy<any> | FieldReadFunction<any>,
	yearClone?: FieldPolicy<any> | FieldReadFunction<any>,
	yearCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	yearDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	yearSetActive?: FieldPolicy<any> | FieldReadFunction<any>,
	yearSetClosed?: FieldPolicy<any> | FieldReadFunction<any>,
	yearSetOpen?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NewEsgQuestionnaireFiltersKeySpecifier = ('questionStatuses' | 'questionTaskRelation' | 'standards' | 'taskStatuses' | NewEsgQuestionnaireFiltersKeySpecifier)[];
export type NewEsgQuestionnaireFiltersFieldPolicy = {
	questionStatuses?: FieldPolicy<any> | FieldReadFunction<any>,
	questionTaskRelation?: FieldPolicy<any> | FieldReadFunction<any>,
	standards?: FieldPolicy<any> | FieldReadFunction<any>,
	taskStatuses?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NewTasksDashboardFiltersKeySpecifier = ('assignee' | 'assignor' | 'dueDateStatus' | 'module' | 'status' | NewTasksDashboardFiltersKeySpecifier)[];
export type NewTasksDashboardFiltersFieldPolicy = {
	assignee?: FieldPolicy<any> | FieldReadFunction<any>,
	assignor?: FieldPolicy<any> | FieldReadFunction<any>,
	dueDateStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	module?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NewTasksDashboardFiltersWithTopicsKeySpecifier = ('assignee' | 'assignor' | 'dueDateStatus' | 'module' | 'status' | 'topic' | NewTasksDashboardFiltersWithTopicsKeySpecifier)[];
export type NewTasksDashboardFiltersWithTopicsFieldPolicy = {
	assignee?: FieldPolicy<any> | FieldReadFunction<any>,
	assignor?: FieldPolicy<any> | FieldReadFunction<any>,
	dueDateStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	module?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	topic?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NicoleGptSessionKeySpecifier = ('createdAt' | 'description' | 'entries' | 'lastUpdatedAt' | 'uuid' | NicoleGptSessionKeySpecifier)[];
export type NicoleGptSessionFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	entries?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NicoleGptSessionConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | NicoleGptSessionConnectionKeySpecifier)[];
export type NicoleGptSessionConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NicoleGptSessionEdgeKeySpecifier = ('cursor' | 'node' | NicoleGptSessionEdgeKeySpecifier)[];
export type NicoleGptSessionEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NicoleGptSessionEntryKeySpecifier = ('confidenceReasoning' | 'confidenceScore' | 'content' | 'createdAt' | 'hallucinationReasoning' | 'isAssistant' | 'isGenerated' | 'isHallucinated' | 'lastUpdatedAt' | 'riskAreas' | 'sourcesUsed' | 'uuid' | NicoleGptSessionEntryKeySpecifier)[];
export type NicoleGptSessionEntryFieldPolicy = {
	confidenceReasoning?: FieldPolicy<any> | FieldReadFunction<any>,
	confidenceScore?: FieldPolicy<any> | FieldReadFunction<any>,
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	hallucinationReasoning?: FieldPolicy<any> | FieldReadFunction<any>,
	isAssistant?: FieldPolicy<any> | FieldReadFunction<any>,
	isGenerated?: FieldPolicy<any> | FieldReadFunction<any>,
	isHallucinated?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	sourcesUsed?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NicoleGptSessionEntryConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | NicoleGptSessionEntryConnectionKeySpecifier)[];
export type NicoleGptSessionEntryConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NicoleGptSessionEntryEdgeKeySpecifier = ('cursor' | 'node' | NicoleGptSessionEntryEdgeKeySpecifier)[];
export type NicoleGptSessionEntryEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationKeySpecifier = ('channel' | 'createdAt' | 'createdByUuid' | 'payload' | 'readNotification' | 'type' | 'uuid' | NotificationKeySpecifier)[];
export type NotificationFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	payload?: FieldPolicy<any> | FieldReadFunction<any>,
	readNotification?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationContentsKeySpecifier = ('body' | 'title' | NotificationContentsKeySpecifier)[];
export type NotificationContentsFieldPolicy = {
	body?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationDataKeySpecifier = ('extra' | 'refUuid' | 'type' | NotificationDataKeySpecifier)[];
export type NotificationDataFieldPolicy = {
	extra?: FieldPolicy<any> | FieldReadFunction<any>,
	refUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationEdgeKeySpecifier = ('cursor' | 'node' | NotificationEdgeKeySpecifier)[];
export type NotificationEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationPageKeySpecifier = ('edges' | 'info' | NotificationPageKeySpecifier)[];
export type NotificationPageFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	info?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationPaginatedKeySpecifier = ('page' | 'totalCount' | NotificationPaginatedKeySpecifier)[];
export type NotificationPaginatedFieldPolicy = {
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationPayloadKeySpecifier = ('data' | 'metadata' | 'notification' | 'reference' | 'type' | NotificationPayloadKeySpecifier)[];
export type NotificationPayloadFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	notification?: FieldPolicy<any> | FieldReadFunction<any>,
	reference?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OAuthClientKeySpecifier = ('clientId' | 'clientName' | 'clientSecret' | 'clusterId' | 'grantTypes' | 'redirectUris' | 'scope' | 'uuid' | OAuthClientKeySpecifier)[];
export type OAuthClientFieldPolicy = {
	clientId?: FieldPolicy<any> | FieldReadFunction<any>,
	clientName?: FieldPolicy<any> | FieldReadFunction<any>,
	clientSecret?: FieldPolicy<any> | FieldReadFunction<any>,
	clusterId?: FieldPolicy<any> | FieldReadFunction<any>,
	grantTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	redirectUris?: FieldPolicy<any> | FieldReadFunction<any>,
	scope?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OAuthClientConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | OAuthClientConnectionKeySpecifier)[];
export type OAuthClientConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OAuthClientEdgeKeySpecifier = ('cursor' | 'node' | OAuthClientEdgeKeySpecifier)[];
export type OAuthClientEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OriginalReportKeySpecifier = ('incidentType' | 'language' | 'reporter' | 'reportingSource' | OriginalReportKeySpecifier)[];
export type OriginalReportFieldPolicy = {
	incidentType?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>,
	reporter?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingSource?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageInfoKeySpecifier = ('endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'pageSize' | 'startCursor' | PageInfoKeySpecifier)[];
export type PageInfoFieldPolicy = {
	endCursor?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>,
	pageSize?: FieldPolicy<any> | FieldReadFunction<any>,
	startCursor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageInfoV2KeySpecifier = ('endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'pageSize' | 'startCursor' | PageInfoV2KeySpecifier)[];
export type PageInfoV2FieldPolicy = {
	endCursor?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>,
	pageSize?: FieldPolicy<any> | FieldReadFunction<any>,
	startCursor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PresignedCaseFileKeySpecifier = ('mimeType' | 'name' | 'size' | 'url' | 'uuid' | PresignedCaseFileKeySpecifier)[];
export type PresignedCaseFileFieldPolicy = {
	mimeType?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	size?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PrimaryContactKeySpecifier = ('email' | 'firstName' | 'lastName' | PrimaryContactKeySpecifier)[];
export type PrimaryContactFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProgramKeySpecifier = ('category' | 'description' | 'name' | 'order' | 'riskAreas' | 'uuid' | ProgramKeySpecifier)[];
export type ProgramFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProgramCategoryKeySpecifier = ('name' | 'riskAreas' | 'uuid' | ProgramCategoryKeySpecifier)[];
export type ProgramCategoryFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProgramSettingCategoryKeySpecifier = ('name' | 'uuid' | ProgramSettingCategoryKeySpecifier)[];
export type ProgramSettingCategoryFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueryKeySpecifier = ('adminUser' | 'adminUsers' | 'appVersion' | 'assignedTagNames' | 'assignees' | 'assignors' | 'assistantCredentials' | 'assistantSlots' | 'auditEvent' | 'auditEvents' | 'bannedEmail' | 'bannedEmails' | 'businessUnits' | 'callsCaseDetails' | 'caseAnalytics' | 'caseAnonymityRestrictions' | 'caseAnonymitySettings' | 'caseInvestigation' | 'caseInvestigations' | 'caseParsedMessageGet' | 'caseReports' | 'caseSettings' | 'chatRoomFileInfo' | 'checkYearDataStatus' | 'client' | 'clientSubsidiarySiteByName' | 'clientSubsidiarySites' | 'clientUsers' | 'clients' | 'countryAnonymityEnabled' | 'countryAnonymityValidate' | 'customPlan' | 'dataCategoryByName' | 'dataCategoryByUuid' | 'dataCategoryList' | 'dictionaryTranslated' | 'disclosureAdminList' | 'disclosureAdminListV2' | 'disclosureCommentsList' | 'disclosureDetails' | 'disclosureEmployeeUserResponseList' | 'disclosureEmployeeUserResponseListV2' | 'disclosureResponders' | 'disclosureResponseAnalyticsList' | 'disclosureResponseAnalyticsListV2' | 'disclosureResponseByUuid' | 'disclosureResponseDetails' | 'disclosureUserList' | 'disclosureUserListV2' | 'disclosureUserResponseList' | 'disclosureUserResponseListV2' | 'disclosureUserStatistics' | 'disclosuresUserCount' | 'emailList' | 'emailListDetails' | 'emailLists' | 'esgActivitiesForActivityReport' | 'esgAnswerByUuid' | 'esgAnswersByQuestion' | 'esgCategories' | 'esgCategoryByName' | 'esgFileByUuid' | 'esgFiles' | 'esgGroupTagsSelector' | 'esgQuestion' | 'esgQuestionFiles' | 'esgQuestionSearchRecent' | 'esgQuestionsActivities' | 'esgQuestionsSearchConnection' | 'esgQuestionsUnmapped' | 'esgQuestionsUnmappedConnection' | 'esgStatistics' | 'esgStepsForAuditReport' | 'esgStepsWithAnyQuestions' | 'esgSubcategories' | 'esgSubcategoryByName' | 'esgSubcategoryByUuid' | 'esgTagsSelect' | 'esgUnansweredQuestionsCount' | 'esgVideos' | 'findGlobalTenantDataByCode' | 'findGlobalTenantDataByName' | 'genericPlan' | 'genericPlans' | 'getActiveSsoMethodsForTenant' | 'getAdminTenantDetails' | 'getGlobalTenantDataByCode' | 'getGlobalTenantDataByMicrosoftTenantId' | 'getGlobalTenantDataByReportingSlug' | 'getGlobalTenantDataByUuid' | 'getMinimumSupportedMobileAppVersions' | 'getMyNotificationTopics' | 'getSamlRequestDetailsForTenant' | 'getSsoTenantInformation' | 'getTenantByCompanyCode' | 'getTenantByUuid' | 'getUnreadNotificationCount' | 'getUserByUuid' | 'glossary' | 'glossaryMarkdown' | 'groupTag' | 'groupTags' | 'groupTagsNameSearch' | 'groupTagsRows' | 'guidelines' | 'guidelinesByUuids' | 'guidelinesCategoriesNames' | 'guidelinesForProgramme' | 'incidentTypes' | 'industryUnits' | 'investigationCaseDetails' | 'knowledgeLibraryExamples' | 'knowledgeLibraryList' | 'linkedTags' | 'listNotifications' | 'me' | 'metricByUuid' | 'metricDataByMetricUuidAndYear' | 'metricDataByUuid' | 'metricDataColumnsList' | 'metricDataRowSelect' | 'metricDataYears' | 'metricList' | 'metricOwners' | 'nicoleGptSession' | 'nicoleGptSessions' | 'oAuthClientByUuid' | 'oAuthClientList' | 'program' | 'programRiskAreasByCategory' | 'programSettings' | 'programsList' | 'questionSearchLinkedCount' | 'questionSearchRiskAreas' | 'questionSearchSteps' | 'questionnaireFilters' | 'questionnaireNavigation' | 'questionnaireNavigationQuestions' | 'releaseNote' | 'reportAudiences' | 'reportCaseDetails' | 'reportCaseDetailsUnlogged' | 'reportCaseExclusionOwnerList' | 'reportCaseExclusionOwners' | 'reportCases' | 'reportCasesStatistics' | 'reportPresignedCaseFile' | 'reportPromptTemplateByUuid' | 'reportsPromptsTemplates' | 'respondQuestionnaire' | 'respondQuestionnaireEntriesCsv' | 'respondQuestionnaireEntriesList' | 'respondQuestionnaireEntry' | 'respondQuestionnaireList' | 'respondQuestionnaireV2Entries' | 'respondQuestionnaireV2GetByUuid' | 'respondQuestionnairesV2' | 'riskAreaByActivity' | 'riskAreaByName' | 'riskAreaByUuid' | 'riskAreaSettingsByProgram' | 'riskAreas' | 'riskAreasWithAnyQuestions' | 'roleByUuid' | 'roles' | 'sectorByUuid' | 'smartFillJob' | 'stakeholderEngagementList' | 'standardAssignedRiskAreas' | 'standardEnabledUnits' | 'standardsWithConnectedRiskAreas' | 'staticTranslations' | 'subsidiarySite' | 'subsidiarySites' | 'surveyAdminList' | 'surveyAdminListV2' | 'surveyAdminSearchList' | 'surveyResponseList' | 'surveyTemplateDetails' | 'surveyTemplateList' | 'surveyUserList' | 'surveyUserListV2' | 'surveysDetails' | 'symbolByUuid' | 'symbolList' | 'tag' | 'tags' | 'tagsNameSearch' | 'targetByUuid' | 'targetList' | 'taskByUuid' | 'taskNameHints' | 'tasks' | 'taxonomies' | 'taxonomy' | 'taxonomyConcept' | 'taxonomyConcepts' | 'taxonomyReport' | 'taxonomyReportFact' | 'taxonomyReportFacts' | 'taxonomyReportPage' | 'taxonomyReportPages' | 'taxonomyReports' | 'templateDetails' | 'templateList' | 'tenant' | 'tenantAdmins' | 'tenantRiskAreaSettings' | 'unmappedQuestionsCount' | 'usedCustomTags' | 'userDisclosureStatistics' | 'validateEmailTenantName' | 'verifyRegistrationCode' | 'webflow' | 'years' | QueryKeySpecifier)[];
export type QueryFieldPolicy = {
	adminUser?: FieldPolicy<any> | FieldReadFunction<any>,
	adminUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	appVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedTagNames?: FieldPolicy<any> | FieldReadFunction<any>,
	assignees?: FieldPolicy<any> | FieldReadFunction<any>,
	assignors?: FieldPolicy<any> | FieldReadFunction<any>,
	assistantCredentials?: FieldPolicy<any> | FieldReadFunction<any>,
	assistantSlots?: FieldPolicy<any> | FieldReadFunction<any>,
	auditEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	auditEvents?: FieldPolicy<any> | FieldReadFunction<any>,
	bannedEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	bannedEmails?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	callsCaseDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	caseAnalytics?: FieldPolicy<any> | FieldReadFunction<any>,
	caseAnonymityRestrictions?: FieldPolicy<any> | FieldReadFunction<any>,
	caseAnonymitySettings?: FieldPolicy<any> | FieldReadFunction<any>,
	caseInvestigation?: FieldPolicy<any> | FieldReadFunction<any>,
	caseInvestigations?: FieldPolicy<any> | FieldReadFunction<any>,
	caseParsedMessageGet?: FieldPolicy<any> | FieldReadFunction<any>,
	caseReports?: FieldPolicy<any> | FieldReadFunction<any>,
	caseSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	chatRoomFileInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	checkYearDataStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	client?: FieldPolicy<any> | FieldReadFunction<any>,
	clientSubsidiarySiteByName?: FieldPolicy<any> | FieldReadFunction<any>,
	clientSubsidiarySites?: FieldPolicy<any> | FieldReadFunction<any>,
	clientUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	clients?: FieldPolicy<any> | FieldReadFunction<any>,
	countryAnonymityEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	countryAnonymityValidate?: FieldPolicy<any> | FieldReadFunction<any>,
	customPlan?: FieldPolicy<any> | FieldReadFunction<any>,
	dataCategoryByName?: FieldPolicy<any> | FieldReadFunction<any>,
	dataCategoryByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	dataCategoryList?: FieldPolicy<any> | FieldReadFunction<any>,
	dictionaryTranslated?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureAdminList?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureAdminListV2?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureCommentsList?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureEmployeeUserResponseList?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureEmployeeUserResponseListV2?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureResponders?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureResponseAnalyticsList?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureResponseAnalyticsListV2?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureResponseByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureResponseDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureUserList?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureUserListV2?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureUserResponseList?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureUserResponseListV2?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureUserStatistics?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosuresUserCount?: FieldPolicy<any> | FieldReadFunction<any>,
	emailList?: FieldPolicy<any> | FieldReadFunction<any>,
	emailListDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	emailLists?: FieldPolicy<any> | FieldReadFunction<any>,
	esgActivitiesForActivityReport?: FieldPolicy<any> | FieldReadFunction<any>,
	esgAnswerByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	esgAnswersByQuestion?: FieldPolicy<any> | FieldReadFunction<any>,
	esgCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	esgCategoryByName?: FieldPolicy<any> | FieldReadFunction<any>,
	esgFileByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	esgFiles?: FieldPolicy<any> | FieldReadFunction<any>,
	esgGroupTagsSelector?: FieldPolicy<any> | FieldReadFunction<any>,
	esgQuestion?: FieldPolicy<any> | FieldReadFunction<any>,
	esgQuestionFiles?: FieldPolicy<any> | FieldReadFunction<any>,
	esgQuestionSearchRecent?: FieldPolicy<any> | FieldReadFunction<any>,
	esgQuestionsActivities?: FieldPolicy<any> | FieldReadFunction<any>,
	esgQuestionsSearchConnection?: FieldPolicy<any> | FieldReadFunction<any>,
	esgQuestionsUnmapped?: FieldPolicy<any> | FieldReadFunction<any>,
	esgQuestionsUnmappedConnection?: FieldPolicy<any> | FieldReadFunction<any>,
	esgStatistics?: FieldPolicy<any> | FieldReadFunction<any>,
	esgStepsForAuditReport?: FieldPolicy<any> | FieldReadFunction<any>,
	esgStepsWithAnyQuestions?: FieldPolicy<any> | FieldReadFunction<any>,
	esgSubcategories?: FieldPolicy<any> | FieldReadFunction<any>,
	esgSubcategoryByName?: FieldPolicy<any> | FieldReadFunction<any>,
	esgSubcategoryByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	esgTagsSelect?: FieldPolicy<any> | FieldReadFunction<any>,
	esgUnansweredQuestionsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	esgVideos?: FieldPolicy<any> | FieldReadFunction<any>,
	findGlobalTenantDataByCode?: FieldPolicy<any> | FieldReadFunction<any>,
	findGlobalTenantDataByName?: FieldPolicy<any> | FieldReadFunction<any>,
	genericPlan?: FieldPolicy<any> | FieldReadFunction<any>,
	genericPlans?: FieldPolicy<any> | FieldReadFunction<any>,
	getActiveSsoMethodsForTenant?: FieldPolicy<any> | FieldReadFunction<any>,
	getAdminTenantDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	getGlobalTenantDataByCode?: FieldPolicy<any> | FieldReadFunction<any>,
	getGlobalTenantDataByMicrosoftTenantId?: FieldPolicy<any> | FieldReadFunction<any>,
	getGlobalTenantDataByReportingSlug?: FieldPolicy<any> | FieldReadFunction<any>,
	getGlobalTenantDataByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	getMinimumSupportedMobileAppVersions?: FieldPolicy<any> | FieldReadFunction<any>,
	getMyNotificationTopics?: FieldPolicy<any> | FieldReadFunction<any>,
	getSamlRequestDetailsForTenant?: FieldPolicy<any> | FieldReadFunction<any>,
	getSsoTenantInformation?: FieldPolicy<any> | FieldReadFunction<any>,
	getTenantByCompanyCode?: FieldPolicy<any> | FieldReadFunction<any>,
	getTenantByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	getUnreadNotificationCount?: FieldPolicy<any> | FieldReadFunction<any>,
	getUserByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	glossary?: FieldPolicy<any> | FieldReadFunction<any>,
	glossaryMarkdown?: FieldPolicy<any> | FieldReadFunction<any>,
	groupTag?: FieldPolicy<any> | FieldReadFunction<any>,
	groupTags?: FieldPolicy<any> | FieldReadFunction<any>,
	groupTagsNameSearch?: FieldPolicy<any> | FieldReadFunction<any>,
	groupTagsRows?: FieldPolicy<any> | FieldReadFunction<any>,
	guidelines?: FieldPolicy<any> | FieldReadFunction<any>,
	guidelinesByUuids?: FieldPolicy<any> | FieldReadFunction<any>,
	guidelinesCategoriesNames?: FieldPolicy<any> | FieldReadFunction<any>,
	guidelinesForProgramme?: FieldPolicy<any> | FieldReadFunction<any>,
	incidentTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	industryUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	investigationCaseDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	knowledgeLibraryExamples?: FieldPolicy<any> | FieldReadFunction<any>,
	knowledgeLibraryList?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedTags?: FieldPolicy<any> | FieldReadFunction<any>,
	listNotifications?: FieldPolicy<any> | FieldReadFunction<any>,
	me?: FieldPolicy<any> | FieldReadFunction<any>,
	metricByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	metricDataByMetricUuidAndYear?: FieldPolicy<any> | FieldReadFunction<any>,
	metricDataByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	metricDataColumnsList?: FieldPolicy<any> | FieldReadFunction<any>,
	metricDataRowSelect?: FieldPolicy<any> | FieldReadFunction<any>,
	metricDataYears?: FieldPolicy<any> | FieldReadFunction<any>,
	metricList?: FieldPolicy<any> | FieldReadFunction<any>,
	metricOwners?: FieldPolicy<any> | FieldReadFunction<any>,
	nicoleGptSession?: FieldPolicy<any> | FieldReadFunction<any>,
	nicoleGptSessions?: FieldPolicy<any> | FieldReadFunction<any>,
	oAuthClientByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	oAuthClientList?: FieldPolicy<any> | FieldReadFunction<any>,
	program?: FieldPolicy<any> | FieldReadFunction<any>,
	programRiskAreasByCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	programSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	programsList?: FieldPolicy<any> | FieldReadFunction<any>,
	questionSearchLinkedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	questionSearchRiskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	questionSearchSteps?: FieldPolicy<any> | FieldReadFunction<any>,
	questionnaireFilters?: FieldPolicy<any> | FieldReadFunction<any>,
	questionnaireNavigation?: FieldPolicy<any> | FieldReadFunction<any>,
	questionnaireNavigationQuestions?: FieldPolicy<any> | FieldReadFunction<any>,
	releaseNote?: FieldPolicy<any> | FieldReadFunction<any>,
	reportAudiences?: FieldPolicy<any> | FieldReadFunction<any>,
	reportCaseDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	reportCaseDetailsUnlogged?: FieldPolicy<any> | FieldReadFunction<any>,
	reportCaseExclusionOwnerList?: FieldPolicy<any> | FieldReadFunction<any>,
	reportCaseExclusionOwners?: FieldPolicy<any> | FieldReadFunction<any>,
	reportCases?: FieldPolicy<any> | FieldReadFunction<any>,
	reportCasesStatistics?: FieldPolicy<any> | FieldReadFunction<any>,
	reportPresignedCaseFile?: FieldPolicy<any> | FieldReadFunction<any>,
	reportPromptTemplateByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	reportsPromptsTemplates?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaire?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireEntriesCsv?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireEntriesList?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireList?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireV2Entries?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnaireV2GetByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	respondQuestionnairesV2?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaByActivity?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaByName?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaSettingsByProgram?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreasWithAnyQuestions?: FieldPolicy<any> | FieldReadFunction<any>,
	roleByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	roles?: FieldPolicy<any> | FieldReadFunction<any>,
	sectorByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	smartFillJob?: FieldPolicy<any> | FieldReadFunction<any>,
	stakeholderEngagementList?: FieldPolicy<any> | FieldReadFunction<any>,
	standardAssignedRiskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	standardEnabledUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	standardsWithConnectedRiskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	staticTranslations?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySite?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySites?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyAdminList?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyAdminListV2?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyAdminSearchList?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyResponseList?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyTemplateDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyTemplateList?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyUserList?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyUserListV2?: FieldPolicy<any> | FieldReadFunction<any>,
	surveysDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	symbolByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	symbolList?: FieldPolicy<any> | FieldReadFunction<any>,
	tag?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	tagsNameSearch?: FieldPolicy<any> | FieldReadFunction<any>,
	targetByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	targetList?: FieldPolicy<any> | FieldReadFunction<any>,
	taskByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	taskNameHints?: FieldPolicy<any> | FieldReadFunction<any>,
	tasks?: FieldPolicy<any> | FieldReadFunction<any>,
	taxonomies?: FieldPolicy<any> | FieldReadFunction<any>,
	taxonomy?: FieldPolicy<any> | FieldReadFunction<any>,
	taxonomyConcept?: FieldPolicy<any> | FieldReadFunction<any>,
	taxonomyConcepts?: FieldPolicy<any> | FieldReadFunction<any>,
	taxonomyReport?: FieldPolicy<any> | FieldReadFunction<any>,
	taxonomyReportFact?: FieldPolicy<any> | FieldReadFunction<any>,
	taxonomyReportFacts?: FieldPolicy<any> | FieldReadFunction<any>,
	taxonomyReportPage?: FieldPolicy<any> | FieldReadFunction<any>,
	taxonomyReportPages?: FieldPolicy<any> | FieldReadFunction<any>,
	taxonomyReports?: FieldPolicy<any> | FieldReadFunction<any>,
	templateDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	templateList?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantAdmins?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantRiskAreaSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	unmappedQuestionsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	usedCustomTags?: FieldPolicy<any> | FieldReadFunction<any>,
	userDisclosureStatistics?: FieldPolicy<any> | FieldReadFunction<any>,
	validateEmailTenantName?: FieldPolicy<any> | FieldReadFunction<any>,
	verifyRegistrationCode?: FieldPolicy<any> | FieldReadFunction<any>,
	webflow?: FieldPolicy<any> | FieldReadFunction<any>,
	years?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionActivityKeySpecifier = ('name' | 'topicsCount' | 'uuid' | QuestionActivityKeySpecifier)[];
export type QuestionActivityFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	topicsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionActivityConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | QuestionActivityConnectionKeySpecifier)[];
export type QuestionActivityConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionActivityEdgeKeySpecifier = ('cursor' | 'node' | QuestionActivityEdgeKeySpecifier)[];
export type QuestionActivityEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionSearchLinkedCountKeySpecifier = ('linkedCount' | QuestionSearchLinkedCountKeySpecifier)[];
export type QuestionSearchLinkedCountFieldPolicy = {
	linkedCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionSearchRiskAreaKeySpecifier = ('category' | 'customLabel' | 'name' | 'totalQuestions' | 'uuid' | QuestionSearchRiskAreaKeySpecifier)[];
export type QuestionSearchRiskAreaFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	customLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	totalQuestions?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionSearchStepKeySpecifier = ('id' | 'name' | 'questions' | 'totalQuestions' | QuestionSearchStepKeySpecifier)[];
export type QuestionSearchStepFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	questions?: FieldPolicy<any> | FieldReadFunction<any>,
	totalQuestions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionnaireEntryKeySpecifier = ('accuracyReason' | 'accuracyScore' | 'answer' | 'category' | 'cellAddress' | 'conflictingKnowledgeLibraryItems' | 'conflictingKnowledgeLibraryReasoning' | 'createdAt' | 'createdBy' | 'hasConflictingKnowledgeLibraryItems' | 'lastUpdatedBy' | 'question' | 'reasoning' | 'riskAreas' | 'rowId' | 'sheetName' | 'sourcesUsed' | 'updatedAt' | 'uuid' | 'validationArgs' | 'validationMode' | 'validationType' | QuestionnaireEntryKeySpecifier)[];
export type QuestionnaireEntryFieldPolicy = {
	accuracyReason?: FieldPolicy<any> | FieldReadFunction<any>,
	accuracyScore?: FieldPolicy<any> | FieldReadFunction<any>,
	answer?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	cellAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	conflictingKnowledgeLibraryItems?: FieldPolicy<any> | FieldReadFunction<any>,
	conflictingKnowledgeLibraryReasoning?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	hasConflictingKnowledgeLibraryItems?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>,
	reasoning?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	rowId?: FieldPolicy<any> | FieldReadFunction<any>,
	sheetName?: FieldPolicy<any> | FieldReadFunction<any>,
	sourcesUsed?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	validationArgs?: FieldPolicy<any> | FieldReadFunction<any>,
	validationMode?: FieldPolicy<any> | FieldReadFunction<any>,
	validationType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionnaireEntryConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | QuestionnaireEntryConnectionKeySpecifier)[];
export type QuestionnaireEntryConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionnaireEntryEdgeKeySpecifier = ('cursor' | 'node' | QuestionnaireEntryEdgeKeySpecifier)[];
export type QuestionnaireEntryEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionnaireFilterKeySpecifier = ('scope' | 'taskAssignees' | 'textSearch' | 'uuid' | QuestionnaireFilterKeySpecifier)[];
export type QuestionnaireFilterFieldPolicy = {
	scope?: FieldPolicy<any> | FieldReadFunction<any>,
	taskAssignees?: FieldPolicy<any> | FieldReadFunction<any>,
	textSearch?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionnaireNavigationKeySpecifier = ('categories' | QuestionnaireNavigationKeySpecifier)[];
export type QuestionnaireNavigationFieldPolicy = {
	categories?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionnaireNavigationCategoryKeySpecifier = ('name' | 'riskAreas' | 'uuid' | QuestionnaireNavigationCategoryKeySpecifier)[];
export type QuestionnaireNavigationCategoryFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionnaireNavigationRiskAreaKeySpecifier = ('customLabel' | 'name' | 'order' | 'standards' | 'statistics' | 'uuid' | QuestionnaireNavigationRiskAreaKeySpecifier)[];
export type QuestionnaireNavigationRiskAreaFieldPolicy = {
	customLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	standards?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionnaireNavigationStandardKeySpecifier = ('name' | 'uuid' | QuestionnaireNavigationStandardKeySpecifier)[];
export type QuestionnaireNavigationStandardFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionnaireNavigationStatisticsKeySpecifier = ('answeredQuestions' | 'totalQuestions' | QuestionnaireNavigationStatisticsKeySpecifier)[];
export type QuestionnaireNavigationStatisticsFieldPolicy = {
	answeredQuestions?: FieldPolicy<any> | FieldReadFunction<any>,
	totalQuestions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuestionnaireNavigationStepKeySpecifier = ('name' | 'order' | 'questions' | 'riskAreaName' | 'statistics' | 'uuid' | QuestionnaireNavigationStepKeySpecifier)[];
export type QuestionnaireNavigationStepFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	questions?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaName?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReadNotificationKeySpecifier = ('readAt' | ReadNotificationKeySpecifier)[];
export type ReadNotificationFieldPolicy = {
	readAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegionKeySpecifier = ('countries' | 'isActive' | 'name' | 'uuid' | RegionKeySpecifier)[];
export type RegionFieldPolicy = {
	countries?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegionConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | RegionConnectionKeySpecifier)[];
export type RegionConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegionEdgeKeySpecifier = ('cursor' | 'node' | RegionEdgeKeySpecifier)[];
export type RegionEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegularRolePermissionKeySpecifier = ('permission' | 'uuid' | RegularRolePermissionKeySpecifier)[];
export type RegularRolePermissionFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReleaseNoteKeySpecifier = ('content' | 'createdAt' | 'createdBy' | 'isNewFeature' | 'isPublished' | 'isUpdate' | 'lastUpdatedAt' | 'lastUpdatedBy' | 'title' | 'uuid' | 'version' | ReleaseNoteKeySpecifier)[];
export type ReleaseNoteFieldPolicy = {
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	isNewFeature?: FieldPolicy<any> | FieldReadFunction<any>,
	isPublished?: FieldPolicy<any> | FieldReadFunction<any>,
	isUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportAudienceKeySpecifier = ('id' | 'label' | ReportAudienceKeySpecifier)[];
export type ReportAudienceFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportCaseFileKeySpecifier = ('name' | 'size' | 'uuid' | ReportCaseFileKeySpecifier)[];
export type ReportCaseFileFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	size?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportPromptTemplateKeySpecifier = ('audience' | 'defaultTopic' | 'icon' | 'prompt' | 'purpose' | 'reportName' | 'reportNameTemplate' | 'suggestedReportLength' | 'templateName' | 'uuid' | ReportPromptTemplateKeySpecifier)[];
export type ReportPromptTemplateFieldPolicy = {
	audience?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultTopic?: FieldPolicy<any> | FieldReadFunction<any>,
	icon?: FieldPolicy<any> | FieldReadFunction<any>,
	prompt?: FieldPolicy<any> | FieldReadFunction<any>,
	purpose?: FieldPolicy<any> | FieldReadFunction<any>,
	reportName?: FieldPolicy<any> | FieldReadFunction<any>,
	reportNameTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	suggestedReportLength?: FieldPolicy<any> | FieldReadFunction<any>,
	templateName?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportPromptTemplateConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | ReportPromptTemplateConnectionKeySpecifier)[];
export type ReportPromptTemplateConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportPromptTemplateEdgeKeySpecifier = ('cursor' | 'node' | ReportPromptTemplateEdgeKeySpecifier)[];
export type ReportPromptTemplateEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportResponseKeySpecifier = ('url' | ReportResponseKeySpecifier)[];
export type ReportResponseFieldPolicy = {
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportSettingsKeySpecifier = ('subsidiaryChoiceEnabled' | 'subsidiarySelectionCopy' | 'uuid' | ReportSettingsKeySpecifier)[];
export type ReportSettingsFieldPolicy = {
	subsidiaryChoiceEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySelectionCopy?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportingGroupKeySpecifier = ('businessUnits' | 'subsidiarySite' | 'uuid' | ReportingGroupKeySpecifier)[];
export type ReportingGroupFieldPolicy = {
	businessUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySite?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportingGroupConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | ReportingGroupConnectionKeySpecifier)[];
export type ReportingGroupConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportingGroupEdgeKeySpecifier = ('cursor' | 'node' | ReportingGroupEdgeKeySpecifier)[];
export type ReportingGroupEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportingSourceKeySpecifier = ('isActive' | 'name' | 'uuid' | ReportingSourceKeySpecifier)[];
export type ReportingSourceFieldPolicy = {
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportingSourceConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | ReportingSourceConnectionKeySpecifier)[];
export type ReportingSourceConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportingSourceEdgeKeySpecifier = ('cursor' | 'node' | ReportingSourceEdgeKeySpecifier)[];
export type ReportingSourceEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RespondQuestionnaireKeySpecifier = ('createdAt' | 'createdBy' | 'entries' | 'lastUpdatedBy' | 'name' | 'originalName' | 'sourcesUsed' | 'updatedAt' | 'uuid' | RespondQuestionnaireKeySpecifier)[];
export type RespondQuestionnaireFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	entries?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	originalName?: FieldPolicy<any> | FieldReadFunction<any>,
	sourcesUsed?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RespondQuestionnaireConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | RespondQuestionnaireConnectionKeySpecifier)[];
export type RespondQuestionnaireConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RespondQuestionnaireEdgeKeySpecifier = ('cursor' | 'node' | RespondQuestionnaireEdgeKeySpecifier)[];
export type RespondQuestionnaireEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RespondQuestionnaireEntryKeySpecifier = ('answer' | 'answerOptions' | 'category' | 'confidenceReason' | 'confidenceScore' | 'createdAt' | 'createdBy' | 'lastUpdatedBy' | 'question' | 'reasoning' | 'riskAreas' | 'rowId' | 'sourcesUsed' | 'updatedAt' | 'uuid' | 'validationArguments' | 'validationOperator' | 'validationType' | RespondQuestionnaireEntryKeySpecifier)[];
export type RespondQuestionnaireEntryFieldPolicy = {
	answer?: FieldPolicy<any> | FieldReadFunction<any>,
	answerOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	confidenceReason?: FieldPolicy<any> | FieldReadFunction<any>,
	confidenceScore?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>,
	reasoning?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	rowId?: FieldPolicy<any> | FieldReadFunction<any>,
	sourcesUsed?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	validationArguments?: FieldPolicy<any> | FieldReadFunction<any>,
	validationOperator?: FieldPolicy<any> | FieldReadFunction<any>,
	validationType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RespondQuestionnaireEntryConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | RespondQuestionnaireEntryConnectionKeySpecifier)[];
export type RespondQuestionnaireEntryConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RespondQuestionnaireEntryEdgeKeySpecifier = ('cursor' | 'node' | RespondQuestionnaireEntryEdgeKeySpecifier)[];
export type RespondQuestionnaireEntryEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RespondQuestionnaireV2KeySpecifier = ('answeredEntriesCount' | 'conflictingEntriesCount' | 'createdAt' | 'createdBy' | 'entries' | 'entriesCount' | 'fileName' | 'filledFile' | 'hasConflictingEntries' | 'lastReviewedAt' | 'lastUpdatedAt' | 'lastUpdatedBy' | 'name' | 'originalFile' | 'riskAreas' | 'sourcesUsed' | 'status' | 'totalConflictsCount' | 'uuid' | RespondQuestionnaireV2KeySpecifier)[];
export type RespondQuestionnaireV2FieldPolicy = {
	answeredEntriesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	conflictingEntriesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	entries?: FieldPolicy<any> | FieldReadFunction<any>,
	entriesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	fileName?: FieldPolicy<any> | FieldReadFunction<any>,
	filledFile?: FieldPolicy<any> | FieldReadFunction<any>,
	hasConflictingEntries?: FieldPolicy<any> | FieldReadFunction<any>,
	lastReviewedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	originalFile?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	sourcesUsed?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	totalConflictsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RespondQuestionnaireV2ConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | RespondQuestionnaireV2ConnectionKeySpecifier)[];
export type RespondQuestionnaireV2ConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RespondQuestionnaireV2EdgeKeySpecifier = ('cursor' | 'node' | RespondQuestionnaireV2EdgeKeySpecifier)[];
export type RespondQuestionnaireV2EdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RiskAreaKeySpecifier = ('category' | 'color' | 'customLabel' | 'groupTags' | 'groupedStatistics' | 'guidelineMain' | 'guidelines' | 'guidelinesCategories' | 'hasSomeIndustryEnabled' | 'history' | 'isEnabled' | 'isMigrated' | 'isShared' | 'label' | 'lastActiveDate' | 'linkedTags' | 'mergedRiskAreas' | 'name' | 'order' | 'path' | 'riskAreas' | 'sectors' | 'statistics' | 'steps' | 'tags' | 'targetRiskArea' | 'type' | 'units' | 'uuid' | RiskAreaKeySpecifier)[];
export type RiskAreaFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	customLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	groupTags?: FieldPolicy<any> | FieldReadFunction<any>,
	groupedStatistics?: FieldPolicy<any> | FieldReadFunction<any>,
	guidelineMain?: FieldPolicy<any> | FieldReadFunction<any>,
	guidelines?: FieldPolicy<any> | FieldReadFunction<any>,
	guidelinesCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	hasSomeIndustryEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	history?: FieldPolicy<any> | FieldReadFunction<any>,
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	isMigrated?: FieldPolicy<any> | FieldReadFunction<any>,
	isShared?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	lastActiveDate?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedTags?: FieldPolicy<any> | FieldReadFunction<any>,
	mergedRiskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	path?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	sectors?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>,
	steps?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	targetRiskArea?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	units?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RiskAreasWithAnyQuestionsElementKeySpecifier = ('riskArea' | RiskAreasWithAnyQuestionsElementKeySpecifier)[];
export type RiskAreasWithAnyQuestionsElementFieldPolicy = {
	riskArea?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RoleKeySpecifier = ('description' | 'editMode' | 'isActive' | 'name' | 'permissions' | 'regions' | 'riskAreas' | 'users' | 'uuid' | RoleKeySpecifier)[];
export type RoleFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	editMode?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	permissions?: FieldPolicy<any> | FieldReadFunction<any>,
	regions?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RoleConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | RoleConnectionKeySpecifier)[];
export type RoleConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RoleEdgeKeySpecifier = ('cursor' | 'node' | RoleEdgeKeySpecifier)[];
export type RoleEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RoleRiskAreaKeySpecifier = ('permissions' | 'riskArea' | RoleRiskAreaKeySpecifier)[];
export type RoleRiskAreaFieldPolicy = {
	permissions?: FieldPolicy<any> | FieldReadFunction<any>,
	riskArea?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ScopeFilterKeySpecifier = ('filter' | 'isFilterEnabled' | ScopeFilterKeySpecifier)[];
export type ScopeFilterFieldPolicy = {
	filter?: FieldPolicy<any> | FieldReadFunction<any>,
	isFilterEnabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SectorKeySpecifier = ('description' | 'isDefault' | 'isEnabled' | 'name' | 'order' | 'units' | 'uuid' | SectorKeySpecifier)[];
export type SectorFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	isDefault?: FieldPolicy<any> | FieldReadFunction<any>,
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	units?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SectorConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | SectorConnectionKeySpecifier)[];
export type SectorConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SectorEdgeKeySpecifier = ('cursor' | 'node' | SectorEdgeKeySpecifier)[];
export type SectorEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SessionKeySpecifier = ('refreshToken' | 'sessionToken' | SessionKeySpecifier)[];
export type SessionFieldPolicy = {
	refreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionToken?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SessionPayloadKeySpecifier = ('firebaseToken' | 'metadata' | 'mfa' | 'refreshToken' | 'sessionToken' | SessionPayloadKeySpecifier)[];
export type SessionPayloadFieldPolicy = {
	firebaseToken?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	mfa?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionToken?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SessionWithOaExchangeKeySpecifier = ('metadata' | 'mobileApiToken' | 'oaExchangeToken' | 'refreshToken' | 'sessionToken' | SessionWithOaExchangeKeySpecifier)[];
export type SessionWithOaExchangeFieldPolicy = {
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	mobileApiToken?: FieldPolicy<any> | FieldReadFunction<any>,
	oaExchangeToken?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionToken?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SmartFillDraftAnswerKeySpecifier = ('confidence' | 'draftAnswer' | 'isAiDraft' | 'question' | 'sources' | 'status' | SmartFillDraftAnswerKeySpecifier)[];
export type SmartFillDraftAnswerFieldPolicy = {
	confidence?: FieldPolicy<any> | FieldReadFunction<any>,
	draftAnswer?: FieldPolicy<any> | FieldReadFunction<any>,
	isAiDraft?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>,
	sources?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SmartFillJobKeySpecifier = ('drafts' | 'programme' | 'riskArea' | 'status' | 'uuid' | SmartFillJobKeySpecifier)[];
export type SmartFillJobFieldPolicy = {
	drafts?: FieldPolicy<any> | FieldReadFunction<any>,
	programme?: FieldPolicy<any> | FieldReadFunction<any>,
	riskArea?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SmartFillSourceKeySpecifier = ('file' | 'sectionOrExcerpt' | 'type' | SmartFillSourceKeySpecifier)[];
export type SmartFillSourceFieldPolicy = {
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionOrExcerpt?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SsoAccountKeySpecifier = ('provider' | 'ssoUuid' | SsoAccountKeySpecifier)[];
export type SsoAccountFieldPolicy = {
	provider?: FieldPolicy<any> | FieldReadFunction<any>,
	ssoUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SsoAuthPayloadKeySpecifier = ('refreshToken' | 'sessionToken' | SsoAuthPayloadKeySpecifier)[];
export type SsoAuthPayloadFieldPolicy = {
	refreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionToken?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SsoAzureTenantInformationKeySpecifier = ('azureTenantId' | 'canLogin' | 'enabled' | SsoAzureTenantInformationKeySpecifier)[];
export type SsoAzureTenantInformationFieldPolicy = {
	azureTenantId?: FieldPolicy<any> | FieldReadFunction<any>,
	canLogin?: FieldPolicy<any> | FieldReadFunction<any>,
	enabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SsoProviderKeySpecifier = ('appId' | 'loginUrl' | 'provider' | 'providerId' | 'samlCertificate' | 'uuid' | SsoProviderKeySpecifier)[];
export type SsoProviderFieldPolicy = {
	appId?: FieldPolicy<any> | FieldReadFunction<any>,
	loginUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	provider?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	samlCertificate?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SsoSamlTenantInformationKeySpecifier = ('canLogin' | 'enabled' | SsoSamlTenantInformationKeySpecifier)[];
export type SsoSamlTenantInformationFieldPolicy = {
	canLogin?: FieldPolicy<any> | FieldReadFunction<any>,
	enabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SsoTenantInformationKeySpecifier = ('azure' | 'saml' | SsoTenantInformationKeySpecifier)[];
export type SsoTenantInformationFieldPolicy = {
	azure?: FieldPolicy<any> | FieldReadFunction<any>,
	saml?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StakeholderEngagementCommonDataKeySpecifier = ('audienceType' | 'canEdit' | 'countries' | 'createdAt' | 'description' | 'isAuthor' | 'json' | 'name' | 'relationships' | 'riskAreas' | 'updatedAt' | 'uuid' | StakeholderEngagementCommonDataKeySpecifier)[];
export type StakeholderEngagementCommonDataFieldPolicy = {
	audienceType?: FieldPolicy<any> | FieldReadFunction<any>,
	canEdit?: FieldPolicy<any> | FieldReadFunction<any>,
	countries?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	isAuthor?: FieldPolicy<any> | FieldReadFunction<any>,
	json?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	relationships?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StakeholderEngagementConnectionConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | StakeholderEngagementConnectionConnectionKeySpecifier)[];
export type StakeholderEngagementConnectionConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StakeholderEngagementConnectionEdgeKeySpecifier = ('cursor' | 'node' | StakeholderEngagementConnectionEdgeKeySpecifier)[];
export type StakeholderEngagementConnectionEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StandardAssignedRiskAreaEdgeKeySpecifier = ('cursor' | 'node' | StandardAssignedRiskAreaEdgeKeySpecifier)[];
export type StandardAssignedRiskAreaEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StandardAssignedRiskAreasConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | StandardAssignedRiskAreasConnectionKeySpecifier)[];
export type StandardAssignedRiskAreasConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StandardItemKeySpecifier = ('checked' | 'name' | 'unitsUuids' | 'uuid' | StandardItemKeySpecifier)[];
export type StandardItemFieldPolicy = {
	checked?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	unitsUuids?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubscriptionPlanKeySpecifier = ('features' | 'modules' | 'name' | 'uuid' | SubscriptionPlanKeySpecifier)[];
export type SubscriptionPlanFieldPolicy = {
	features?: FieldPolicy<any> | FieldReadFunction<any>,
	modules?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubsidiarySiteKeySpecifier = ('admins' | 'caseOwnerExclusion' | 'isActive' | 'isHeadquarters' | 'name' | 'reportingGroup' | 'reportingLabel' | 'reportingSlug' | 'reportingUrl' | 'userCount' | 'users' | 'uuid' | SubsidiarySiteKeySpecifier)[];
export type SubsidiarySiteFieldPolicy = {
	admins?: FieldPolicy<any> | FieldReadFunction<any>,
	caseOwnerExclusion?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isHeadquarters?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingSlug?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	userCount?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubsidiarySiteEdgeKeySpecifier = ('cursor' | 'node' | SubsidiarySiteEdgeKeySpecifier)[];
export type SubsidiarySiteEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubsidiarySiteReportingSettingsKeySpecifier = ('canEdit' | 'defaultCopy' | 'isEnabled' | 'subsidiarySelectionCopy' | 'useCustomCopy' | SubsidiarySiteReportingSettingsKeySpecifier)[];
export type SubsidiarySiteReportingSettingsFieldPolicy = {
	canEdit?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultCopy?: FieldPolicy<any> | FieldReadFunction<any>,
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySelectionCopy?: FieldPolicy<any> | FieldReadFunction<any>,
	useCustomCopy?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubsidiarySitesConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | SubsidiarySitesConnectionKeySpecifier)[];
export type SubsidiarySitesConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SupportedMobileAppVersionsKeySpecifier = ('android' | 'ios' | SupportedMobileAppVersionsKeySpecifier)[];
export type SupportedMobileAppVersionsFieldPolicy = {
	android?: FieldPolicy<any> | FieldReadFunction<any>,
	ios?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyKeySpecifier = ('audienceType' | 'canEdit' | 'countries' | 'createdAt' | 'createdBy' | 'createdByName' | 'daysValidity' | 'description' | 'emailTargets' | 'emailTargetsCount' | 'endDate' | 'isAuthor' | 'json' | 'lastUpdatedAt' | 'name' | 'relationships' | 'reminder' | 'respondersCountPerDay' | 'respondersTotalCount' | 'riskAreas' | 'startDate' | 'status' | 'updatedAt' | 'uuid' | SurveyKeySpecifier)[];
export type SurveyFieldPolicy = {
	audienceType?: FieldPolicy<any> | FieldReadFunction<any>,
	canEdit?: FieldPolicy<any> | FieldReadFunction<any>,
	countries?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByName?: FieldPolicy<any> | FieldReadFunction<any>,
	daysValidity?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	emailTargets?: FieldPolicy<any> | FieldReadFunction<any>,
	emailTargetsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	isAuthor?: FieldPolicy<any> | FieldReadFunction<any>,
	json?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	relationships?: FieldPolicy<any> | FieldReadFunction<any>,
	reminder?: FieldPolicy<any> | FieldReadFunction<any>,
	respondersCountPerDay?: FieldPolicy<any> | FieldReadFunction<any>,
	respondersTotalCount?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'statistics' | 'totalCount' | SurveyConnectionKeySpecifier)[];
export type SurveyConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyEdgeKeySpecifier = ('cursor' | 'node' | SurveyEdgeKeySpecifier)[];
export type SurveyEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyEmailTargetKeySpecifier = ('answered' | 'email' | 'sent' | 'surveyAnswer' | 'uuid' | SurveyEmailTargetKeySpecifier)[];
export type SurveyEmailTargetFieldPolicy = {
	answered?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	sent?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyAnswer?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyPageKeySpecifier = ('edges' | 'info' | SurveyPageKeySpecifier)[];
export type SurveyPageFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	info?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyPaginatedKeySpecifier = ('page' | 'statistics' | 'totalCount' | SurveyPaginatedKeySpecifier)[];
export type SurveyPaginatedFieldPolicy = {
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyReportUploadResponseKeySpecifier = ('s3Url' | SurveyReportUploadResponseKeySpecifier)[];
export type SurveyReportUploadResponseFieldPolicy = {
	s3Url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyResponseKeySpecifier = ('createdAt' | 'createdByName' | 'createdByUuid' | 'json' | 'source' | 'surveyUuid' | 'uuid' | SurveyResponseKeySpecifier)[];
export type SurveyResponseFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByName?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	json?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyResponseEdgeKeySpecifier = ('cursor' | 'node' | SurveyResponseEdgeKeySpecifier)[];
export type SurveyResponseEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyResponsePageKeySpecifier = ('edges' | 'info' | SurveyResponsePageKeySpecifier)[];
export type SurveyResponsePageFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	info?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyResponsePaginatedKeySpecifier = ('page' | 'surveyData' | 'totalCount' | SurveyResponsePaginatedKeySpecifier)[];
export type SurveyResponsePaginatedFieldPolicy = {
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	surveyData?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyStatisticsKeySpecifier = ('completedCount' | 'ongoingCount' | 'scheduledCount' | SurveyStatisticsKeySpecifier)[];
export type SurveyStatisticsFieldPolicy = {
	completedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	ongoingCount?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduledCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveySummaryKeySpecifier = ('url' | SurveySummaryKeySpecifier)[];
export type SurveySummaryFieldPolicy = {
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyTemplateKeySpecifier = ('canEdit' | 'createdAt' | 'createdByName' | 'isAuthor' | 'isPublic' | 'json' | 'lastUpdatedAt' | 'name' | 'type' | 'uuid' | SurveyTemplateKeySpecifier)[];
export type SurveyTemplateFieldPolicy = {
	canEdit?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByName?: FieldPolicy<any> | FieldReadFunction<any>,
	isAuthor?: FieldPolicy<any> | FieldReadFunction<any>,
	isPublic?: FieldPolicy<any> | FieldReadFunction<any>,
	json?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyTemplateEdgeKeySpecifier = ('cursor' | 'node' | SurveyTemplateEdgeKeySpecifier)[];
export type SurveyTemplateEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyTemplatePageKeySpecifier = ('edges' | 'info' | SurveyTemplatePageKeySpecifier)[];
export type SurveyTemplatePageFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	info?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyTemplatePaginatedKeySpecifier = ('page' | 'totalCount' | SurveyTemplatePaginatedKeySpecifier)[];
export type SurveyTemplatePaginatedFieldPolicy = {
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SurveyTemplateTypeKeySpecifier = ('isOwner' | 'isStandardTemplate' | 'label' | SurveyTemplateTypeKeySpecifier)[];
export type SurveyTemplateTypeFieldPolicy = {
	isOwner?: FieldPolicy<any> | FieldReadFunction<any>,
	isStandardTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SymbolKeySpecifier = ('denotation' | 'isSeeded' | 'name' | 'uuid' | SymbolKeySpecifier)[];
export type SymbolFieldPolicy = {
	denotation?: FieldPolicy<any> | FieldReadFunction<any>,
	isSeeded?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SymbolConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | SymbolConnectionKeySpecifier)[];
export type SymbolConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SymbolEdgeKeySpecifier = ('cursor' | 'node' | SymbolEdgeKeySpecifier)[];
export type SymbolEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TagKeySpecifier = ('color' | 'createdAt' | 'createdBy' | 'description' | 'groupTag' | 'isPublic' | 'name' | 'tenant' | 'updatedAt' | 'updatedBy' | 'uuid' | TagKeySpecifier)[];
export type TagFieldPolicy = {
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	groupTag?: FieldPolicy<any> | FieldReadFunction<any>,
	isPublic?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TagConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | TagConnectionKeySpecifier)[];
export type TagConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TagEdgeKeySpecifier = ('cursor' | 'node' | TagEdgeKeySpecifier)[];
export type TagEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TagsSelectConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | TagsSelectConnectionKeySpecifier)[];
export type TagsSelectConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TargetKeySpecifier = ('baseYear' | 'createdBy' | 'description' | 'direction' | 'goals' | 'lastUpdatedBy' | 'metric' | 'name' | 'points' | 'targetData' | 'targetYear' | 'trackedCellAddress' | 'trackedDataRowId' | 'trackedDataSubRowId' | 'unit' | 'uuid' | TargetKeySpecifier)[];
export type TargetFieldPolicy = {
	baseYear?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	direction?: FieldPolicy<any> | FieldReadFunction<any>,
	goals?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	metric?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	points?: FieldPolicy<any> | FieldReadFunction<any>,
	targetData?: FieldPolicy<any> | FieldReadFunction<any>,
	targetYear?: FieldPolicy<any> | FieldReadFunction<any>,
	trackedCellAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	trackedDataRowId?: FieldPolicy<any> | FieldReadFunction<any>,
	trackedDataSubRowId?: FieldPolicy<any> | FieldReadFunction<any>,
	unit?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TargetConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | TargetConnectionKeySpecifier)[];
export type TargetConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TargetDataKeySpecifier = ('currentValue' | 'isBaseYear' | 'predictedValue' | 'targetValue' | 'unit' | 'year' | TargetDataKeySpecifier)[];
export type TargetDataFieldPolicy = {
	currentValue?: FieldPolicy<any> | FieldReadFunction<any>,
	isBaseYear?: FieldPolicy<any> | FieldReadFunction<any>,
	predictedValue?: FieldPolicy<any> | FieldReadFunction<any>,
	targetValue?: FieldPolicy<any> | FieldReadFunction<any>,
	unit?: FieldPolicy<any> | FieldReadFunction<any>,
	year?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TargetEdgeKeySpecifier = ('cursor' | 'node' | TargetEdgeKeySpecifier)[];
export type TargetEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TargetGoalsKeySpecifier = ('uuid' | 'value' | 'year' | TargetGoalsKeySpecifier)[];
export type TargetGoalsFieldPolicy = {
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>,
	year?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TargetRiskAreaKeySpecifier = ('customLabel' | 'name' | 'uuid' | TargetRiskAreaKeySpecifier)[];
export type TargetRiskAreaFieldPolicy = {
	customLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskKeySpecifier = ('assignee' | 'assignor' | 'comments' | 'createdAt' | 'description' | 'dueDate' | 'expiryDate' | 'id' | 'isNew' | 'lastUpdatedAt' | 'metadata' | 'riskArea' | 'status' | 'title' | 'type' | 'uuid' | 'year' | TaskKeySpecifier)[];
export type TaskFieldPolicy = {
	assignee?: FieldPolicy<any> | FieldReadFunction<any>,
	assignor?: FieldPolicy<any> | FieldReadFunction<any>,
	comments?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	dueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	expiryDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isNew?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	riskArea?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	year?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskCommentKeySpecifier = ('content' | 'createdAt' | 'createdBy' | 'lastUpdatedAt' | 'newStatus' | 'type' | 'uuid' | TaskCommentKeySpecifier)[];
export type TaskCommentFieldPolicy = {
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	newStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'statistics' | 'totalCount' | TaskConnectionKeySpecifier)[];
export type TaskConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskEdgeKeySpecifier = ('cursor' | 'node' | TaskEdgeKeySpecifier)[];
export type TaskEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskMetadataKeySpecifier = ('answer' | 'disabledReason' | 'programme' | 'question' | 'riskArea' | 'stage' | 'standard' | 'versionTag' | TaskMetadataKeySpecifier)[];
export type TaskMetadataFieldPolicy = {
	answer?: FieldPolicy<any> | FieldReadFunction<any>,
	disabledReason?: FieldPolicy<any> | FieldReadFunction<any>,
	programme?: FieldPolicy<any> | FieldReadFunction<any>,
	question?: FieldPolicy<any> | FieldReadFunction<any>,
	riskArea?: FieldPolicy<any> | FieldReadFunction<any>,
	stage?: FieldPolicy<any> | FieldReadFunction<any>,
	standard?: FieldPolicy<any> | FieldReadFunction<any>,
	versionTag?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskNameHintKeySpecifier = ('title' | 'uuid' | TaskNameHintKeySpecifier)[];
export type TaskNameHintFieldPolicy = {
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskNameHintConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | TaskNameHintConnectionKeySpecifier)[];
export type TaskNameHintConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskNameHintEdgeKeySpecifier = ('cursor' | 'node' | TaskNameHintEdgeKeySpecifier)[];
export type TaskNameHintEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskStatisticsKeySpecifier = ('closedCount' | 'inProgressCount' | 'inProgressWithoutUpcomingAndOverdueCount' | 'newCount' | 'openedCount' | 'overDueAndUpcomingCount' | 'overdueCount' | 'totalCount' | 'upcomingCount' | TaskStatisticsKeySpecifier)[];
export type TaskStatisticsFieldPolicy = {
	closedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	inProgressCount?: FieldPolicy<any> | FieldReadFunction<any>,
	inProgressWithoutUpcomingAndOverdueCount?: FieldPolicy<any> | FieldReadFunction<any>,
	newCount?: FieldPolicy<any> | FieldReadFunction<any>,
	openedCount?: FieldPolicy<any> | FieldReadFunction<any>,
	overDueAndUpcomingCount?: FieldPolicy<any> | FieldReadFunction<any>,
	overdueCount?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>,
	upcomingCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TasksDashboardFiltersKeySpecifier = ('assignee' | 'assignor' | 'module' | 'status' | TasksDashboardFiltersKeySpecifier)[];
export type TasksDashboardFiltersFieldPolicy = {
	assignee?: FieldPolicy<any> | FieldReadFunction<any>,
	assignor?: FieldPolicy<any> | FieldReadFunction<any>,
	module?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TasksDashboardSortKeySpecifier = ('direction' | 'field' | TasksDashboardSortKeySpecifier)[];
export type TasksDashboardSortFieldPolicy = {
	direction?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TasksUserTypeEdgeKeySpecifier = ('cursor' | 'node' | TasksUserTypeEdgeKeySpecifier)[];
export type TasksUserTypeEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyKeySpecifier = ('name' | 'uuid' | 'version' | TaxonomyKeySpecifier)[];
export type TaxonomyFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyComplexUnitKeySpecifier = ('denominator' | 'label' | 'numerator' | TaxonomyComplexUnitKeySpecifier)[];
export type TaxonomyComplexUnitFieldPolicy = {
	denominator?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	numerator?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyConceptKeySpecifier = ('dimensionSets' | 'enumeration' | 'formats' | 'itemType' | 'label' | 'name' | 'periodType' | 'trees' | 'units' | 'uuid' | TaxonomyConceptKeySpecifier)[];
export type TaxonomyConceptFieldPolicy = {
	dimensionSets?: FieldPolicy<any> | FieldReadFunction<any>,
	enumeration?: FieldPolicy<any> | FieldReadFunction<any>,
	formats?: FieldPolicy<any> | FieldReadFunction<any>,
	itemType?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	periodType?: FieldPolicy<any> | FieldReadFunction<any>,
	trees?: FieldPolicy<any> | FieldReadFunction<any>,
	units?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyConceptConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | TaxonomyConceptConnectionKeySpecifier)[];
export type TaxonomyConceptConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyConceptEdgeKeySpecifier = ('cursor' | 'node' | TaxonomyConceptEdgeKeySpecifier)[];
export type TaxonomyConceptEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | TaxonomyConnectionKeySpecifier)[];
export type TaxonomyConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyDimensionSetKeySpecifier = ('definition' | 'dimensions' | 'label' | 'name' | 'uuid' | TaxonomyDimensionSetKeySpecifier)[];
export type TaxonomyDimensionSetFieldPolicy = {
	definition?: FieldPolicy<any> | FieldReadFunction<any>,
	dimensions?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyDomainKeySpecifier = ('default' | 'label' | 'members' | 'name' | TaxonomyDomainKeySpecifier)[];
export type TaxonomyDomainFieldPolicy = {
	default?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	members?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyEdgeKeySpecifier = ('cursor' | 'node' | TaxonomyEdgeKeySpecifier)[];
export type TaxonomyEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyEnumerationKeySpecifier = ('label' | 'name' | 'uuid' | 'values' | TaxonomyEnumerationKeySpecifier)[];
export type TaxonomyEnumerationFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyEnumerationValueKeySpecifier = ('label' | 'name' | 'value' | TaxonomyEnumerationValueKeySpecifier)[];
export type TaxonomyEnumerationValueFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyExplicitDimensionKeySpecifier = ('domains' | 'label' | 'name' | 'type' | TaxonomyExplicitDimensionKeySpecifier)[];
export type TaxonomyExplicitDimensionFieldPolicy = {
	domains?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyFormatKeySpecifier = ('label' | 'name' | TaxonomyFormatKeySpecifier)[];
export type TaxonomyFormatFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyMemberKeySpecifier = ('label' | 'name' | TaxonomyMemberKeySpecifier)[];
export type TaxonomyMemberFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyReportKeySpecifier = ('audits' | 'collaborators' | 'createdAt' | 'facts' | 'file' | 'filingId' | 'name' | 'pagesCount' | 'preparer' | 'statistics' | 'status' | 'updatedAt' | 'uuid' | TaxonomyReportKeySpecifier)[];
export type TaxonomyReportFieldPolicy = {
	audits?: FieldPolicy<any> | FieldReadFunction<any>,
	collaborators?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	facts?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	filingId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	pagesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	preparer?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyReportAuditKeySpecifier = ('action' | 'changedAt' | 'changedBy' | 'uuid' | TaxonomyReportAuditKeySpecifier)[];
export type TaxonomyReportAuditFieldPolicy = {
	action?: FieldPolicy<any> | FieldReadFunction<any>,
	changedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	changedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyReportAuditConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | TaxonomyReportAuditConnectionKeySpecifier)[];
export type TaxonomyReportAuditConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyReportAuditEdgeKeySpecifier = ('cursor' | 'node' | TaxonomyReportAuditEdgeKeySpecifier)[];
export type TaxonomyReportAuditEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyReportConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | TaxonomyReportConnectionKeySpecifier)[];
export type TaxonomyReportConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyReportEdgeKeySpecifier = ('cursor' | 'node' | TaxonomyReportEdgeKeySpecifier)[];
export type TaxonomyReportEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyReportFactKeySpecifier = ('color' | 'concept' | 'conceptUuid' | 'dimensionSetUuid' | 'entityName' | 'hidden' | 'itemDecimals' | 'itemFormat' | 'itemType' | 'itemUnit' | 'itemValue' | 'lines' | 'page' | 'periodDuration' | 'periodInstant' | 'periodType' | 'report' | 'reportUuid' | 'scenarios' | 'uuid' | TaxonomyReportFactKeySpecifier)[];
export type TaxonomyReportFactFieldPolicy = {
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	concept?: FieldPolicy<any> | FieldReadFunction<any>,
	conceptUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	dimensionSetUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	entityName?: FieldPolicy<any> | FieldReadFunction<any>,
	hidden?: FieldPolicy<any> | FieldReadFunction<any>,
	itemDecimals?: FieldPolicy<any> | FieldReadFunction<any>,
	itemFormat?: FieldPolicy<any> | FieldReadFunction<any>,
	itemType?: FieldPolicy<any> | FieldReadFunction<any>,
	itemUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	itemValue?: FieldPolicy<any> | FieldReadFunction<any>,
	lines?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	periodDuration?: FieldPolicy<any> | FieldReadFunction<any>,
	periodInstant?: FieldPolicy<any> | FieldReadFunction<any>,
	periodType?: FieldPolicy<any> | FieldReadFunction<any>,
	report?: FieldPolicy<any> | FieldReadFunction<any>,
	reportUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	scenarios?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyReportFactConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | TaxonomyReportFactConnectionKeySpecifier)[];
export type TaxonomyReportFactConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyReportFactEdgeKeySpecifier = ('cursor' | 'node' | TaxonomyReportFactEdgeKeySpecifier)[];
export type TaxonomyReportFactEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyReportFactLineKeySpecifier = ('end' | 'line' | 'start' | TaxonomyReportFactLineKeySpecifier)[];
export type TaxonomyReportFactLineFieldPolicy = {
	end?: FieldPolicy<any> | FieldReadFunction<any>,
	line?: FieldPolicy<any> | FieldReadFunction<any>,
	start?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyReportFactPeriodDurationKeySpecifier = ('end' | 'start' | TaxonomyReportFactPeriodDurationKeySpecifier)[];
export type TaxonomyReportFactPeriodDurationFieldPolicy = {
	end?: FieldPolicy<any> | FieldReadFunction<any>,
	start?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyReportFactScenarioKeySpecifier = ('dimension' | 'member' | TaxonomyReportFactScenarioKeySpecifier)[];
export type TaxonomyReportFactScenarioFieldPolicy = {
	dimension?: FieldPolicy<any> | FieldReadFunction<any>,
	member?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyReportPageKeySpecifier = ('html' | 'page' | 'report' | 'reportUuid' | 'screenshot' | 'text' | 'uuid' | TaxonomyReportPageKeySpecifier)[];
export type TaxonomyReportPageFieldPolicy = {
	html?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	report?: FieldPolicy<any> | FieldReadFunction<any>,
	reportUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	screenshot?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyReportStatisticsKeySpecifier = ('hiddenCount' | 'missingCount' | 'visibleCount' | TaxonomyReportStatisticsKeySpecifier)[];
export type TaxonomyReportStatisticsFieldPolicy = {
	hiddenCount?: FieldPolicy<any> | FieldReadFunction<any>,
	missingCount?: FieldPolicy<any> | FieldReadFunction<any>,
	visibleCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomySimpleUnitKeySpecifier = ('label' | 'measure' | TaxonomySimpleUnitKeySpecifier)[];
export type TaxonomySimpleUnitFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	measure?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxonomyTypedDimensionKeySpecifier = ('domain' | 'label' | 'name' | 'type' | TaxonomyTypedDimensionKeySpecifier)[];
export type TaxonomyTypedDimensionFieldPolicy = {
	domain?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TemplateKeySpecifier = ('createdAt' | 'createdBy' | 'createdByName' | 'isPublic' | 'json' | 'lastUpdatedAt' | 'name' | 'riskAreas' | 'scope' | 'type' | 'uuid' | TemplateKeySpecifier)[];
export type TemplateFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByName?: FieldPolicy<any> | FieldReadFunction<any>,
	isPublic?: FieldPolicy<any> | FieldReadFunction<any>,
	json?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreas?: FieldPolicy<any> | FieldReadFunction<any>,
	scope?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TemplateConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | TemplateConnectionKeySpecifier)[];
export type TemplateConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TemplateEdgeKeySpecifier = ('cursor' | 'node' | TemplateEdgeKeySpecifier)[];
export type TemplateEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TemplateTypeKeySpecifier = ('isOwner' | 'isStandardTemplate' | 'label' | TemplateTypeKeySpecifier)[];
export type TemplateTypeFieldPolicy = {
	isOwner?: FieldPolicy<any> | FieldReadFunction<any>,
	isStandardTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantBaseDataTypeKeySpecifier = ('activeYear' | 'assetSettings' | 'caseOwnerExclusion' | 'code' | 'defaultAnswerVersionLabel' | 'elineNumbers' | 'enforceMfa' | 'features' | 'forwardEarthUrl' | 'groupTags' | 'hasSomeIndustryEnabled' | 'headline' | 'headlineTranslated' | 'homeContent' | 'homeContentTranslated' | 'htmlBanner' | 'incidentTypes' | 'industryUnits' | 'lastRenewalRequestSentAt' | 'license' | 'logo' | 'modules' | 'name' | 'policiesContent' | 'policiesContentTranslated' | 'region' | 'regions' | 'reportSettings' | 'reportingGroup' | 'reportingGroups' | 'reportingPeriod' | 'reportingSlug' | 'reportingUrl' | 'ssoProviders' | 'ssoSamlRequestUrl' | 'standards' | 'subscriptionPlan' | 'subsidiarySite' | 'subsidiarySites' | 'tags' | 'users' | 'uuid' | 'years' | TenantBaseDataTypeKeySpecifier)[];
export type TenantBaseDataTypeFieldPolicy = {
	activeYear?: FieldPolicy<any> | FieldReadFunction<any>,
	assetSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	caseOwnerExclusion?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultAnswerVersionLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	elineNumbers?: FieldPolicy<any> | FieldReadFunction<any>,
	enforceMfa?: FieldPolicy<any> | FieldReadFunction<any>,
	features?: FieldPolicy<any> | FieldReadFunction<any>,
	forwardEarthUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	groupTags?: FieldPolicy<any> | FieldReadFunction<any>,
	hasSomeIndustryEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	headline?: FieldPolicy<any> | FieldReadFunction<any>,
	headlineTranslated?: FieldPolicy<any> | FieldReadFunction<any>,
	homeContent?: FieldPolicy<any> | FieldReadFunction<any>,
	homeContentTranslated?: FieldPolicy<any> | FieldReadFunction<any>,
	htmlBanner?: FieldPolicy<any> | FieldReadFunction<any>,
	incidentTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	industryUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	lastRenewalRequestSentAt?: FieldPolicy<any> | FieldReadFunction<any>,
	license?: FieldPolicy<any> | FieldReadFunction<any>,
	logo?: FieldPolicy<any> | FieldReadFunction<any>,
	modules?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	policiesContent?: FieldPolicy<any> | FieldReadFunction<any>,
	policiesContentTranslated?: FieldPolicy<any> | FieldReadFunction<any>,
	region?: FieldPolicy<any> | FieldReadFunction<any>,
	regions?: FieldPolicy<any> | FieldReadFunction<any>,
	reportSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingPeriod?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingSlug?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	ssoProviders?: FieldPolicy<any> | FieldReadFunction<any>,
	ssoSamlRequestUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	standards?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionPlan?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySite?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySites?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	years?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantModuleSettingsKeySpecifier = ('CARBON_LENS' | 'CASES' | 'DEMO' | 'DISCLOSURES' | 'DUE_DILIGENCE' | 'ESG' | 'INSIGHTS' | 'NICOLE_GPT' | 'SSO' | 'SUBSIDIARY_SITES' | 'SURVEYS' | 'TASKS' | 'TEAMS' | 'TRAININGS' | 'cases' | 'disclosures' | 'sso' | 'subsidiary_sites' | 'surveys' | 'teams' | 'teamsTenantId' | 'trainings' | TenantModuleSettingsKeySpecifier)[];
export type TenantModuleSettingsFieldPolicy = {
	CARBON_LENS?: FieldPolicy<any> | FieldReadFunction<any>,
	CASES?: FieldPolicy<any> | FieldReadFunction<any>,
	DEMO?: FieldPolicy<any> | FieldReadFunction<any>,
	DISCLOSURES?: FieldPolicy<any> | FieldReadFunction<any>,
	DUE_DILIGENCE?: FieldPolicy<any> | FieldReadFunction<any>,
	ESG?: FieldPolicy<any> | FieldReadFunction<any>,
	INSIGHTS?: FieldPolicy<any> | FieldReadFunction<any>,
	NICOLE_GPT?: FieldPolicy<any> | FieldReadFunction<any>,
	SSO?: FieldPolicy<any> | FieldReadFunction<any>,
	SUBSIDIARY_SITES?: FieldPolicy<any> | FieldReadFunction<any>,
	SURVEYS?: FieldPolicy<any> | FieldReadFunction<any>,
	TASKS?: FieldPolicy<any> | FieldReadFunction<any>,
	TEAMS?: FieldPolicy<any> | FieldReadFunction<any>,
	TRAININGS?: FieldPolicy<any> | FieldReadFunction<any>,
	cases?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosures?: FieldPolicy<any> | FieldReadFunction<any>,
	sso?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiary_sites?: FieldPolicy<any> | FieldReadFunction<any>,
	surveys?: FieldPolicy<any> | FieldReadFunction<any>,
	teams?: FieldPolicy<any> | FieldReadFunction<any>,
	teamsTenantId?: FieldPolicy<any> | FieldReadFunction<any>,
	trainings?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantReportingPeriodKeySpecifier = ('isPeriodSet' | 'reportingPeriodStart' | 'tenantUuid' | TenantReportingPeriodKeySpecifier)[];
export type TenantReportingPeriodFieldPolicy = {
	isPeriodSet?: FieldPolicy<any> | FieldReadFunction<any>,
	reportingPeriodStart?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantRiskAreaSettingKeySpecifier = ('customLabel' | 'isEnabled' | 'name' | 'riskAreaUuid' | 'targetRiskArea' | TenantRiskAreaSettingKeySpecifier)[];
export type TenantRiskAreaSettingFieldPolicy = {
	customLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	riskAreaUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	targetRiskArea?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantRiskAreaSettingsKeySpecifier = ('riskAreaSettings' | 'tenantUuid' | TenantRiskAreaSettingsKeySpecifier)[];
export type TenantRiskAreaSettingsFieldPolicy = {
	riskAreaSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantSamlRequestDetailsKeySpecifier = ('samlRequestUrl' | TenantSamlRequestDetailsKeySpecifier)[];
export type TenantSamlRequestDetailsFieldPolicy = {
	samlRequestUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantSubscriptionKeySpecifier = ('daysToExpire' | 'endDate' | 'planName' | 'startDate' | TenantSubscriptionKeySpecifier)[];
export type TenantSubscriptionFieldPolicy = {
	daysToExpire?: FieldPolicy<any> | FieldReadFunction<any>,
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	planName?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantYearDataStateKeySpecifier = ('hasAnswers' | 'hasTasks' | 'uuid' | TenantYearDataStateKeySpecifier)[];
export type TenantYearDataStateFieldPolicy = {
	hasAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	hasTasks?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TriageScoreSettingKeySpecifier = ('canEdit' | 'isEnabled' | 'severityLabel' | 'severityWeight' | 'urgencyLabel' | 'urgencyWeight' | TriageScoreSettingKeySpecifier)[];
export type TriageScoreSettingFieldPolicy = {
	canEdit?: FieldPolicy<any> | FieldReadFunction<any>,
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	severityLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	severityWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	urgencyLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	urgencyWeight?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UnitKeySpecifier = ('description' | 'isEnabled' | 'name' | 'sector' | 'uuid' | 'volume' | UnitKeySpecifier)[];
export type UnitFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	sector?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	volume?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UnitEdgeKeySpecifier = ('cursor' | 'node' | UnitEdgeKeySpecifier)[];
export type UnitEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UnlinkMetricFromAnswerResultKeySpecifier = ('answerUuid' | 'metricUuid' | UnlinkMetricFromAnswerResultKeySpecifier)[];
export type UnlinkMetricFromAnswerResultFieldPolicy = {
	answerUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	metricUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UnlinkQuestionFromMetricResultKeySpecifier = ('metricUuid' | 'questionUuid' | UnlinkQuestionFromMetricResultKeySpecifier)[];
export type UnlinkQuestionFromMetricResultFieldPolicy = {
	metricUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	questionUuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UnmappedQuestionStandardStatisticsKeySpecifier = ('standard' | 'statistics' | UnmappedQuestionStandardStatisticsKeySpecifier)[];
export type UnmappedQuestionStandardStatisticsFieldPolicy = {
	standard?: FieldPolicy<any> | FieldReadFunction<any>,
	statistics?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UnmappedQuestionStatisticsKeySpecifier = ('answeredCount' | 'standardsCount' | 'totalCount' | UnmappedQuestionStatisticsKeySpecifier)[];
export type UnmappedQuestionStatisticsFieldPolicy = {
	answeredCount?: FieldPolicy<any> | FieldReadFunction<any>,
	standardsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | UserConnectionKeySpecifier)[];
export type UserConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserDisclosureStatisticsKeySpecifier = ('availableDisclosures' | 'respondedDisclosures' | 'responsesCount' | UserDisclosureStatisticsKeySpecifier)[];
export type UserDisclosureStatisticsFieldPolicy = {
	availableDisclosures?: FieldPolicy<any> | FieldReadFunction<any>,
	respondedDisclosures?: FieldPolicy<any> | FieldReadFunction<any>,
	responsesCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserRoleKeySpecifier = ('permissions' | 'role' | 'subsidiarySite' | 'subsidiarySiteUuid' | 'user' | 'userUuid' | 'uuid' | UserRoleKeySpecifier)[];
export type UserRoleFieldPolicy = {
	permissions?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySite?: FieldPolicy<any> | FieldReadFunction<any>,
	subsidiarySiteUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userUuid?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserSettingsKeySpecifier = ('tokens' | 'user' | UserSettingsKeySpecifier)[];
export type UserSettingsFieldPolicy = {
	tokens?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserStorageKeySpecifier = ('adminOnboardingActive' | 'analyticsDateRange' | 'analyticsSitesFilters' | 'dashboardColumns' | 'dashboardDateRange' | 'dashboardFilters' | 'dashboardSort' | 'esgQuestionnaireFilters' | 'isFirstAdmin' | 'newEsgQuestionnaireFilters' | 'newTasksDashboardFilters' | 'newTasksDashboardFiltersWithTopics' | 'onboardingStatus' | 'tasksDashboardFilters' | 'tasksDashboardSort' | UserStorageKeySpecifier)[];
export type UserStorageFieldPolicy = {
	adminOnboardingActive?: FieldPolicy<any> | FieldReadFunction<any>,
	analyticsDateRange?: FieldPolicy<any> | FieldReadFunction<any>,
	analyticsSitesFilters?: FieldPolicy<any> | FieldReadFunction<any>,
	dashboardColumns?: FieldPolicy<any> | FieldReadFunction<any>,
	dashboardDateRange?: FieldPolicy<any> | FieldReadFunction<any>,
	dashboardFilters?: FieldPolicy<any> | FieldReadFunction<any>,
	dashboardSort?: FieldPolicy<any> | FieldReadFunction<any>,
	esgQuestionnaireFilters?: FieldPolicy<any> | FieldReadFunction<any>,
	isFirstAdmin?: FieldPolicy<any> | FieldReadFunction<any>,
	newEsgQuestionnaireFilters?: FieldPolicy<any> | FieldReadFunction<any>,
	newTasksDashboardFilters?: FieldPolicy<any> | FieldReadFunction<any>,
	newTasksDashboardFiltersWithTopics?: FieldPolicy<any> | FieldReadFunction<any>,
	onboardingStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	tasksDashboardFilters?: FieldPolicy<any> | FieldReadFunction<any>,
	tasksDashboardSort?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserTypeKeySpecifier = ('activeEntity' | 'activeRole' | 'assignedRole' | 'azureConnected' | 'biometricsDevices' | 'businessUnit' | 'canResendInvitation' | 'contactEmail' | 'country' | 'createdAt' | 'email' | 'enabledStandards' | 'esgSettings' | 'firebaseToken' | 'firstName' | 'fullName' | 'graphStorage' | 'hasUnreadReleaseNote' | 'hotspots' | 'invitation' | 'isBillingRole' | 'isFilterEnabled' | 'language' | 'lastName' | 'name' | 'navigableTaskRiskArea' | 'organizationEmail' | 'organizationName' | 'organizationRole' | 'parsedGraphStorage' | 'permissions' | 'phoneNumber' | 'questionnaireFilters' | 'recoveryEmail' | 'regions' | 'relationship' | 'role' | 'roles' | 'ssoAccounts' | 'status' | 'tenant' | 'timeZone' | 'type' | 'unreadReleaseNote' | 'updatedAt' | 'uuid' | UserTypeKeySpecifier)[];
export type UserTypeFieldPolicy = {
	activeEntity?: FieldPolicy<any> | FieldReadFunction<any>,
	activeRole?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedRole?: FieldPolicy<any> | FieldReadFunction<any>,
	azureConnected?: FieldPolicy<any> | FieldReadFunction<any>,
	biometricsDevices?: FieldPolicy<any> | FieldReadFunction<any>,
	businessUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	canResendInvitation?: FieldPolicy<any> | FieldReadFunction<any>,
	contactEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	enabledStandards?: FieldPolicy<any> | FieldReadFunction<any>,
	esgSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	firebaseToken?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	fullName?: FieldPolicy<any> | FieldReadFunction<any>,
	graphStorage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasUnreadReleaseNote?: FieldPolicy<any> | FieldReadFunction<any>,
	hotspots?: FieldPolicy<any> | FieldReadFunction<any>,
	invitation?: FieldPolicy<any> | FieldReadFunction<any>,
	isBillingRole?: FieldPolicy<any> | FieldReadFunction<any>,
	isFilterEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	navigableTaskRiskArea?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationName?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationRole?: FieldPolicy<any> | FieldReadFunction<any>,
	parsedGraphStorage?: FieldPolicy<any> | FieldReadFunction<any>,
	permissions?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	questionnaireFilters?: FieldPolicy<any> | FieldReadFunction<any>,
	recoveryEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	regions?: FieldPolicy<any> | FieldReadFunction<any>,
	relationship?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	roles?: FieldPolicy<any> | FieldReadFunction<any>,
	ssoAccounts?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant?: FieldPolicy<any> | FieldReadFunction<any>,
	timeZone?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	unreadReleaseNote?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserTypeConnectionKeySpecifier = ('all' | 'edges' | 'nodes' | 'pageInfo' | 'totalCount' | UserTypeConnectionKeySpecifier)[];
export type UserTypeConnectionFieldPolicy = {
	all?: FieldPolicy<any> | FieldReadFunction<any>,
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserTypeEdgeKeySpecifier = ('cursor' | 'node' | UserTypeEdgeKeySpecifier)[];
export type UserTypeEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type V2CaseExclusionOwnerEdgeKeySpecifier = ('cursor' | 'node' | V2CaseExclusionOwnerEdgeKeySpecifier)[];
export type V2CaseExclusionOwnerEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type V2DisclosureEdgeKeySpecifier = ('cursor' | 'node' | V2DisclosureEdgeKeySpecifier)[];
export type V2DisclosureEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type V2DisclosureResponseEdgeKeySpecifier = ('cursor' | 'node' | V2DisclosureResponseEdgeKeySpecifier)[];
export type V2DisclosureResponseEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type V2SurveyEdgeKeySpecifier = ('cursor' | 'node' | V2SurveyEdgeKeySpecifier)[];
export type V2SurveyEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WebflowKeySpecifier = ('esgArticles' | 'feed' | 'latestRelease' | 'supportArticle' | WebflowKeySpecifier)[];
export type WebflowFieldPolicy = {
	esgArticles?: FieldPolicy<any> | FieldReadFunction<any>,
	feed?: FieldPolicy<any> | FieldReadFunction<any>,
	latestRelease?: FieldPolicy<any> | FieldReadFunction<any>,
	supportArticle?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WebflowPostKeySpecifier = ('categories' | 'category' | 'description' | 'id' | 'publishedAt' | 'title' | 'url' | WebflowPostKeySpecifier)[];
export type WebflowPostFieldPolicy = {
	categories?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WebflowPostConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | WebflowPostConnectionKeySpecifier)[];
export type WebflowPostConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WebflowPostEdgeKeySpecifier = ('cursor' | 'node' | WebflowPostEdgeKeySpecifier)[];
export type WebflowPostEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WhistleblowerCaseReportPdfResponseKeySpecifier = ('password' | 's3Url' | WhistleblowerCaseReportPdfResponseKeySpecifier)[];
export type WhistleblowerCaseReportPdfResponseFieldPolicy = {
	password?: FieldPolicy<any> | FieldReadFunction<any>,
	s3Url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type YearKeySpecifier = ('status' | 'uuid' | 'year' | 'yearDataStatus' | YearKeySpecifier)[];
export type YearFieldPolicy = {
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	year?: FieldPolicy<any> | FieldReadFunction<any>,
	yearDataStatus?: FieldPolicy<any> | FieldReadFunction<any>
};
export type YearConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | YearConnectionKeySpecifier)[];
export type YearConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type YearEdgeKeySpecifier = ('cursor' | 'node' | YearEdgeKeySpecifier)[];
export type YearEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrictTypedTypePolicies = {
	AdminContextTokens?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdminContextTokensKeySpecifier | (() => undefined | AdminContextTokensKeySpecifier),
		fields?: AdminContextTokensFieldPolicy,
	},
	AdminTenantData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdminTenantDataKeySpecifier | (() => undefined | AdminTenantDataKeySpecifier),
		fields?: AdminTenantDataFieldPolicy,
	},
	AdminTenantDataConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdminTenantDataConnectionKeySpecifier | (() => undefined | AdminTenantDataConnectionKeySpecifier),
		fields?: AdminTenantDataConnectionFieldPolicy,
	},
	AdminTenantDataEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdminTenantDataEdgeKeySpecifier | (() => undefined | AdminTenantDataEdgeKeySpecifier),
		fields?: AdminTenantDataEdgeFieldPolicy,
	},
	AdminTenantModuleSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdminTenantModuleSettingsKeySpecifier | (() => undefined | AdminTenantModuleSettingsKeySpecifier),
		fields?: AdminTenantModuleSettingsFieldPolicy,
	},
	AdminTenantSubscription?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdminTenantSubscriptionKeySpecifier | (() => undefined | AdminTenantSubscriptionKeySpecifier),
		fields?: AdminTenantSubscriptionFieldPolicy,
	},
	AdminUserData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdminUserDataKeySpecifier | (() => undefined | AdminUserDataKeySpecifier),
		fields?: AdminUserDataFieldPolicy,
	},
	AdminUserDataConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdminUserDataConnectionKeySpecifier | (() => undefined | AdminUserDataConnectionKeySpecifier),
		fields?: AdminUserDataConnectionFieldPolicy,
	},
	AdminUserDataEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdminUserDataEdgeKeySpecifier | (() => undefined | AdminUserDataEdgeKeySpecifier),
		fields?: AdminUserDataEdgeFieldPolicy,
	},
	AiReport?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AiReportKeySpecifier | (() => undefined | AiReportKeySpecifier),
		fields?: AiReportFieldPolicy,
	},
	AiReportTopic?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AiReportTopicKeySpecifier | (() => undefined | AiReportTopicKeySpecifier),
		fields?: AiReportTopicFieldPolicy,
	},
	AnalyticsDateRange?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnalyticsDateRangeKeySpecifier | (() => undefined | AnalyticsDateRangeKeySpecifier),
		fields?: AnalyticsDateRangeFieldPolicy,
	},
	AnalyticsSitesFilters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnalyticsSitesFiltersKeySpecifier | (() => undefined | AnalyticsSitesFiltersKeySpecifier),
		fields?: AnalyticsSitesFiltersFieldPolicy,
	},
	AnalyticsSitesFiltersItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnalyticsSitesFiltersItemKeySpecifier | (() => undefined | AnalyticsSitesFiltersItemKeySpecifier),
		fields?: AnalyticsSitesFiltersItemFieldPolicy,
	},
	AssetSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssetSettingsKeySpecifier | (() => undefined | AssetSettingsKeySpecifier),
		fields?: AssetSettingsFieldPolicy,
	},
	AssistantCredentials?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssistantCredentialsKeySpecifier | (() => undefined | AssistantCredentialsKeySpecifier),
		fields?: AssistantCredentialsFieldPolicy,
	},
	AssistantCredentialsConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssistantCredentialsConnectionKeySpecifier | (() => undefined | AssistantCredentialsConnectionKeySpecifier),
		fields?: AssistantCredentialsConnectionFieldPolicy,
	},
	AssistantCredentialsEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssistantCredentialsEdgeKeySpecifier | (() => undefined | AssistantCredentialsEdgeKeySpecifier),
		fields?: AssistantCredentialsEdgeFieldPolicy,
	},
	AssistantSlot?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssistantSlotKeySpecifier | (() => undefined | AssistantSlotKeySpecifier),
		fields?: AssistantSlotFieldPolicy,
	},
	AssistantSlotConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssistantSlotConnectionKeySpecifier | (() => undefined | AssistantSlotConnectionKeySpecifier),
		fields?: AssistantSlotConnectionFieldPolicy,
	},
	AssistantSlotEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssistantSlotEdgeKeySpecifier | (() => undefined | AssistantSlotEdgeKeySpecifier),
		fields?: AssistantSlotEdgeFieldPolicy,
	},
	AssistantSlotIdentifiers?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssistantSlotIdentifiersKeySpecifier | (() => undefined | AssistantSlotIdentifiersKeySpecifier),
		fields?: AssistantSlotIdentifiersFieldPolicy,
	},
	AuditEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AuditEventKeySpecifier | (() => undefined | AuditEventKeySpecifier),
		fields?: AuditEventFieldPolicy,
	},
	AuditEventConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AuditEventConnectionKeySpecifier | (() => undefined | AuditEventConnectionKeySpecifier),
		fields?: AuditEventConnectionFieldPolicy,
	},
	AuditEventEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AuditEventEdgeKeySpecifier | (() => undefined | AuditEventEdgeKeySpecifier),
		fields?: AuditEventEdgeFieldPolicy,
	},
	AutomaticDeletionSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AutomaticDeletionSettingsKeySpecifier | (() => undefined | AutomaticDeletionSettingsKeySpecifier),
		fields?: AutomaticDeletionSettingsFieldPolicy,
	},
	AvgDaysToCloseByIncidentType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AvgDaysToCloseByIncidentTypeKeySpecifier | (() => undefined | AvgDaysToCloseByIncidentTypeKeySpecifier),
		fields?: AvgDaysToCloseByIncidentTypeFieldPolicy,
	},
	AvgDaysToCloseByTimeInterval?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AvgDaysToCloseByTimeIntervalKeySpecifier | (() => undefined | AvgDaysToCloseByTimeIntervalKeySpecifier),
		fields?: AvgDaysToCloseByTimeIntervalFieldPolicy,
	},
	BannedEmail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BannedEmailKeySpecifier | (() => undefined | BannedEmailKeySpecifier),
		fields?: BannedEmailFieldPolicy,
	},
	BannedEmailConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BannedEmailConnectionKeySpecifier | (() => undefined | BannedEmailConnectionKeySpecifier),
		fields?: BannedEmailConnectionFieldPolicy,
	},
	BannedEmailEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BannedEmailEdgeKeySpecifier | (() => undefined | BannedEmailEdgeKeySpecifier),
		fields?: BannedEmailEdgeFieldPolicy,
	},
	BusinessUnit?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BusinessUnitKeySpecifier | (() => undefined | BusinessUnitKeySpecifier),
		fields?: BusinessUnitFieldPolicy,
	},
	BusinessUnitConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BusinessUnitConnectionKeySpecifier | (() => undefined | BusinessUnitConnectionKeySpecifier),
		fields?: BusinessUnitConnectionFieldPolicy,
	},
	BusinessUnitEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BusinessUnitEdgeKeySpecifier | (() => undefined | BusinessUnitEdgeKeySpecifier),
		fields?: BusinessUnitEdgeFieldPolicy,
	},
	CallsCase?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CallsCaseKeySpecifier | (() => undefined | CallsCaseKeySpecifier),
		fields?: CallsCaseFieldPolicy,
	},
	CallsIncidentType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CallsIncidentTypeKeySpecifier | (() => undefined | CallsIncidentTypeKeySpecifier),
		fields?: CallsIncidentTypeFieldPolicy,
	},
	Case?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseKeySpecifier | (() => undefined | CaseKeySpecifier),
		fields?: CaseFieldPolicy,
	},
	CaseActivity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseActivityKeySpecifier | (() => undefined | CaseActivityKeySpecifier),
		fields?: CaseActivityFieldPolicy,
	},
	CaseActivityConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseActivityConnectionKeySpecifier | (() => undefined | CaseActivityConnectionKeySpecifier),
		fields?: CaseActivityConnectionFieldPolicy,
	},
	CaseActivityEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseActivityEdgeKeySpecifier | (() => undefined | CaseActivityEdgeKeySpecifier),
		fields?: CaseActivityEdgeFieldPolicy,
	},
	CaseActivityRelatedField?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseActivityRelatedFieldKeySpecifier | (() => undefined | CaseActivityRelatedFieldKeySpecifier),
		fields?: CaseActivityRelatedFieldFieldPolicy,
	},
	CaseActivitySettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseActivitySettingsKeySpecifier | (() => undefined | CaseActivitySettingsKeySpecifier),
		fields?: CaseActivitySettingsFieldPolicy,
	},
	CaseActivitySettingsConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseActivitySettingsConnectionKeySpecifier | (() => undefined | CaseActivitySettingsConnectionKeySpecifier),
		fields?: CaseActivitySettingsConnectionFieldPolicy,
	},
	CaseActivitySettingsEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseActivitySettingsEdgeKeySpecifier | (() => undefined | CaseActivitySettingsEdgeKeySpecifier),
		fields?: CaseActivitySettingsEdgeFieldPolicy,
	},
	CaseActivitySettingsRelatedField?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseActivitySettingsRelatedFieldKeySpecifier | (() => undefined | CaseActivitySettingsRelatedFieldKeySpecifier),
		fields?: CaseActivitySettingsRelatedFieldFieldPolicy,
	},
	CaseAnalytics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseAnalyticsKeySpecifier | (() => undefined | CaseAnalyticsKeySpecifier),
		fields?: CaseAnalyticsFieldPolicy,
	},
	CaseAnonymityConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseAnonymityConnectionKeySpecifier | (() => undefined | CaseAnonymityConnectionKeySpecifier),
		fields?: CaseAnonymityConnectionFieldPolicy,
	},
	CaseAnonymityRestrictions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseAnonymityRestrictionsKeySpecifier | (() => undefined | CaseAnonymityRestrictionsKeySpecifier),
		fields?: CaseAnonymityRestrictionsFieldPolicy,
	},
	CaseAssignment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseAssignmentKeySpecifier | (() => undefined | CaseAssignmentKeySpecifier),
		fields?: CaseAssignmentFieldPolicy,
	},
	CaseAssignmentConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseAssignmentConnectionKeySpecifier | (() => undefined | CaseAssignmentConnectionKeySpecifier),
		fields?: CaseAssignmentConnectionFieldPolicy,
	},
	CaseAssignmentEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseAssignmentEdgeKeySpecifier | (() => undefined | CaseAssignmentEdgeKeySpecifier),
		fields?: CaseAssignmentEdgeFieldPolicy,
	},
	CaseByCountry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseByCountryKeySpecifier | (() => undefined | CaseByCountryKeySpecifier),
		fields?: CaseByCountryFieldPolicy,
	},
	CaseByReportSource?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseByReportSourceKeySpecifier | (() => undefined | CaseByReportSourceKeySpecifier),
		fields?: CaseByReportSourceFieldPolicy,
	},
	CaseByStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseByStatusKeySpecifier | (() => undefined | CaseByStatusKeySpecifier),
		fields?: CaseByStatusFieldPolicy,
	},
	CaseByStatusData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseByStatusDataKeySpecifier | (() => undefined | CaseByStatusDataKeySpecifier),
		fields?: CaseByStatusDataFieldPolicy,
	},
	CaseCustomReminder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseCustomReminderKeySpecifier | (() => undefined | CaseCustomReminderKeySpecifier),
		fields?: CaseCustomReminderFieldPolicy,
	},
	CaseCustomReminderConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseCustomReminderConnectionKeySpecifier | (() => undefined | CaseCustomReminderConnectionKeySpecifier),
		fields?: CaseCustomReminderConnectionFieldPolicy,
	},
	CaseCustomReminderEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseCustomReminderEdgeKeySpecifier | (() => undefined | CaseCustomReminderEdgeKeySpecifier),
		fields?: CaseCustomReminderEdgeFieldPolicy,
	},
	CaseEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseEdgeKeySpecifier | (() => undefined | CaseEdgeKeySpecifier),
		fields?: CaseEdgeFieldPolicy,
	},
	CaseExclusionOwner?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseExclusionOwnerKeySpecifier | (() => undefined | CaseExclusionOwnerKeySpecifier),
		fields?: CaseExclusionOwnerFieldPolicy,
	},
	CaseExclusionOwnerEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseExclusionOwnerEdgeKeySpecifier | (() => undefined | CaseExclusionOwnerEdgeKeySpecifier),
		fields?: CaseExclusionOwnerEdgeFieldPolicy,
	},
	CaseExclusionOwnerListPaginated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseExclusionOwnerListPaginatedKeySpecifier | (() => undefined | CaseExclusionOwnerListPaginatedKeySpecifier),
		fields?: CaseExclusionOwnerListPaginatedFieldPolicy,
	},
	CaseExclusionOwnerPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseExclusionOwnerPageKeySpecifier | (() => undefined | CaseExclusionOwnerPageKeySpecifier),
		fields?: CaseExclusionOwnerPageFieldPolicy,
	},
	CaseFile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseFileKeySpecifier | (() => undefined | CaseFileKeySpecifier),
		fields?: CaseFileFieldPolicy,
	},
	CaseFileConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseFileConnectionKeySpecifier | (() => undefined | CaseFileConnectionKeySpecifier),
		fields?: CaseFileConnectionFieldPolicy,
	},
	CaseFileEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseFileEdgeKeySpecifier | (() => undefined | CaseFileEdgeKeySpecifier),
		fields?: CaseFileEdgeFieldPolicy,
	},
	CaseHistory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseHistoryKeySpecifier | (() => undefined | CaseHistoryKeySpecifier),
		fields?: CaseHistoryFieldPolicy,
	},
	CaseHistoryConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseHistoryConnectionKeySpecifier | (() => undefined | CaseHistoryConnectionKeySpecifier),
		fields?: CaseHistoryConnectionFieldPolicy,
	},
	CaseHistoryEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseHistoryEdgeKeySpecifier | (() => undefined | CaseHistoryEdgeKeySpecifier),
		fields?: CaseHistoryEdgeFieldPolicy,
	},
	CaseInvestigation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseInvestigationKeySpecifier | (() => undefined | CaseInvestigationKeySpecifier),
		fields?: CaseInvestigationFieldPolicy,
	},
	CaseInvestigationConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseInvestigationConnectionKeySpecifier | (() => undefined | CaseInvestigationConnectionKeySpecifier),
		fields?: CaseInvestigationConnectionFieldPolicy,
	},
	CaseInvestigationPdfReportGenerateResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseInvestigationPdfReportGenerateResponseKeySpecifier | (() => undefined | CaseInvestigationPdfReportGenerateResponseKeySpecifier),
		fields?: CaseInvestigationPdfReportGenerateResponseFieldPolicy,
	},
	CaseInvestigationStatistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseInvestigationStatisticsKeySpecifier | (() => undefined | CaseInvestigationStatisticsKeySpecifier),
		fields?: CaseInvestigationStatisticsFieldPolicy,
	},
	CaseInvestigators?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseInvestigatorsKeySpecifier | (() => undefined | CaseInvestigatorsKeySpecifier),
		fields?: CaseInvestigatorsFieldPolicy,
	},
	CaseOwnerExclusion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseOwnerExclusionKeySpecifier | (() => undefined | CaseOwnerExclusionKeySpecifier),
		fields?: CaseOwnerExclusionFieldPolicy,
	},
	CaseOwnerExclusionConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseOwnerExclusionConnectionKeySpecifier | (() => undefined | CaseOwnerExclusionConnectionKeySpecifier),
		fields?: CaseOwnerExclusionConnectionFieldPolicy,
	},
	CaseOwnerExclusionEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseOwnerExclusionEdgeKeySpecifier | (() => undefined | CaseOwnerExclusionEdgeKeySpecifier),
		fields?: CaseOwnerExclusionEdgeFieldPolicy,
	},
	CasePrintSections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CasePrintSectionsKeySpecifier | (() => undefined | CasePrintSectionsKeySpecifier),
		fields?: CasePrintSectionsFieldPolicy,
	},
	CasePrintSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CasePrintSettingsKeySpecifier | (() => undefined | CasePrintSettingsKeySpecifier),
		fields?: CasePrintSettingsFieldPolicy,
	},
	CaseReport?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseReportKeySpecifier | (() => undefined | CaseReportKeySpecifier),
		fields?: CaseReportFieldPolicy,
	},
	CaseReportConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseReportConnectionKeySpecifier | (() => undefined | CaseReportConnectionKeySpecifier),
		fields?: CaseReportConnectionFieldPolicy,
	},
	CaseReportEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseReportEdgeKeySpecifier | (() => undefined | CaseReportEdgeKeySpecifier),
		fields?: CaseReportEdgeFieldPolicy,
	},
	CaseReportStatistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseReportStatisticsKeySpecifier | (() => undefined | CaseReportStatisticsKeySpecifier),
		fields?: CaseReportStatisticsFieldPolicy,
	},
	CaseReportSubmit?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseReportSubmitKeySpecifier | (() => undefined | CaseReportSubmitKeySpecifier),
		fields?: CaseReportSubmitFieldPolicy,
	},
	CaseReportSummaryResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseReportSummaryResponseKeySpecifier | (() => undefined | CaseReportSummaryResponseKeySpecifier),
		fields?: CaseReportSummaryResponseFieldPolicy,
	},
	CaseReporter?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseReporterKeySpecifier | (() => undefined | CaseReporterKeySpecifier),
		fields?: CaseReporterFieldPolicy,
	},
	CaseSettingAnonymity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseSettingAnonymityKeySpecifier | (() => undefined | CaseSettingAnonymityKeySpecifier),
		fields?: CaseSettingAnonymityFieldPolicy,
	},
	CaseSettingExclusion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseSettingExclusionKeySpecifier | (() => undefined | CaseSettingExclusionKeySpecifier),
		fields?: CaseSettingExclusionFieldPolicy,
	},
	CaseSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseSettingsKeySpecifier | (() => undefined | CaseSettingsKeySpecifier),
		fields?: CaseSettingsFieldPolicy,
	},
	CaseStatusByIncidentType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaseStatusByIncidentTypeKeySpecifier | (() => undefined | CaseStatusByIncidentTypeKeySpecifier),
		fields?: CaseStatusByIncidentTypeFieldPolicy,
	},
	CasesRolePermission?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CasesRolePermissionKeySpecifier | (() => undefined | CasesRolePermissionKeySpecifier),
		fields?: CasesRolePermissionFieldPolicy,
	},
	Category?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CategoryKeySpecifier | (() => undefined | CategoryKeySpecifier),
		fields?: CategoryFieldPolicy,
	},
	ChatRoom?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChatRoomKeySpecifier | (() => undefined | ChatRoomKeySpecifier),
		fields?: ChatRoomFieldPolicy,
	},
	Chatbot?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChatbotKeySpecifier | (() => undefined | ChatbotKeySpecifier),
		fields?: ChatbotFieldPolicy,
	},
	ChatbotMessage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChatbotMessageKeySpecifier | (() => undefined | ChatbotMessageKeySpecifier),
		fields?: ChatbotMessageFieldPolicy,
	},
	ChatbotMessageConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChatbotMessageConnectionKeySpecifier | (() => undefined | ChatbotMessageConnectionKeySpecifier),
		fields?: ChatbotMessageConnectionFieldPolicy,
	},
	ChatbotMessageEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChatbotMessageEdgeKeySpecifier | (() => undefined | ChatbotMessageEdgeKeySpecifier),
		fields?: ChatbotMessageEdgeFieldPolicy,
	},
	ChatsFile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChatsFileKeySpecifier | (() => undefined | ChatsFileKeySpecifier),
		fields?: ChatsFileFieldPolicy,
	},
	ClientSubsidiarySite?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ClientSubsidiarySiteKeySpecifier | (() => undefined | ClientSubsidiarySiteKeySpecifier),
		fields?: ClientSubsidiarySiteFieldPolicy,
	},
	ClientSubsidiarySiteAdmin?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ClientSubsidiarySiteAdminKeySpecifier | (() => undefined | ClientSubsidiarySiteAdminKeySpecifier),
		fields?: ClientSubsidiarySiteAdminFieldPolicy,
	},
	ClientSubsidiarySiteEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ClientSubsidiarySiteEdgeKeySpecifier | (() => undefined | ClientSubsidiarySiteEdgeKeySpecifier),
		fields?: ClientSubsidiarySiteEdgeFieldPolicy,
	},
	ClientSubsidiarySitesConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ClientSubsidiarySitesConnectionKeySpecifier | (() => undefined | ClientSubsidiarySitesConnectionKeySpecifier),
		fields?: ClientSubsidiarySitesConnectionFieldPolicy,
	},
	ClientUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ClientUserKeySpecifier | (() => undefined | ClientUserKeySpecifier),
		fields?: ClientUserFieldPolicy,
	},
	ConclusionType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConclusionTypeKeySpecifier | (() => undefined | ConclusionTypeKeySpecifier),
		fields?: ConclusionTypeFieldPolicy,
	},
	ConclusionTypeConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConclusionTypeConnectionKeySpecifier | (() => undefined | ConclusionTypeConnectionKeySpecifier),
		fields?: ConclusionTypeConnectionFieldPolicy,
	},
	ConclusionTypeEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConclusionTypeEdgeKeySpecifier | (() => undefined | ConclusionTypeEdgeKeySpecifier),
		fields?: ConclusionTypeEdgeFieldPolicy,
	},
	ConversationActionSlot?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConversationActionSlotKeySpecifier | (() => undefined | ConversationActionSlotKeySpecifier),
		fields?: ConversationActionSlotFieldPolicy,
	},
	ConversationAssistantResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConversationAssistantResponseKeySpecifier | (() => undefined | ConversationAssistantResponseKeySpecifier),
		fields?: ConversationAssistantResponseFieldPolicy,
	},
	ConversationEditingSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConversationEditingSettingsKeySpecifier | (() => undefined | ConversationEditingSettingsKeySpecifier),
		fields?: ConversationEditingSettingsFieldPolicy,
	},
	ConversationMessage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConversationMessageKeySpecifier | (() => undefined | ConversationMessageKeySpecifier),
		fields?: ConversationMessageFieldPolicy,
	},
	ConversationProgress?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConversationProgressKeySpecifier | (() => undefined | ConversationProgressKeySpecifier),
		fields?: ConversationProgressFieldPolicy,
	},
	CountryAnonymity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CountryAnonymityKeySpecifier | (() => undefined | CountryAnonymityKeySpecifier),
		fields?: CountryAnonymityFieldPolicy,
	},
	CountryAnonymityEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CountryAnonymityEdgeKeySpecifier | (() => undefined | CountryAnonymityEdgeKeySpecifier),
		fields?: CountryAnonymityEdgeFieldPolicy,
	},
	DashboardColumn?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DashboardColumnKeySpecifier | (() => undefined | DashboardColumnKeySpecifier),
		fields?: DashboardColumnFieldPolicy,
	},
	DashboardDateRange?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DashboardDateRangeKeySpecifier | (() => undefined | DashboardDateRangeKeySpecifier),
		fields?: DashboardDateRangeFieldPolicy,
	},
	DashboardFilters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DashboardFiltersKeySpecifier | (() => undefined | DashboardFiltersKeySpecifier),
		fields?: DashboardFiltersFieldPolicy,
	},
	DashboardSort?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DashboardSortKeySpecifier | (() => undefined | DashboardSortKeySpecifier),
		fields?: DashboardSortFieldPolicy,
	},
	DataCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DataCategoryKeySpecifier | (() => undefined | DataCategoryKeySpecifier),
		fields?: DataCategoryFieldPolicy,
	},
	DataCategoryConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DataCategoryConnectionKeySpecifier | (() => undefined | DataCategoryConnectionKeySpecifier),
		fields?: DataCategoryConnectionFieldPolicy,
	},
	DataCategoryEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DataCategoryEdgeKeySpecifier | (() => undefined | DataCategoryEdgeKeySpecifier),
		fields?: DataCategoryEdgeFieldPolicy,
	},
	Disclosure?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureKeySpecifier | (() => undefined | DisclosureKeySpecifier),
		fields?: DisclosureFieldPolicy,
	},
	DisclosureChatNotificationExtra?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureChatNotificationExtraKeySpecifier | (() => undefined | DisclosureChatNotificationExtraKeySpecifier),
		fields?: DisclosureChatNotificationExtraFieldPolicy,
	},
	DisclosureCommentsPaginated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureCommentsPaginatedKeySpecifier | (() => undefined | DisclosureCommentsPaginatedKeySpecifier),
		fields?: DisclosureCommentsPaginatedFieldPolicy,
	},
	DisclosureConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureConnectionKeySpecifier | (() => undefined | DisclosureConnectionKeySpecifier),
		fields?: DisclosureConnectionFieldPolicy,
	},
	DisclosureEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureEdgeKeySpecifier | (() => undefined | DisclosureEdgeKeySpecifier),
		fields?: DisclosureEdgeFieldPolicy,
	},
	DisclosureEmailTarget?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureEmailTargetKeySpecifier | (() => undefined | DisclosureEmailTargetKeySpecifier),
		fields?: DisclosureEmailTargetFieldPolicy,
	},
	DisclosurePage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosurePageKeySpecifier | (() => undefined | DisclosurePageKeySpecifier),
		fields?: DisclosurePageFieldPolicy,
	},
	DisclosurePaginated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosurePaginatedKeySpecifier | (() => undefined | DisclosurePaginatedKeySpecifier),
		fields?: DisclosurePaginatedFieldPolicy,
	},
	DisclosureResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureResponseKeySpecifier | (() => undefined | DisclosureResponseKeySpecifier),
		fields?: DisclosureResponseFieldPolicy,
	},
	DisclosureResponseComment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureResponseCommentKeySpecifier | (() => undefined | DisclosureResponseCommentKeySpecifier),
		fields?: DisclosureResponseCommentFieldPolicy,
	},
	DisclosureResponseCommentEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureResponseCommentEdgeKeySpecifier | (() => undefined | DisclosureResponseCommentEdgeKeySpecifier),
		fields?: DisclosureResponseCommentEdgeFieldPolicy,
	},
	DisclosureResponseCommentPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureResponseCommentPageKeySpecifier | (() => undefined | DisclosureResponseCommentPageKeySpecifier),
		fields?: DisclosureResponseCommentPageFieldPolicy,
	},
	DisclosureResponseConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureResponseConnectionKeySpecifier | (() => undefined | DisclosureResponseConnectionKeySpecifier),
		fields?: DisclosureResponseConnectionFieldPolicy,
	},
	DisclosureResponseEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureResponseEdgeKeySpecifier | (() => undefined | DisclosureResponseEdgeKeySpecifier),
		fields?: DisclosureResponseEdgeFieldPolicy,
	},
	DisclosureResponsePage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureResponsePageKeySpecifier | (() => undefined | DisclosureResponsePageKeySpecifier),
		fields?: DisclosureResponsePageFieldPolicy,
	},
	DisclosureResponsesPaginated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureResponsesPaginatedKeySpecifier | (() => undefined | DisclosureResponsesPaginatedKeySpecifier),
		fields?: DisclosureResponsesPaginatedFieldPolicy,
	},
	DisclosureStatistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureStatisticsKeySpecifier | (() => undefined | DisclosureStatisticsKeySpecifier),
		fields?: DisclosureStatisticsFieldPolicy,
	},
	DisclosureUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureUserKeySpecifier | (() => undefined | DisclosureUserKeySpecifier),
		fields?: DisclosureUserFieldPolicy,
	},
	DisclosureUserConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureUserConnectionKeySpecifier | (() => undefined | DisclosureUserConnectionKeySpecifier),
		fields?: DisclosureUserConnectionFieldPolicy,
	},
	DisclosureUserEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureUserEdgeKeySpecifier | (() => undefined | DisclosureUserEdgeKeySpecifier),
		fields?: DisclosureUserEdgeFieldPolicy,
	},
	ESGGroupTagEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ESGGroupTagEdgeKeySpecifier | (() => undefined | ESGGroupTagEdgeKeySpecifier),
		fields?: ESGGroupTagEdgeFieldPolicy,
	},
	ElineConversation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ElineConversationKeySpecifier | (() => undefined | ElineConversationKeySpecifier),
		fields?: ElineConversationFieldPolicy,
	},
	ElineNumber?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ElineNumberKeySpecifier | (() => undefined | ElineNumberKeySpecifier),
		fields?: ElineNumberFieldPolicy,
	},
	ElinePhoneNumber?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ElinePhoneNumberKeySpecifier | (() => undefined | ElinePhoneNumberKeySpecifier),
		fields?: ElinePhoneNumberFieldPolicy,
	},
	EmailEntry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmailEntryKeySpecifier | (() => undefined | EmailEntryKeySpecifier),
		fields?: EmailEntryFieldPolicy,
	},
	EmailEntryEditResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmailEntryEditResultKeySpecifier | (() => undefined | EmailEntryEditResultKeySpecifier),
		fields?: EmailEntryEditResultFieldPolicy,
	},
	EmailList?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmailListKeySpecifier | (() => undefined | EmailListKeySpecifier),
		fields?: EmailListFieldPolicy,
	},
	EmailListConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmailListConnectionKeySpecifier | (() => undefined | EmailListConnectionKeySpecifier),
		fields?: EmailListConnectionFieldPolicy,
	},
	EmailListEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmailListEdgeKeySpecifier | (() => undefined | EmailListEdgeKeySpecifier),
		fields?: EmailListEdgeFieldPolicy,
	},
	EmailMessageParsedResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmailMessageParsedResponseKeySpecifier | (() => undefined | EmailMessageParsedResponseKeySpecifier),
		fields?: EmailMessageParsedResponseFieldPolicy,
	},
	EmailTemplate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmailTemplateKeySpecifier | (() => undefined | EmailTemplateKeySpecifier),
		fields?: EmailTemplateFieldPolicy,
	},
	EmailTemplateRecipients?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmailTemplateRecipientsKeySpecifier | (() => undefined | EmailTemplateRecipientsKeySpecifier),
		fields?: EmailTemplateRecipientsFieldPolicy,
	},
	EnabledSsoMethodsForTenant?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EnabledSsoMethodsForTenantKeySpecifier | (() => undefined | EnabledSsoMethodsForTenantKeySpecifier),
		fields?: EnabledSsoMethodsForTenantFieldPolicy,
	},
	EsgActivitiesForActivityReport?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgActivitiesForActivityReportKeySpecifier | (() => undefined | EsgActivitiesForActivityReportKeySpecifier),
		fields?: EsgActivitiesForActivityReportFieldPolicy,
	},
	EsgAnswer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgAnswerKeySpecifier | (() => undefined | EsgAnswerKeySpecifier),
		fields?: EsgAnswerFieldPolicy,
	},
	EsgAnswerGenerateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgAnswerGenerateResultKeySpecifier | (() => undefined | EsgAnswerGenerateResultKeySpecifier),
		fields?: EsgAnswerGenerateResultFieldPolicy,
	},
	EsgAnswerTags?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgAnswerTagsKeySpecifier | (() => undefined | EsgAnswerTagsKeySpecifier),
		fields?: EsgAnswerTagsFieldPolicy,
	},
	EsgCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgCategoryKeySpecifier | (() => undefined | EsgCategoryKeySpecifier),
		fields?: EsgCategoryFieldPolicy,
	},
	EsgFile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgFileKeySpecifier | (() => undefined | EsgFileKeySpecifier),
		fields?: EsgFileFieldPolicy,
	},
	EsgGroupTagConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgGroupTagConnectionKeySpecifier | (() => undefined | EsgGroupTagConnectionKeySpecifier),
		fields?: EsgGroupTagConnectionFieldPolicy,
	},
	EsgGroupedStatistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgGroupedStatisticsKeySpecifier | (() => undefined | EsgGroupedStatisticsKeySpecifier),
		fields?: EsgGroupedStatisticsFieldPolicy,
	},
	EsgHistoryElement?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgHistoryElementKeySpecifier | (() => undefined | EsgHistoryElementKeySpecifier),
		fields?: EsgHistoryElementFieldPolicy,
	},
	EsgQuestion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgQuestionKeySpecifier | (() => undefined | EsgQuestionKeySpecifier),
		fields?: EsgQuestionFieldPolicy,
	},
	EsgQuestionConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgQuestionConnectionKeySpecifier | (() => undefined | EsgQuestionConnectionKeySpecifier),
		fields?: EsgQuestionConnectionFieldPolicy,
	},
	EsgQuestionEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgQuestionEdgeKeySpecifier | (() => undefined | EsgQuestionEdgeKeySpecifier),
		fields?: EsgQuestionEdgeFieldPolicy,
	},
	EsgQuestionMetadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgQuestionMetadataKeySpecifier | (() => undefined | EsgQuestionMetadataKeySpecifier),
		fields?: EsgQuestionMetadataFieldPolicy,
	},
	EsgQuestionRiskAreaMetadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgQuestionRiskAreaMetadataKeySpecifier | (() => undefined | EsgQuestionRiskAreaMetadataKeySpecifier),
		fields?: EsgQuestionRiskAreaMetadataFieldPolicy,
	},
	EsgQuestionSearchConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgQuestionSearchConnectionKeySpecifier | (() => undefined | EsgQuestionSearchConnectionKeySpecifier),
		fields?: EsgQuestionSearchConnectionFieldPolicy,
	},
	EsgQuestionTagMetadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgQuestionTagMetadataKeySpecifier | (() => undefined | EsgQuestionTagMetadataKeySpecifier),
		fields?: EsgQuestionTagMetadataFieldPolicy,
	},
	EsgQuestionTagsMetadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgQuestionTagsMetadataKeySpecifier | (() => undefined | EsgQuestionTagsMetadataKeySpecifier),
		fields?: EsgQuestionTagsMetadataFieldPolicy,
	},
	EsgQuestionnaireFilters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgQuestionnaireFiltersKeySpecifier | (() => undefined | EsgQuestionnaireFiltersKeySpecifier),
		fields?: EsgQuestionnaireFiltersFieldPolicy,
	},
	EsgRiskAreaSettingByProgram?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgRiskAreaSettingByProgramKeySpecifier | (() => undefined | EsgRiskAreaSettingByProgramKeySpecifier),
		fields?: EsgRiskAreaSettingByProgramFieldPolicy,
	},
	EsgRiskAreaSettingsByProgram?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgRiskAreaSettingsByProgramKeySpecifier | (() => undefined | EsgRiskAreaSettingsByProgramKeySpecifier),
		fields?: EsgRiskAreaSettingsByProgramFieldPolicy,
	},
	EsgRolePermission?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgRolePermissionKeySpecifier | (() => undefined | EsgRolePermissionKeySpecifier),
		fields?: EsgRolePermissionFieldPolicy,
	},
	EsgSmartFillDraftAnswer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgSmartFillDraftAnswerKeySpecifier | (() => undefined | EsgSmartFillDraftAnswerKeySpecifier),
		fields?: EsgSmartFillDraftAnswerFieldPolicy,
	},
	EsgSmartFillJob?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgSmartFillJobKeySpecifier | (() => undefined | EsgSmartFillJobKeySpecifier),
		fields?: EsgSmartFillJobFieldPolicy,
	},
	EsgSmartFillSource?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgSmartFillSourceKeySpecifier | (() => undefined | EsgSmartFillSourceKeySpecifier),
		fields?: EsgSmartFillSourceFieldPolicy,
	},
	EsgStandard?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgStandardKeySpecifier | (() => undefined | EsgStandardKeySpecifier),
		fields?: EsgStandardFieldPolicy,
	},
	EsgStandardWithConnectedRiskAreas?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgStandardWithConnectedRiskAreasKeySpecifier | (() => undefined | EsgStandardWithConnectedRiskAreasKeySpecifier),
		fields?: EsgStandardWithConnectedRiskAreasFieldPolicy,
	},
	EsgStatistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgStatisticsKeySpecifier | (() => undefined | EsgStatisticsKeySpecifier),
		fields?: EsgStatisticsFieldPolicy,
	},
	EsgStep?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgStepKeySpecifier | (() => undefined | EsgStepKeySpecifier),
		fields?: EsgStepFieldPolicy,
	},
	EsgSubcategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgSubcategoryKeySpecifier | (() => undefined | EsgSubcategoryKeySpecifier),
		fields?: EsgSubcategoryFieldPolicy,
	},
	EsgTagConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgTagConnectionKeySpecifier | (() => undefined | EsgTagConnectionKeySpecifier),
		fields?: EsgTagConnectionFieldPolicy,
	},
	EsgTagEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgTagEdgeKeySpecifier | (() => undefined | EsgTagEdgeKeySpecifier),
		fields?: EsgTagEdgeFieldPolicy,
	},
	EsgTaskDisabledReason?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgTaskDisabledReasonKeySpecifier | (() => undefined | EsgTaskDisabledReasonKeySpecifier),
		fields?: EsgTaskDisabledReasonFieldPolicy,
	},
	EsgTenantProgramSetting?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgTenantProgramSettingKeySpecifier | (() => undefined | EsgTenantProgramSettingKeySpecifier),
		fields?: EsgTenantProgramSettingFieldPolicy,
	},
	EsgTenantProgramSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgTenantProgramSettingsKeySpecifier | (() => undefined | EsgTenantProgramSettingsKeySpecifier),
		fields?: EsgTenantProgramSettingsFieldPolicy,
	},
	EsgVideo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgVideoKeySpecifier | (() => undefined | EsgVideoKeySpecifier),
		fields?: EsgVideoFieldPolicy,
	},
	EsgVideoConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgVideoConnectionKeySpecifier | (() => undefined | EsgVideoConnectionKeySpecifier),
		fields?: EsgVideoConnectionFieldPolicy,
	},
	EsgVideoEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EsgVideoEdgeKeySpecifier | (() => undefined | EsgVideoEdgeKeySpecifier),
		fields?: EsgVideoEdgeFieldPolicy,
	},
	ExclusionAdminUserConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExclusionAdminUserConnectionKeySpecifier | (() => undefined | ExclusionAdminUserConnectionKeySpecifier),
		fields?: ExclusionAdminUserConnectionFieldPolicy,
	},
	ExternalUserAvailableRiskArea?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExternalUserAvailableRiskAreaKeySpecifier | (() => undefined | ExternalUserAvailableRiskAreaKeySpecifier),
		fields?: ExternalUserAvailableRiskAreaFieldPolicy,
	},
	FeatureSetting?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FeatureSettingKeySpecifier | (() => undefined | FeatureSettingKeySpecifier),
		fields?: FeatureSettingFieldPolicy,
	},
	FilterQuestionStatuses?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FilterQuestionStatusesKeySpecifier | (() => undefined | FilterQuestionStatusesKeySpecifier),
		fields?: FilterQuestionStatusesFieldPolicy,
	},
	FilterQuestionTaskRelation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FilterQuestionTaskRelationKeySpecifier | (() => undefined | FilterQuestionTaskRelationKeySpecifier),
		fields?: FilterQuestionTaskRelationFieldPolicy,
	},
	FilterTaskStatuses?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FilterTaskStatusesKeySpecifier | (() => undefined | FilterTaskStatusesKeySpecifier),
		fields?: FilterTaskStatusesFieldPolicy,
	},
	FirebaseResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FirebaseResponseKeySpecifier | (() => undefined | FirebaseResponseKeySpecifier),
		fields?: FirebaseResponseFieldPolicy,
	},
	FirebaseToken?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FirebaseTokenKeySpecifier | (() => undefined | FirebaseTokenKeySpecifier),
		fields?: FirebaseTokenFieldPolicy,
	},
	FirebaseTopicSubscription?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FirebaseTopicSubscriptionKeySpecifier | (() => undefined | FirebaseTopicSubscriptionKeySpecifier),
		fields?: FirebaseTopicSubscriptionFieldPolicy,
	},
	ForwardEarthCredentials?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ForwardEarthCredentialsKeySpecifier | (() => undefined | ForwardEarthCredentialsKeySpecifier),
		fields?: ForwardEarthCredentialsFieldPolicy,
	},
	GlobalTenantBaseData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GlobalTenantBaseDataKeySpecifier | (() => undefined | GlobalTenantBaseDataKeySpecifier),
		fields?: GlobalTenantBaseDataFieldPolicy,
	},
	GlossaryConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GlossaryConnectionKeySpecifier | (() => undefined | GlossaryConnectionKeySpecifier),
		fields?: GlossaryConnectionFieldPolicy,
	},
	GlossaryEntry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GlossaryEntryKeySpecifier | (() => undefined | GlossaryEntryKeySpecifier),
		fields?: GlossaryEntryFieldPolicy,
	},
	GlossaryEntryEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GlossaryEntryEdgeKeySpecifier | (() => undefined | GlossaryEntryEdgeKeySpecifier),
		fields?: GlossaryEntryEdgeFieldPolicy,
	},
	GroupTag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupTagKeySpecifier | (() => undefined | GroupTagKeySpecifier),
		fields?: GroupTagFieldPolicy,
	},
	GroupTagConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupTagConnectionKeySpecifier | (() => undefined | GroupTagConnectionKeySpecifier),
		fields?: GroupTagConnectionFieldPolicy,
	},
	GroupTagEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupTagEdgeKeySpecifier | (() => undefined | GroupTagEdgeKeySpecifier),
		fields?: GroupTagEdgeFieldPolicy,
	},
	GroupTagEsgMetadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupTagEsgMetadataKeySpecifier | (() => undefined | GroupTagEsgMetadataKeySpecifier),
		fields?: GroupTagEsgMetadataFieldPolicy,
	},
	GroupTagRow?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupTagRowKeySpecifier | (() => undefined | GroupTagRowKeySpecifier),
		fields?: GroupTagRowFieldPolicy,
	},
	GroupTagRowConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupTagRowConnectionKeySpecifier | (() => undefined | GroupTagRowConnectionKeySpecifier),
		fields?: GroupTagRowConnectionFieldPolicy,
	},
	GroupTagRowEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupTagRowEdgeKeySpecifier | (() => undefined | GroupTagRowEdgeKeySpecifier),
		fields?: GroupTagRowEdgeFieldPolicy,
	},
	Guideline?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GuidelineKeySpecifier | (() => undefined | GuidelineKeySpecifier),
		fields?: GuidelineFieldPolicy,
	},
	GuidelineConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GuidelineConnectionKeySpecifier | (() => undefined | GuidelineConnectionKeySpecifier),
		fields?: GuidelineConnectionFieldPolicy,
	},
	GuidelineEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GuidelineEdgeKeySpecifier | (() => undefined | GuidelineEdgeKeySpecifier),
		fields?: GuidelineEdgeFieldPolicy,
	},
	IncidentAnonymityRestriction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IncidentAnonymityRestrictionKeySpecifier | (() => undefined | IncidentAnonymityRestrictionKeySpecifier),
		fields?: IncidentAnonymityRestrictionFieldPolicy,
	},
	IncidentType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IncidentTypeKeySpecifier | (() => undefined | IncidentTypeKeySpecifier),
		fields?: IncidentTypeFieldPolicy,
	},
	IncidentTypeAnonymity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IncidentTypeAnonymityKeySpecifier | (() => undefined | IncidentTypeAnonymityKeySpecifier),
		fields?: IncidentTypeAnonymityFieldPolicy,
	},
	IncidentTypeConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IncidentTypeConnectionKeySpecifier | (() => undefined | IncidentTypeConnectionKeySpecifier),
		fields?: IncidentTypeConnectionFieldPolicy,
	},
	IncidentTypeEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IncidentTypeEdgeKeySpecifier | (() => undefined | IncidentTypeEdgeKeySpecifier),
		fields?: IncidentTypeEdgeFieldPolicy,
	},
	IndividualInvolved?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IndividualInvolvedKeySpecifier | (() => undefined | IndividualInvolvedKeySpecifier),
		fields?: IndividualInvolvedFieldPolicy,
	},
	IndustryUnitConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IndustryUnitConnectionKeySpecifier | (() => undefined | IndustryUnitConnectionKeySpecifier),
		fields?: IndustryUnitConnectionFieldPolicy,
	},
	InsightsFile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InsightsFileKeySpecifier | (() => undefined | InsightsFileKeySpecifier),
		fields?: InsightsFileFieldPolicy,
	},
	KnowledgeLibraryAssets?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | KnowledgeLibraryAssetsKeySpecifier | (() => undefined | KnowledgeLibraryAssetsKeySpecifier),
		fields?: KnowledgeLibraryAssetsFieldPolicy,
	},
	KnowledgeLibraryConnectionStatistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | KnowledgeLibraryConnectionStatisticsKeySpecifier | (() => undefined | KnowledgeLibraryConnectionStatisticsKeySpecifier),
		fields?: KnowledgeLibraryConnectionStatisticsFieldPolicy,
	},
	KnowledgeLibraryGeneratedAnswer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | KnowledgeLibraryGeneratedAnswerKeySpecifier | (() => undefined | KnowledgeLibraryGeneratedAnswerKeySpecifier),
		fields?: KnowledgeLibraryGeneratedAnswerFieldPolicy,
	},
	KnowledgeLibraryOptionsQuestion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | KnowledgeLibraryOptionsQuestionKeySpecifier | (() => undefined | KnowledgeLibraryOptionsQuestionKeySpecifier),
		fields?: KnowledgeLibraryOptionsQuestionFieldPolicy,
	},
	KnowledgeLibraryQuestion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | KnowledgeLibraryQuestionKeySpecifier | (() => undefined | KnowledgeLibraryQuestionKeySpecifier),
		fields?: KnowledgeLibraryQuestionFieldPolicy,
	},
	KnowledgeLibraryQuestionConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | KnowledgeLibraryQuestionConnectionKeySpecifier | (() => undefined | KnowledgeLibraryQuestionConnectionKeySpecifier),
		fields?: KnowledgeLibraryQuestionConnectionFieldPolicy,
	},
	KnowledgeLibraryQuestionEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | KnowledgeLibraryQuestionEdgeKeySpecifier | (() => undefined | KnowledgeLibraryQuestionEdgeKeySpecifier),
		fields?: KnowledgeLibraryQuestionEdgeFieldPolicy,
	},
	KnowledgeLibraryScalarQuestion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | KnowledgeLibraryScalarQuestionKeySpecifier | (() => undefined | KnowledgeLibraryScalarQuestionKeySpecifier),
		fields?: KnowledgeLibraryScalarQuestionFieldPolicy,
	},
	License?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LicenseKeySpecifier | (() => undefined | LicenseKeySpecifier),
		fields?: LicenseFieldPolicy,
	},
	LinkAnswersToMetricResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LinkAnswersToMetricResultKeySpecifier | (() => undefined | LinkAnswersToMetricResultKeySpecifier),
		fields?: LinkAnswersToMetricResultFieldPolicy,
	},
	LinkMetricsToAnswerResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LinkMetricsToAnswerResultKeySpecifier | (() => undefined | LinkMetricsToAnswerResultKeySpecifier),
		fields?: LinkMetricsToAnswerResultFieldPolicy,
	},
	Metadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetadataKeySpecifier | (() => undefined | MetadataKeySpecifier),
		fields?: MetadataFieldPolicy,
	},
	MethodType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MethodTypeKeySpecifier | (() => undefined | MethodTypeKeySpecifier),
		fields?: MethodTypeFieldPolicy,
	},
	Metric?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetricKeySpecifier | (() => undefined | MetricKeySpecifier),
		fields?: MetricFieldPolicy,
	},
	MetricConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetricConnectionKeySpecifier | (() => undefined | MetricConnectionKeySpecifier),
		fields?: MetricConnectionFieldPolicy,
	},
	MetricData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetricDataKeySpecifier | (() => undefined | MetricDataKeySpecifier),
		fields?: MetricDataFieldPolicy,
	},
	MetricDataColumnSelector?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetricDataColumnSelectorKeySpecifier | (() => undefined | MetricDataColumnSelectorKeySpecifier),
		fields?: MetricDataColumnSelectorFieldPolicy,
	},
	MetricDataSelector?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetricDataSelectorKeySpecifier | (() => undefined | MetricDataSelectorKeySpecifier),
		fields?: MetricDataSelectorFieldPolicy,
	},
	MetricDataYear?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetricDataYearKeySpecifier | (() => undefined | MetricDataYearKeySpecifier),
		fields?: MetricDataYearFieldPolicy,
	},
	MetricEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetricEdgeKeySpecifier | (() => undefined | MetricEdgeKeySpecifier),
		fields?: MetricEdgeFieldPolicy,
	},
	MetricLinkedQuestion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetricLinkedQuestionKeySpecifier | (() => undefined | MetricLinkedQuestionKeySpecifier),
		fields?: MetricLinkedQuestionFieldPolicy,
	},
	Mfa?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MfaKeySpecifier | (() => undefined | MfaKeySpecifier),
		fields?: MfaFieldPolicy,
	},
	ModuleSetting?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ModuleSettingKeySpecifier | (() => undefined | ModuleSettingKeySpecifier),
		fields?: ModuleSettingFieldPolicy,
	},
	ModuleSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ModuleSettingsKeySpecifier | (() => undefined | ModuleSettingsKeySpecifier),
		fields?: ModuleSettingsFieldPolicy,
	},
	Mutation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationKeySpecifier | (() => undefined | MutationKeySpecifier),
		fields?: MutationFieldPolicy,
	},
	NewEsgQuestionnaireFilters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NewEsgQuestionnaireFiltersKeySpecifier | (() => undefined | NewEsgQuestionnaireFiltersKeySpecifier),
		fields?: NewEsgQuestionnaireFiltersFieldPolicy,
	},
	NewTasksDashboardFilters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NewTasksDashboardFiltersKeySpecifier | (() => undefined | NewTasksDashboardFiltersKeySpecifier),
		fields?: NewTasksDashboardFiltersFieldPolicy,
	},
	NewTasksDashboardFiltersWithTopics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NewTasksDashboardFiltersWithTopicsKeySpecifier | (() => undefined | NewTasksDashboardFiltersWithTopicsKeySpecifier),
		fields?: NewTasksDashboardFiltersWithTopicsFieldPolicy,
	},
	NicoleGptSession?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NicoleGptSessionKeySpecifier | (() => undefined | NicoleGptSessionKeySpecifier),
		fields?: NicoleGptSessionFieldPolicy,
	},
	NicoleGptSessionConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NicoleGptSessionConnectionKeySpecifier | (() => undefined | NicoleGptSessionConnectionKeySpecifier),
		fields?: NicoleGptSessionConnectionFieldPolicy,
	},
	NicoleGptSessionEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NicoleGptSessionEdgeKeySpecifier | (() => undefined | NicoleGptSessionEdgeKeySpecifier),
		fields?: NicoleGptSessionEdgeFieldPolicy,
	},
	NicoleGptSessionEntry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NicoleGptSessionEntryKeySpecifier | (() => undefined | NicoleGptSessionEntryKeySpecifier),
		fields?: NicoleGptSessionEntryFieldPolicy,
	},
	NicoleGptSessionEntryConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NicoleGptSessionEntryConnectionKeySpecifier | (() => undefined | NicoleGptSessionEntryConnectionKeySpecifier),
		fields?: NicoleGptSessionEntryConnectionFieldPolicy,
	},
	NicoleGptSessionEntryEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NicoleGptSessionEntryEdgeKeySpecifier | (() => undefined | NicoleGptSessionEntryEdgeKeySpecifier),
		fields?: NicoleGptSessionEntryEdgeFieldPolicy,
	},
	Notification?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationKeySpecifier | (() => undefined | NotificationKeySpecifier),
		fields?: NotificationFieldPolicy,
	},
	NotificationContents?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationContentsKeySpecifier | (() => undefined | NotificationContentsKeySpecifier),
		fields?: NotificationContentsFieldPolicy,
	},
	NotificationData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationDataKeySpecifier | (() => undefined | NotificationDataKeySpecifier),
		fields?: NotificationDataFieldPolicy,
	},
	NotificationEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationEdgeKeySpecifier | (() => undefined | NotificationEdgeKeySpecifier),
		fields?: NotificationEdgeFieldPolicy,
	},
	NotificationPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationPageKeySpecifier | (() => undefined | NotificationPageKeySpecifier),
		fields?: NotificationPageFieldPolicy,
	},
	NotificationPaginated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationPaginatedKeySpecifier | (() => undefined | NotificationPaginatedKeySpecifier),
		fields?: NotificationPaginatedFieldPolicy,
	},
	NotificationPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationPayloadKeySpecifier | (() => undefined | NotificationPayloadKeySpecifier),
		fields?: NotificationPayloadFieldPolicy,
	},
	OAuthClient?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OAuthClientKeySpecifier | (() => undefined | OAuthClientKeySpecifier),
		fields?: OAuthClientFieldPolicy,
	},
	OAuthClientConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OAuthClientConnectionKeySpecifier | (() => undefined | OAuthClientConnectionKeySpecifier),
		fields?: OAuthClientConnectionFieldPolicy,
	},
	OAuthClientEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OAuthClientEdgeKeySpecifier | (() => undefined | OAuthClientEdgeKeySpecifier),
		fields?: OAuthClientEdgeFieldPolicy,
	},
	OriginalReport?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OriginalReportKeySpecifier | (() => undefined | OriginalReportKeySpecifier),
		fields?: OriginalReportFieldPolicy,
	},
	PageInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageInfoKeySpecifier | (() => undefined | PageInfoKeySpecifier),
		fields?: PageInfoFieldPolicy,
	},
	PageInfoV2?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageInfoV2KeySpecifier | (() => undefined | PageInfoV2KeySpecifier),
		fields?: PageInfoV2FieldPolicy,
	},
	PresignedCaseFile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PresignedCaseFileKeySpecifier | (() => undefined | PresignedCaseFileKeySpecifier),
		fields?: PresignedCaseFileFieldPolicy,
	},
	PrimaryContact?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PrimaryContactKeySpecifier | (() => undefined | PrimaryContactKeySpecifier),
		fields?: PrimaryContactFieldPolicy,
	},
	Program?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProgramKeySpecifier | (() => undefined | ProgramKeySpecifier),
		fields?: ProgramFieldPolicy,
	},
	ProgramCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProgramCategoryKeySpecifier | (() => undefined | ProgramCategoryKeySpecifier),
		fields?: ProgramCategoryFieldPolicy,
	},
	ProgramSettingCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProgramSettingCategoryKeySpecifier | (() => undefined | ProgramSettingCategoryKeySpecifier),
		fields?: ProgramSettingCategoryFieldPolicy,
	},
	Query?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier),
		fields?: QueryFieldPolicy,
	},
	QuestionActivity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionActivityKeySpecifier | (() => undefined | QuestionActivityKeySpecifier),
		fields?: QuestionActivityFieldPolicy,
	},
	QuestionActivityConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionActivityConnectionKeySpecifier | (() => undefined | QuestionActivityConnectionKeySpecifier),
		fields?: QuestionActivityConnectionFieldPolicy,
	},
	QuestionActivityEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionActivityEdgeKeySpecifier | (() => undefined | QuestionActivityEdgeKeySpecifier),
		fields?: QuestionActivityEdgeFieldPolicy,
	},
	QuestionSearchLinkedCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionSearchLinkedCountKeySpecifier | (() => undefined | QuestionSearchLinkedCountKeySpecifier),
		fields?: QuestionSearchLinkedCountFieldPolicy,
	},
	QuestionSearchRiskArea?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionSearchRiskAreaKeySpecifier | (() => undefined | QuestionSearchRiskAreaKeySpecifier),
		fields?: QuestionSearchRiskAreaFieldPolicy,
	},
	QuestionSearchStep?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionSearchStepKeySpecifier | (() => undefined | QuestionSearchStepKeySpecifier),
		fields?: QuestionSearchStepFieldPolicy,
	},
	QuestionnaireEntry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionnaireEntryKeySpecifier | (() => undefined | QuestionnaireEntryKeySpecifier),
		fields?: QuestionnaireEntryFieldPolicy,
	},
	QuestionnaireEntryConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionnaireEntryConnectionKeySpecifier | (() => undefined | QuestionnaireEntryConnectionKeySpecifier),
		fields?: QuestionnaireEntryConnectionFieldPolicy,
	},
	QuestionnaireEntryEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionnaireEntryEdgeKeySpecifier | (() => undefined | QuestionnaireEntryEdgeKeySpecifier),
		fields?: QuestionnaireEntryEdgeFieldPolicy,
	},
	QuestionnaireFilter?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionnaireFilterKeySpecifier | (() => undefined | QuestionnaireFilterKeySpecifier),
		fields?: QuestionnaireFilterFieldPolicy,
	},
	QuestionnaireNavigation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionnaireNavigationKeySpecifier | (() => undefined | QuestionnaireNavigationKeySpecifier),
		fields?: QuestionnaireNavigationFieldPolicy,
	},
	QuestionnaireNavigationCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionnaireNavigationCategoryKeySpecifier | (() => undefined | QuestionnaireNavigationCategoryKeySpecifier),
		fields?: QuestionnaireNavigationCategoryFieldPolicy,
	},
	QuestionnaireNavigationRiskArea?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionnaireNavigationRiskAreaKeySpecifier | (() => undefined | QuestionnaireNavigationRiskAreaKeySpecifier),
		fields?: QuestionnaireNavigationRiskAreaFieldPolicy,
	},
	QuestionnaireNavigationStandard?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionnaireNavigationStandardKeySpecifier | (() => undefined | QuestionnaireNavigationStandardKeySpecifier),
		fields?: QuestionnaireNavigationStandardFieldPolicy,
	},
	QuestionnaireNavigationStatistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionnaireNavigationStatisticsKeySpecifier | (() => undefined | QuestionnaireNavigationStatisticsKeySpecifier),
		fields?: QuestionnaireNavigationStatisticsFieldPolicy,
	},
	QuestionnaireNavigationStep?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuestionnaireNavigationStepKeySpecifier | (() => undefined | QuestionnaireNavigationStepKeySpecifier),
		fields?: QuestionnaireNavigationStepFieldPolicy,
	},
	ReadNotification?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReadNotificationKeySpecifier | (() => undefined | ReadNotificationKeySpecifier),
		fields?: ReadNotificationFieldPolicy,
	},
	Region?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegionKeySpecifier | (() => undefined | RegionKeySpecifier),
		fields?: RegionFieldPolicy,
	},
	RegionConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegionConnectionKeySpecifier | (() => undefined | RegionConnectionKeySpecifier),
		fields?: RegionConnectionFieldPolicy,
	},
	RegionEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegionEdgeKeySpecifier | (() => undefined | RegionEdgeKeySpecifier),
		fields?: RegionEdgeFieldPolicy,
	},
	RegularRolePermission?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegularRolePermissionKeySpecifier | (() => undefined | RegularRolePermissionKeySpecifier),
		fields?: RegularRolePermissionFieldPolicy,
	},
	ReleaseNote?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReleaseNoteKeySpecifier | (() => undefined | ReleaseNoteKeySpecifier),
		fields?: ReleaseNoteFieldPolicy,
	},
	ReportAudience?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportAudienceKeySpecifier | (() => undefined | ReportAudienceKeySpecifier),
		fields?: ReportAudienceFieldPolicy,
	},
	ReportCaseFile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportCaseFileKeySpecifier | (() => undefined | ReportCaseFileKeySpecifier),
		fields?: ReportCaseFileFieldPolicy,
	},
	ReportPromptTemplate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportPromptTemplateKeySpecifier | (() => undefined | ReportPromptTemplateKeySpecifier),
		fields?: ReportPromptTemplateFieldPolicy,
	},
	ReportPromptTemplateConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportPromptTemplateConnectionKeySpecifier | (() => undefined | ReportPromptTemplateConnectionKeySpecifier),
		fields?: ReportPromptTemplateConnectionFieldPolicy,
	},
	ReportPromptTemplateEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportPromptTemplateEdgeKeySpecifier | (() => undefined | ReportPromptTemplateEdgeKeySpecifier),
		fields?: ReportPromptTemplateEdgeFieldPolicy,
	},
	ReportResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportResponseKeySpecifier | (() => undefined | ReportResponseKeySpecifier),
		fields?: ReportResponseFieldPolicy,
	},
	ReportSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportSettingsKeySpecifier | (() => undefined | ReportSettingsKeySpecifier),
		fields?: ReportSettingsFieldPolicy,
	},
	ReportingGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportingGroupKeySpecifier | (() => undefined | ReportingGroupKeySpecifier),
		fields?: ReportingGroupFieldPolicy,
	},
	ReportingGroupConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportingGroupConnectionKeySpecifier | (() => undefined | ReportingGroupConnectionKeySpecifier),
		fields?: ReportingGroupConnectionFieldPolicy,
	},
	ReportingGroupEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportingGroupEdgeKeySpecifier | (() => undefined | ReportingGroupEdgeKeySpecifier),
		fields?: ReportingGroupEdgeFieldPolicy,
	},
	ReportingSource?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportingSourceKeySpecifier | (() => undefined | ReportingSourceKeySpecifier),
		fields?: ReportingSourceFieldPolicy,
	},
	ReportingSourceConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportingSourceConnectionKeySpecifier | (() => undefined | ReportingSourceConnectionKeySpecifier),
		fields?: ReportingSourceConnectionFieldPolicy,
	},
	ReportingSourceEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportingSourceEdgeKeySpecifier | (() => undefined | ReportingSourceEdgeKeySpecifier),
		fields?: ReportingSourceEdgeFieldPolicy,
	},
	RespondQuestionnaire?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RespondQuestionnaireKeySpecifier | (() => undefined | RespondQuestionnaireKeySpecifier),
		fields?: RespondQuestionnaireFieldPolicy,
	},
	RespondQuestionnaireConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RespondQuestionnaireConnectionKeySpecifier | (() => undefined | RespondQuestionnaireConnectionKeySpecifier),
		fields?: RespondQuestionnaireConnectionFieldPolicy,
	},
	RespondQuestionnaireEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RespondQuestionnaireEdgeKeySpecifier | (() => undefined | RespondQuestionnaireEdgeKeySpecifier),
		fields?: RespondQuestionnaireEdgeFieldPolicy,
	},
	RespondQuestionnaireEntry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RespondQuestionnaireEntryKeySpecifier | (() => undefined | RespondQuestionnaireEntryKeySpecifier),
		fields?: RespondQuestionnaireEntryFieldPolicy,
	},
	RespondQuestionnaireEntryConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RespondQuestionnaireEntryConnectionKeySpecifier | (() => undefined | RespondQuestionnaireEntryConnectionKeySpecifier),
		fields?: RespondQuestionnaireEntryConnectionFieldPolicy,
	},
	RespondQuestionnaireEntryEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RespondQuestionnaireEntryEdgeKeySpecifier | (() => undefined | RespondQuestionnaireEntryEdgeKeySpecifier),
		fields?: RespondQuestionnaireEntryEdgeFieldPolicy,
	},
	RespondQuestionnaireV2?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RespondQuestionnaireV2KeySpecifier | (() => undefined | RespondQuestionnaireV2KeySpecifier),
		fields?: RespondQuestionnaireV2FieldPolicy,
	},
	RespondQuestionnaireV2Connection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RespondQuestionnaireV2ConnectionKeySpecifier | (() => undefined | RespondQuestionnaireV2ConnectionKeySpecifier),
		fields?: RespondQuestionnaireV2ConnectionFieldPolicy,
	},
	RespondQuestionnaireV2Edge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RespondQuestionnaireV2EdgeKeySpecifier | (() => undefined | RespondQuestionnaireV2EdgeKeySpecifier),
		fields?: RespondQuestionnaireV2EdgeFieldPolicy,
	},
	RiskArea?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RiskAreaKeySpecifier | (() => undefined | RiskAreaKeySpecifier),
		fields?: RiskAreaFieldPolicy,
	},
	RiskAreasWithAnyQuestionsElement?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RiskAreasWithAnyQuestionsElementKeySpecifier | (() => undefined | RiskAreasWithAnyQuestionsElementKeySpecifier),
		fields?: RiskAreasWithAnyQuestionsElementFieldPolicy,
	},
	Role?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RoleKeySpecifier | (() => undefined | RoleKeySpecifier),
		fields?: RoleFieldPolicy,
	},
	RoleConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RoleConnectionKeySpecifier | (() => undefined | RoleConnectionKeySpecifier),
		fields?: RoleConnectionFieldPolicy,
	},
	RoleEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RoleEdgeKeySpecifier | (() => undefined | RoleEdgeKeySpecifier),
		fields?: RoleEdgeFieldPolicy,
	},
	RoleRiskArea?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RoleRiskAreaKeySpecifier | (() => undefined | RoleRiskAreaKeySpecifier),
		fields?: RoleRiskAreaFieldPolicy,
	},
	ScopeFilter?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ScopeFilterKeySpecifier | (() => undefined | ScopeFilterKeySpecifier),
		fields?: ScopeFilterFieldPolicy,
	},
	Sector?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SectorKeySpecifier | (() => undefined | SectorKeySpecifier),
		fields?: SectorFieldPolicy,
	},
	SectorConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SectorConnectionKeySpecifier | (() => undefined | SectorConnectionKeySpecifier),
		fields?: SectorConnectionFieldPolicy,
	},
	SectorEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SectorEdgeKeySpecifier | (() => undefined | SectorEdgeKeySpecifier),
		fields?: SectorEdgeFieldPolicy,
	},
	Session?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SessionKeySpecifier | (() => undefined | SessionKeySpecifier),
		fields?: SessionFieldPolicy,
	},
	SessionPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SessionPayloadKeySpecifier | (() => undefined | SessionPayloadKeySpecifier),
		fields?: SessionPayloadFieldPolicy,
	},
	SessionWithOaExchange?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SessionWithOaExchangeKeySpecifier | (() => undefined | SessionWithOaExchangeKeySpecifier),
		fields?: SessionWithOaExchangeFieldPolicy,
	},
	SmartFillDraftAnswer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SmartFillDraftAnswerKeySpecifier | (() => undefined | SmartFillDraftAnswerKeySpecifier),
		fields?: SmartFillDraftAnswerFieldPolicy,
	},
	SmartFillJob?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SmartFillJobKeySpecifier | (() => undefined | SmartFillJobKeySpecifier),
		fields?: SmartFillJobFieldPolicy,
	},
	SmartFillSource?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SmartFillSourceKeySpecifier | (() => undefined | SmartFillSourceKeySpecifier),
		fields?: SmartFillSourceFieldPolicy,
	},
	SsoAccount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SsoAccountKeySpecifier | (() => undefined | SsoAccountKeySpecifier),
		fields?: SsoAccountFieldPolicy,
	},
	SsoAuthPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SsoAuthPayloadKeySpecifier | (() => undefined | SsoAuthPayloadKeySpecifier),
		fields?: SsoAuthPayloadFieldPolicy,
	},
	SsoAzureTenantInformation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SsoAzureTenantInformationKeySpecifier | (() => undefined | SsoAzureTenantInformationKeySpecifier),
		fields?: SsoAzureTenantInformationFieldPolicy,
	},
	SsoProvider?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SsoProviderKeySpecifier | (() => undefined | SsoProviderKeySpecifier),
		fields?: SsoProviderFieldPolicy,
	},
	SsoSamlTenantInformation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SsoSamlTenantInformationKeySpecifier | (() => undefined | SsoSamlTenantInformationKeySpecifier),
		fields?: SsoSamlTenantInformationFieldPolicy,
	},
	SsoTenantInformation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SsoTenantInformationKeySpecifier | (() => undefined | SsoTenantInformationKeySpecifier),
		fields?: SsoTenantInformationFieldPolicy,
	},
	StakeholderEngagementCommonData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StakeholderEngagementCommonDataKeySpecifier | (() => undefined | StakeholderEngagementCommonDataKeySpecifier),
		fields?: StakeholderEngagementCommonDataFieldPolicy,
	},
	StakeholderEngagementConnectionConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StakeholderEngagementConnectionConnectionKeySpecifier | (() => undefined | StakeholderEngagementConnectionConnectionKeySpecifier),
		fields?: StakeholderEngagementConnectionConnectionFieldPolicy,
	},
	StakeholderEngagementConnectionEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StakeholderEngagementConnectionEdgeKeySpecifier | (() => undefined | StakeholderEngagementConnectionEdgeKeySpecifier),
		fields?: StakeholderEngagementConnectionEdgeFieldPolicy,
	},
	StandardAssignedRiskAreaEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StandardAssignedRiskAreaEdgeKeySpecifier | (() => undefined | StandardAssignedRiskAreaEdgeKeySpecifier),
		fields?: StandardAssignedRiskAreaEdgeFieldPolicy,
	},
	StandardAssignedRiskAreasConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StandardAssignedRiskAreasConnectionKeySpecifier | (() => undefined | StandardAssignedRiskAreasConnectionKeySpecifier),
		fields?: StandardAssignedRiskAreasConnectionFieldPolicy,
	},
	StandardItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StandardItemKeySpecifier | (() => undefined | StandardItemKeySpecifier),
		fields?: StandardItemFieldPolicy,
	},
	SubscriptionPlan?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubscriptionPlanKeySpecifier | (() => undefined | SubscriptionPlanKeySpecifier),
		fields?: SubscriptionPlanFieldPolicy,
	},
	SubsidiarySite?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubsidiarySiteKeySpecifier | (() => undefined | SubsidiarySiteKeySpecifier),
		fields?: SubsidiarySiteFieldPolicy,
	},
	SubsidiarySiteEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubsidiarySiteEdgeKeySpecifier | (() => undefined | SubsidiarySiteEdgeKeySpecifier),
		fields?: SubsidiarySiteEdgeFieldPolicy,
	},
	SubsidiarySiteReportingSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubsidiarySiteReportingSettingsKeySpecifier | (() => undefined | SubsidiarySiteReportingSettingsKeySpecifier),
		fields?: SubsidiarySiteReportingSettingsFieldPolicy,
	},
	SubsidiarySitesConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubsidiarySitesConnectionKeySpecifier | (() => undefined | SubsidiarySitesConnectionKeySpecifier),
		fields?: SubsidiarySitesConnectionFieldPolicy,
	},
	SupportedMobileAppVersions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SupportedMobileAppVersionsKeySpecifier | (() => undefined | SupportedMobileAppVersionsKeySpecifier),
		fields?: SupportedMobileAppVersionsFieldPolicy,
	},
	Survey?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyKeySpecifier | (() => undefined | SurveyKeySpecifier),
		fields?: SurveyFieldPolicy,
	},
	SurveyConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyConnectionKeySpecifier | (() => undefined | SurveyConnectionKeySpecifier),
		fields?: SurveyConnectionFieldPolicy,
	},
	SurveyEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyEdgeKeySpecifier | (() => undefined | SurveyEdgeKeySpecifier),
		fields?: SurveyEdgeFieldPolicy,
	},
	SurveyEmailTarget?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyEmailTargetKeySpecifier | (() => undefined | SurveyEmailTargetKeySpecifier),
		fields?: SurveyEmailTargetFieldPolicy,
	},
	SurveyPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyPageKeySpecifier | (() => undefined | SurveyPageKeySpecifier),
		fields?: SurveyPageFieldPolicy,
	},
	SurveyPaginated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyPaginatedKeySpecifier | (() => undefined | SurveyPaginatedKeySpecifier),
		fields?: SurveyPaginatedFieldPolicy,
	},
	SurveyReportUploadResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyReportUploadResponseKeySpecifier | (() => undefined | SurveyReportUploadResponseKeySpecifier),
		fields?: SurveyReportUploadResponseFieldPolicy,
	},
	SurveyResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyResponseKeySpecifier | (() => undefined | SurveyResponseKeySpecifier),
		fields?: SurveyResponseFieldPolicy,
	},
	SurveyResponseEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyResponseEdgeKeySpecifier | (() => undefined | SurveyResponseEdgeKeySpecifier),
		fields?: SurveyResponseEdgeFieldPolicy,
	},
	SurveyResponsePage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyResponsePageKeySpecifier | (() => undefined | SurveyResponsePageKeySpecifier),
		fields?: SurveyResponsePageFieldPolicy,
	},
	SurveyResponsePaginated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyResponsePaginatedKeySpecifier | (() => undefined | SurveyResponsePaginatedKeySpecifier),
		fields?: SurveyResponsePaginatedFieldPolicy,
	},
	SurveyStatistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyStatisticsKeySpecifier | (() => undefined | SurveyStatisticsKeySpecifier),
		fields?: SurveyStatisticsFieldPolicy,
	},
	SurveySummary?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveySummaryKeySpecifier | (() => undefined | SurveySummaryKeySpecifier),
		fields?: SurveySummaryFieldPolicy,
	},
	SurveyTemplate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyTemplateKeySpecifier | (() => undefined | SurveyTemplateKeySpecifier),
		fields?: SurveyTemplateFieldPolicy,
	},
	SurveyTemplateEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyTemplateEdgeKeySpecifier | (() => undefined | SurveyTemplateEdgeKeySpecifier),
		fields?: SurveyTemplateEdgeFieldPolicy,
	},
	SurveyTemplatePage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyTemplatePageKeySpecifier | (() => undefined | SurveyTemplatePageKeySpecifier),
		fields?: SurveyTemplatePageFieldPolicy,
	},
	SurveyTemplatePaginated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyTemplatePaginatedKeySpecifier | (() => undefined | SurveyTemplatePaginatedKeySpecifier),
		fields?: SurveyTemplatePaginatedFieldPolicy,
	},
	SurveyTemplateType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SurveyTemplateTypeKeySpecifier | (() => undefined | SurveyTemplateTypeKeySpecifier),
		fields?: SurveyTemplateTypeFieldPolicy,
	},
	Symbol?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SymbolKeySpecifier | (() => undefined | SymbolKeySpecifier),
		fields?: SymbolFieldPolicy,
	},
	SymbolConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SymbolConnectionKeySpecifier | (() => undefined | SymbolConnectionKeySpecifier),
		fields?: SymbolConnectionFieldPolicy,
	},
	SymbolEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SymbolEdgeKeySpecifier | (() => undefined | SymbolEdgeKeySpecifier),
		fields?: SymbolEdgeFieldPolicy,
	},
	Tag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TagKeySpecifier | (() => undefined | TagKeySpecifier),
		fields?: TagFieldPolicy,
	},
	TagConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TagConnectionKeySpecifier | (() => undefined | TagConnectionKeySpecifier),
		fields?: TagConnectionFieldPolicy,
	},
	TagEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TagEdgeKeySpecifier | (() => undefined | TagEdgeKeySpecifier),
		fields?: TagEdgeFieldPolicy,
	},
	TagsSelectConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TagsSelectConnectionKeySpecifier | (() => undefined | TagsSelectConnectionKeySpecifier),
		fields?: TagsSelectConnectionFieldPolicy,
	},
	Target?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TargetKeySpecifier | (() => undefined | TargetKeySpecifier),
		fields?: TargetFieldPolicy,
	},
	TargetConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TargetConnectionKeySpecifier | (() => undefined | TargetConnectionKeySpecifier),
		fields?: TargetConnectionFieldPolicy,
	},
	TargetData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TargetDataKeySpecifier | (() => undefined | TargetDataKeySpecifier),
		fields?: TargetDataFieldPolicy,
	},
	TargetEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TargetEdgeKeySpecifier | (() => undefined | TargetEdgeKeySpecifier),
		fields?: TargetEdgeFieldPolicy,
	},
	TargetGoals?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TargetGoalsKeySpecifier | (() => undefined | TargetGoalsKeySpecifier),
		fields?: TargetGoalsFieldPolicy,
	},
	TargetRiskArea?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TargetRiskAreaKeySpecifier | (() => undefined | TargetRiskAreaKeySpecifier),
		fields?: TargetRiskAreaFieldPolicy,
	},
	Task?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskKeySpecifier | (() => undefined | TaskKeySpecifier),
		fields?: TaskFieldPolicy,
	},
	TaskComment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskCommentKeySpecifier | (() => undefined | TaskCommentKeySpecifier),
		fields?: TaskCommentFieldPolicy,
	},
	TaskConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskConnectionKeySpecifier | (() => undefined | TaskConnectionKeySpecifier),
		fields?: TaskConnectionFieldPolicy,
	},
	TaskEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskEdgeKeySpecifier | (() => undefined | TaskEdgeKeySpecifier),
		fields?: TaskEdgeFieldPolicy,
	},
	TaskMetadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskMetadataKeySpecifier | (() => undefined | TaskMetadataKeySpecifier),
		fields?: TaskMetadataFieldPolicy,
	},
	TaskNameHint?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskNameHintKeySpecifier | (() => undefined | TaskNameHintKeySpecifier),
		fields?: TaskNameHintFieldPolicy,
	},
	TaskNameHintConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskNameHintConnectionKeySpecifier | (() => undefined | TaskNameHintConnectionKeySpecifier),
		fields?: TaskNameHintConnectionFieldPolicy,
	},
	TaskNameHintEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskNameHintEdgeKeySpecifier | (() => undefined | TaskNameHintEdgeKeySpecifier),
		fields?: TaskNameHintEdgeFieldPolicy,
	},
	TaskStatistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskStatisticsKeySpecifier | (() => undefined | TaskStatisticsKeySpecifier),
		fields?: TaskStatisticsFieldPolicy,
	},
	TasksDashboardFilters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TasksDashboardFiltersKeySpecifier | (() => undefined | TasksDashboardFiltersKeySpecifier),
		fields?: TasksDashboardFiltersFieldPolicy,
	},
	TasksDashboardSort?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TasksDashboardSortKeySpecifier | (() => undefined | TasksDashboardSortKeySpecifier),
		fields?: TasksDashboardSortFieldPolicy,
	},
	TasksUserTypeEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TasksUserTypeEdgeKeySpecifier | (() => undefined | TasksUserTypeEdgeKeySpecifier),
		fields?: TasksUserTypeEdgeFieldPolicy,
	},
	Taxonomy?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyKeySpecifier | (() => undefined | TaxonomyKeySpecifier),
		fields?: TaxonomyFieldPolicy,
	},
	TaxonomyComplexUnit?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyComplexUnitKeySpecifier | (() => undefined | TaxonomyComplexUnitKeySpecifier),
		fields?: TaxonomyComplexUnitFieldPolicy,
	},
	TaxonomyConcept?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyConceptKeySpecifier | (() => undefined | TaxonomyConceptKeySpecifier),
		fields?: TaxonomyConceptFieldPolicy,
	},
	TaxonomyConceptConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyConceptConnectionKeySpecifier | (() => undefined | TaxonomyConceptConnectionKeySpecifier),
		fields?: TaxonomyConceptConnectionFieldPolicy,
	},
	TaxonomyConceptEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyConceptEdgeKeySpecifier | (() => undefined | TaxonomyConceptEdgeKeySpecifier),
		fields?: TaxonomyConceptEdgeFieldPolicy,
	},
	TaxonomyConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyConnectionKeySpecifier | (() => undefined | TaxonomyConnectionKeySpecifier),
		fields?: TaxonomyConnectionFieldPolicy,
	},
	TaxonomyDimensionSet?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyDimensionSetKeySpecifier | (() => undefined | TaxonomyDimensionSetKeySpecifier),
		fields?: TaxonomyDimensionSetFieldPolicy,
	},
	TaxonomyDomain?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyDomainKeySpecifier | (() => undefined | TaxonomyDomainKeySpecifier),
		fields?: TaxonomyDomainFieldPolicy,
	},
	TaxonomyEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyEdgeKeySpecifier | (() => undefined | TaxonomyEdgeKeySpecifier),
		fields?: TaxonomyEdgeFieldPolicy,
	},
	TaxonomyEnumeration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyEnumerationKeySpecifier | (() => undefined | TaxonomyEnumerationKeySpecifier),
		fields?: TaxonomyEnumerationFieldPolicy,
	},
	TaxonomyEnumerationValue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyEnumerationValueKeySpecifier | (() => undefined | TaxonomyEnumerationValueKeySpecifier),
		fields?: TaxonomyEnumerationValueFieldPolicy,
	},
	TaxonomyExplicitDimension?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyExplicitDimensionKeySpecifier | (() => undefined | TaxonomyExplicitDimensionKeySpecifier),
		fields?: TaxonomyExplicitDimensionFieldPolicy,
	},
	TaxonomyFormat?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyFormatKeySpecifier | (() => undefined | TaxonomyFormatKeySpecifier),
		fields?: TaxonomyFormatFieldPolicy,
	},
	TaxonomyMember?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyMemberKeySpecifier | (() => undefined | TaxonomyMemberKeySpecifier),
		fields?: TaxonomyMemberFieldPolicy,
	},
	TaxonomyReport?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyReportKeySpecifier | (() => undefined | TaxonomyReportKeySpecifier),
		fields?: TaxonomyReportFieldPolicy,
	},
	TaxonomyReportAudit?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyReportAuditKeySpecifier | (() => undefined | TaxonomyReportAuditKeySpecifier),
		fields?: TaxonomyReportAuditFieldPolicy,
	},
	TaxonomyReportAuditConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyReportAuditConnectionKeySpecifier | (() => undefined | TaxonomyReportAuditConnectionKeySpecifier),
		fields?: TaxonomyReportAuditConnectionFieldPolicy,
	},
	TaxonomyReportAuditEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyReportAuditEdgeKeySpecifier | (() => undefined | TaxonomyReportAuditEdgeKeySpecifier),
		fields?: TaxonomyReportAuditEdgeFieldPolicy,
	},
	TaxonomyReportConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyReportConnectionKeySpecifier | (() => undefined | TaxonomyReportConnectionKeySpecifier),
		fields?: TaxonomyReportConnectionFieldPolicy,
	},
	TaxonomyReportEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyReportEdgeKeySpecifier | (() => undefined | TaxonomyReportEdgeKeySpecifier),
		fields?: TaxonomyReportEdgeFieldPolicy,
	},
	TaxonomyReportFact?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyReportFactKeySpecifier | (() => undefined | TaxonomyReportFactKeySpecifier),
		fields?: TaxonomyReportFactFieldPolicy,
	},
	TaxonomyReportFactConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyReportFactConnectionKeySpecifier | (() => undefined | TaxonomyReportFactConnectionKeySpecifier),
		fields?: TaxonomyReportFactConnectionFieldPolicy,
	},
	TaxonomyReportFactEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyReportFactEdgeKeySpecifier | (() => undefined | TaxonomyReportFactEdgeKeySpecifier),
		fields?: TaxonomyReportFactEdgeFieldPolicy,
	},
	TaxonomyReportFactLine?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyReportFactLineKeySpecifier | (() => undefined | TaxonomyReportFactLineKeySpecifier),
		fields?: TaxonomyReportFactLineFieldPolicy,
	},
	TaxonomyReportFactPeriodDuration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyReportFactPeriodDurationKeySpecifier | (() => undefined | TaxonomyReportFactPeriodDurationKeySpecifier),
		fields?: TaxonomyReportFactPeriodDurationFieldPolicy,
	},
	TaxonomyReportFactScenario?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyReportFactScenarioKeySpecifier | (() => undefined | TaxonomyReportFactScenarioKeySpecifier),
		fields?: TaxonomyReportFactScenarioFieldPolicy,
	},
	TaxonomyReportPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyReportPageKeySpecifier | (() => undefined | TaxonomyReportPageKeySpecifier),
		fields?: TaxonomyReportPageFieldPolicy,
	},
	TaxonomyReportStatistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyReportStatisticsKeySpecifier | (() => undefined | TaxonomyReportStatisticsKeySpecifier),
		fields?: TaxonomyReportStatisticsFieldPolicy,
	},
	TaxonomySimpleUnit?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomySimpleUnitKeySpecifier | (() => undefined | TaxonomySimpleUnitKeySpecifier),
		fields?: TaxonomySimpleUnitFieldPolicy,
	},
	TaxonomyTypedDimension?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxonomyTypedDimensionKeySpecifier | (() => undefined | TaxonomyTypedDimensionKeySpecifier),
		fields?: TaxonomyTypedDimensionFieldPolicy,
	},
	Template?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TemplateKeySpecifier | (() => undefined | TemplateKeySpecifier),
		fields?: TemplateFieldPolicy,
	},
	TemplateConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TemplateConnectionKeySpecifier | (() => undefined | TemplateConnectionKeySpecifier),
		fields?: TemplateConnectionFieldPolicy,
	},
	TemplateEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TemplateEdgeKeySpecifier | (() => undefined | TemplateEdgeKeySpecifier),
		fields?: TemplateEdgeFieldPolicy,
	},
	TemplateType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TemplateTypeKeySpecifier | (() => undefined | TemplateTypeKeySpecifier),
		fields?: TemplateTypeFieldPolicy,
	},
	TenantBaseDataType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantBaseDataTypeKeySpecifier | (() => undefined | TenantBaseDataTypeKeySpecifier),
		fields?: TenantBaseDataTypeFieldPolicy,
	},
	TenantModuleSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantModuleSettingsKeySpecifier | (() => undefined | TenantModuleSettingsKeySpecifier),
		fields?: TenantModuleSettingsFieldPolicy,
	},
	TenantReportingPeriod?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantReportingPeriodKeySpecifier | (() => undefined | TenantReportingPeriodKeySpecifier),
		fields?: TenantReportingPeriodFieldPolicy,
	},
	TenantRiskAreaSetting?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantRiskAreaSettingKeySpecifier | (() => undefined | TenantRiskAreaSettingKeySpecifier),
		fields?: TenantRiskAreaSettingFieldPolicy,
	},
	TenantRiskAreaSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantRiskAreaSettingsKeySpecifier | (() => undefined | TenantRiskAreaSettingsKeySpecifier),
		fields?: TenantRiskAreaSettingsFieldPolicy,
	},
	TenantSamlRequestDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantSamlRequestDetailsKeySpecifier | (() => undefined | TenantSamlRequestDetailsKeySpecifier),
		fields?: TenantSamlRequestDetailsFieldPolicy,
	},
	TenantSubscription?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantSubscriptionKeySpecifier | (() => undefined | TenantSubscriptionKeySpecifier),
		fields?: TenantSubscriptionFieldPolicy,
	},
	TenantYearDataState?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantYearDataStateKeySpecifier | (() => undefined | TenantYearDataStateKeySpecifier),
		fields?: TenantYearDataStateFieldPolicy,
	},
	TriageScoreSetting?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TriageScoreSettingKeySpecifier | (() => undefined | TriageScoreSettingKeySpecifier),
		fields?: TriageScoreSettingFieldPolicy,
	},
	Unit?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UnitKeySpecifier | (() => undefined | UnitKeySpecifier),
		fields?: UnitFieldPolicy,
	},
	UnitEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UnitEdgeKeySpecifier | (() => undefined | UnitEdgeKeySpecifier),
		fields?: UnitEdgeFieldPolicy,
	},
	UnlinkMetricFromAnswerResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UnlinkMetricFromAnswerResultKeySpecifier | (() => undefined | UnlinkMetricFromAnswerResultKeySpecifier),
		fields?: UnlinkMetricFromAnswerResultFieldPolicy,
	},
	UnlinkQuestionFromMetricResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UnlinkQuestionFromMetricResultKeySpecifier | (() => undefined | UnlinkQuestionFromMetricResultKeySpecifier),
		fields?: UnlinkQuestionFromMetricResultFieldPolicy,
	},
	UnmappedQuestionStandardStatistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UnmappedQuestionStandardStatisticsKeySpecifier | (() => undefined | UnmappedQuestionStandardStatisticsKeySpecifier),
		fields?: UnmappedQuestionStandardStatisticsFieldPolicy,
	},
	UnmappedQuestionStatistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UnmappedQuestionStatisticsKeySpecifier | (() => undefined | UnmappedQuestionStatisticsKeySpecifier),
		fields?: UnmappedQuestionStatisticsFieldPolicy,
	},
	UserConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserConnectionKeySpecifier | (() => undefined | UserConnectionKeySpecifier),
		fields?: UserConnectionFieldPolicy,
	},
	UserDisclosureStatistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserDisclosureStatisticsKeySpecifier | (() => undefined | UserDisclosureStatisticsKeySpecifier),
		fields?: UserDisclosureStatisticsFieldPolicy,
	},
	UserRole?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserRoleKeySpecifier | (() => undefined | UserRoleKeySpecifier),
		fields?: UserRoleFieldPolicy,
	},
	UserSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserSettingsKeySpecifier | (() => undefined | UserSettingsKeySpecifier),
		fields?: UserSettingsFieldPolicy,
	},
	UserStorage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserStorageKeySpecifier | (() => undefined | UserStorageKeySpecifier),
		fields?: UserStorageFieldPolicy,
	},
	UserType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserTypeKeySpecifier | (() => undefined | UserTypeKeySpecifier),
		fields?: UserTypeFieldPolicy,
	},
	UserTypeConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserTypeConnectionKeySpecifier | (() => undefined | UserTypeConnectionKeySpecifier),
		fields?: UserTypeConnectionFieldPolicy,
	},
	UserTypeEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserTypeEdgeKeySpecifier | (() => undefined | UserTypeEdgeKeySpecifier),
		fields?: UserTypeEdgeFieldPolicy,
	},
	V2CaseExclusionOwnerEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | V2CaseExclusionOwnerEdgeKeySpecifier | (() => undefined | V2CaseExclusionOwnerEdgeKeySpecifier),
		fields?: V2CaseExclusionOwnerEdgeFieldPolicy,
	},
	V2DisclosureEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | V2DisclosureEdgeKeySpecifier | (() => undefined | V2DisclosureEdgeKeySpecifier),
		fields?: V2DisclosureEdgeFieldPolicy,
	},
	V2DisclosureResponseEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | V2DisclosureResponseEdgeKeySpecifier | (() => undefined | V2DisclosureResponseEdgeKeySpecifier),
		fields?: V2DisclosureResponseEdgeFieldPolicy,
	},
	V2SurveyEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | V2SurveyEdgeKeySpecifier | (() => undefined | V2SurveyEdgeKeySpecifier),
		fields?: V2SurveyEdgeFieldPolicy,
	},
	Webflow?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WebflowKeySpecifier | (() => undefined | WebflowKeySpecifier),
		fields?: WebflowFieldPolicy,
	},
	WebflowPost?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WebflowPostKeySpecifier | (() => undefined | WebflowPostKeySpecifier),
		fields?: WebflowPostFieldPolicy,
	},
	WebflowPostConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WebflowPostConnectionKeySpecifier | (() => undefined | WebflowPostConnectionKeySpecifier),
		fields?: WebflowPostConnectionFieldPolicy,
	},
	WebflowPostEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WebflowPostEdgeKeySpecifier | (() => undefined | WebflowPostEdgeKeySpecifier),
		fields?: WebflowPostEdgeFieldPolicy,
	},
	WhistleblowerCaseReportPdfResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WhistleblowerCaseReportPdfResponseKeySpecifier | (() => undefined | WhistleblowerCaseReportPdfResponseKeySpecifier),
		fields?: WhistleblowerCaseReportPdfResponseFieldPolicy,
	},
	Year?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | YearKeySpecifier | (() => undefined | YearKeySpecifier),
		fields?: YearFieldPolicy,
	},
	YearConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | YearConnectionKeySpecifier | (() => undefined | YearConnectionKeySpecifier),
		fields?: YearConnectionFieldPolicy,
	},
	YearEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | YearEdgeKeySpecifier | (() => undefined | YearEdgeKeySpecifier),
		fields?: YearEdgeFieldPolicy,
	}
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;